import React from 'react';
import PropTypes$1, { PropTypes } from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { flipInX, bounceIn, rubberBand, shake, pulse, headShake } from 'react-animations';
import { Box } from '@rebass/grid';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

const rotateAnimation = keyframes`
  100% { transform: rotate(360deg) }
`;
keyframes`
  0% { transform: rotate(0deg) }
  25% { transform: rotate(180deg) }
  50% { transform: rotate(180deg) }
  75% { transform: rotate(360deg) }
  100% { transform: rotate(360deg) }
`;
keyframes`
  0% ,100% { transform: scale(0) }
  50% { transform: scale(1) }
`;
keyframes`
  from {
    transform: translateX(100vw);
  }
  to {
    transform: translateX(0vw);
  }
`;
keyframes`
  from {
    transform: scale(.85);
  }
  to {
    transform: scale(1);
  }
`;
keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(.95);
  }
`;
keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;
keyframes`${flipInX}`;
keyframes`${bounceIn}`;
keyframes`${rubberBand}`;
keyframes`${shake}`;
keyframes`${pulse}`;
keyframes`${headShake}`;

const IconSvgStyled = styled.span`
  display: inline-flex;
  align-self: center;
  font-size: ${_ref => {
  let {
    fontSize
  } = _ref;
  return `${fontSize}rem` || '1.25rem';
}};

  svg {
    height: 1em;
    width: 1em;
    position: relative;
    fill: ${_ref2 => {
  let {
    color
  } = _ref2;
  return color || 'currentcolor';
}};
    stroke: ${_ref3 => {
  let {
    color
  } = _ref3;
  return color || 'unset';
}};

    ${_ref4 => {
  let {
    rotate
  } = _ref4;
  return rotate && css`
        transform: rotate(${rotate}deg);
      `;
}};
    ${_ref5 => {
  let {
    isRotating
  } = _ref5;
  return isRotating && css`
        animation: ${rotateAnimation} 0.5s infinite linear;
      `;
}};
    ${_ref6 => {
  let {
    backgroundColor
  } = _ref6;
  return backgroundColor && css`
        overflow: visible;
        border: ${_ref7 => {
    let {
      fontSize
    } = _ref7;
    return fontSize ? `${fontSize * 0.2}rem` : '0.2rem';
  }} solid ${backgroundColor};
        border-color: ${backgroundColor};
        background-color: ${backgroundColor};
        border-radius: 100px;
        svg {
          top: 0;
        }
      `;
}};
  }
`;

// eslint-disable-next-line react/prop-types
const Icon = _ref8 => {
  let {
    children,
    backgroundColor,
    color,
    rotate,
    ...props
  } = _ref8;
  return /*#__PURE__*/React.createElement(IconSvgStyled, _extends({}, props, {
    backgroundColor: backgroundColor,
    color: color,
    rotate: rotate
  }), children);
};
Icon.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  rotate: PropTypes.number
};
Icon.defaultProps = {
  color: '',
  backgroundColor: '',
  rotate: 0
};
Icon.displayName = 'IconSvg';

var IconAdd = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
var IconAngleDown = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 4.21875 10.78125 L 2.78125 12.21875 L 15.28125 24.71875 L 16 25.40625 L 16.71875 24.71875 L 29.21875 12.21875 L 27.78125 10.78125 L 16 22.5625 Z"
})));

/* eslint-disable max-len */
var IconAngleLeft = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 19.03125 4.28125 L 8.03125 15.28125 L 7.34375 16 L 8.03125 16.71875 L 19.03125 27.71875 L 20.46875 26.28125 L 10.1875 16 L 20.46875 5.71875 Z"
})));

/* eslint-disable max-len */
var IconAngleRight = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 12.96875 4.28125 L 11.53125 5.71875 L 21.8125 16 L 11.53125 26.28125 L 12.96875 27.71875 L 23.96875 16.71875 L 24.65625 16 L 23.96875 15.28125 Z"
})));

/* eslint-disable max-len */
var IconApple = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.46,12.63a4.51,4.51,0,0,1,2.16-3.81,4.66,4.66,0,0,0-3.66-2c-1.56-.16-3,.91-3.83.91s-2-.89-3.3-.87A4.92,4.92,0,0,0,4.69,9.39C2.93,12.45,4.24,17,6,19.47,6.8,20.68,7.8,22.05,9.12,22s1.75-.82,3.28-.82,2,.82,3.3.79,2.22-1.24,3.06-2.45a11,11,0,0,0,1.38-2.85,4.41,4.41,0,0,1-2.68-4",
  fill: "#b3b3b3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13,5.19A4.38,4.38,0,0,0,14,2a4.46,4.46,0,0,0-2.94,1.52A4.16,4.16,0,0,0,10,6.61a3.67,3.67,0,0,0,3-1.42",
  fill: "#b3b3b3"
})));

/* eslint-disable max-len */
var IconApprove = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7,15.05a1.92,1.92,0,0,1-2-1.93v-.64a1.92,1.92,0,0,1,2-1.93,1.92,1.92,0,0,1,2,1.93v.64A1.92,1.92,0,0,1,7,15.05Z",
  fill: "none",
  stroke: "#1e2834",
  strokeMiterlimit: "10",
  strokeWidth: "0.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,21.8l1-3.6c.3-1.13.9-1.8,2-1.8H6L9.49,20h3s.22,1.8-1.5,1.8H8L5.5,19.1",
  fill: "none",
  stroke: "#1e2834",
  strokeMiterlimit: "10",
  strokeWidth: "0.5"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "10 18.65 12 15.5 21 15.5 18 20.45 13.5 20.45",
  fill: "none",
  stroke: "#1e2834",
  strokeMiterlimit: "10",
  strokeWidth: "0.5"
}), /*#__PURE__*/React.createElement("line", {
  x1: "6",
  y1: "21.8",
  x2: "22",
  y2: "21.8",
  fill: "none",
  stroke: "#1e2834",
  strokeMiterlimit: "10",
  strokeWidth: "0.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5,2h9A1.43,1.43,0,0,1,22,3.35v5.4a1.91,1.91,0,0,1-2,1.8H15.5l-2.1,2.52a.51.51,0,0,1-.9-.27V10.55h-1A1.43,1.43,0,0,1,10,9.2V3.35A1.43,1.43,0,0,1,11.5,2Z",
  fill: "none",
  stroke: "#1e2834",
  strokeMiterlimit: "10",
  strokeWidth: "0.5"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "13.5 6.5 15.5 8.3 19 4.25",
  fill: "none",
  stroke: "#1e2834",
  strokeMiterlimit: "10",
  strokeWidth: "0.5"
})));

var IconArrowUpLong = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,4.09,9.28,10.81l1.44,1.41L15,7.94V28h2V7.94l4.28,4.28,1.44-1.41Z"
})));

/* eslint-disable max-len */
var IconBell = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,22C13.1,22 14,21.1 14,20H10C10,21.1 10.9,22 12,22M18,16V11C18,7.93 16.36,5.36 13.5,4.68V4C13.5,3.17 12.83,2.5 12,2.5C11.17,2.5 10.5,3.17 10.5,4V4.68C7.63,5.36 6,7.92 6,11V16L4,18V19H20V18L18,16Z"
})));

/* eslint-disable max-len */
var IconBilling = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 6 3 L 6 29 L 22 29 L 22 27 L 8 27 L 8 5 L 18 5 L 18 11 L 24 11 L 24 13 L 26 13 L 26 9.5996094 L 25.699219 9.3007812 L 19.699219 3.3007812 L 19.400391 3 L 6 3 z M 20 6.4003906 L 22.599609 9 L 20 9 L 20 6.4003906 z M 10 13 L 10 15 L 22 15 L 22 13 L 10 13 z M 27 15 L 27 17 C 25.3 17.3 24 18.7 24 20.5 C 24 22.5 25.5 24 27.5 24 L 28.5 24 C 29.3 24 30 24.7 30 25.5 C 30 26.3 29.3 27 28.5 27 L 25 27 L 25 29 L 27 29 L 27 31 L 29 31 L 29 29 C 30.7 28.7 32 27.3 32 25.5 C 32 23.5 30.5 22 28.5 22 L 27.5 22 C 26.7 22 26 21.3 26 20.5 C 26 19.7 26.7 19 27.5 19 L 31 19 L 31 17 L 29 17 L 29 15 L 27 15 z M 10 18 L 10 20 L 17 20 L 17 18 L 10 18 z M 19 18 L 19 20 L 22 20 L 22 18 L 19 18 z M 10 22 L 10 24 L 17 24 L 17 22 L 10 22 z M 19 22 L 19 24 L 22 24 L 22 22 L 19 22 z"
})));

/* eslint-disable max-len */
const IconBolt = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.25,3h-10.4l-5.2,14.3h5.2l-2.6,11.7,11.7-16.9h-6.49l7.79-9.1Z",
    fillRule: "evenodd"
  })));
};

/* eslint-disable max-len */
var IconBriefcase = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.2,9h-5.6v-2.8l-2.8-2.8h-5.6l-2.8,2.8v2.8H4.8c-1.54,0-2.8,1.26-2.8,2.8v7c0,1.05,.56,1.93,1.4,2.42v4.58c0,1.55,1.25,2.8,2.8,2.8H25.8c1.55,0,2.8-1.25,2.8-2.8v-4.59c.83-.49,1.4-1.39,1.4-2.41v-7c0-1.54-1.26-2.8-2.8-2.8Zm-15.2-3h8v3H12v-3Zm15,20H5v-4h7.54v1h6.92v-1h7.54v4Zm-13-5v-4h4v4h-4Zm14-2h-8.5v-4h-7v4H4V11H28v8Z"
})));

/* eslint-disable max-len */
var IconBuilding = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.56,18h1.87c.31,0,.56,.25,.56,.56v1.88c0,.31-.25,.56-.56,.56h-1.88c-.31,0-.56-.25-.56-.56v-1.87c0-.31,.25-.56,.56-.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.56,18h1.87c.31,0,.56,.25,.56,.56v1.88c0,.31-.25,.56-.56,.56h-1.88c-.31,0-.56-.25-.56-.56v-1.87c0-.31,.25-.56,.56-.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.56,8h1.87c.31,0,.56,.25,.56,.56v1.88c0,.31-.25,.56-.56,.56h-1.88c-.31,0-.56-.25-.56-.56v-1.87c0-.31,.25-.56,.56-.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.56,8h1.87c.31,0,.56,.25,.56,.56v1.88c0,.31-.25,.56-.56,.56h-1.88c-.31,0-.56-.25-.56-.56v-1.87c0-.31,.25-.56,.56-.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.56,13h1.87c.31,0,.56,.25,.56,.56v1.88c0,.31-.25,.56-.56,.56h-1.88c-.31,0-.56-.25-.56-.56v-1.87c0-.31,.25-.56,.56-.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.56,13h1.87c.31,0,.56,.25,.56,.56v1.88c0,.31-.25,.56-.56,.56h-1.88c-.31,0-.56-.25-.56-.56v-1.87c0-.31,.25-.56,.56-.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.9,27.38h-1.01V3.31h0c0-.73-.56-1.31-1.24-1.31H7.26c-.68,0-1.23,.59-1.23,1.31V27.38h-1.01c-.34,0-.62,.29-.62,.66v1.97H27.52v-1.97c0-.36-.28-.65-.62-.66Zm-3,.61h-6.15v-3.87c0-.38-.29-.69-.66-.69h-2.19c-.36,0-.65,.31-.66,.69v3.88h-6.15l.03-24,15.78,.06V27.99Z"
})));

/* eslint-disable max-len */
var IconAngledFlatSeat = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.76,14.45l-.65,1.83L9.33,12l2-5.47,8.16,3A3.86,3.86,0,0,1,21.76,14.45ZM2,12.38l6.19,2.26V19h7.62V17.43L20.12,19l.65-1.83L2.66,10.55ZM7.52,10.5A2.93,2.93,0,0,0,8.87,6.64,2.84,2.84,0,0,0,5.05,5.29,2.91,2.91,0,0,0,3.71,9.15,2.83,2.83,0,0,0,7.52,10.5Z"
})));

/* eslint-disable max-len */
var IconCalendar = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})));

/* eslint-disable max-len */
var IconCalendarLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 9 4 L 9 5 L 5 5 L 5 27 L 27 27 L 27 5 L 23 5 L 23 4 L 21 4 L 21 5 L 11 5 L 11 4 Z M 7 7 L 9 7 L 9 8 L 11 8 L 11 7 L 21 7 L 21 8 L 23 8 L 23 7 L 25 7 L 25 9 L 7 9 Z M 7 11 L 25 11 L 25 25 L 7 25 Z M 13 13 L 13 15 L 15 15 L 15 13 Z M 17 13 L 17 15 L 19 15 L 19 13 Z M 21 13 L 21 15 L 23 15 L 23 13 Z M 9 17 L 9 19 L 11 19 L 11 17 Z M 13 17 L 13 19 L 15 19 L 15 17 Z M 17 17 L 17 19 L 19 19 L 19 17 Z M 21 17 L 21 19 L 23 19 L 23 17 Z M 9 21 L 9 23 L 11 23 L 11 21 Z M 13 21 L 13 23 L 15 23 L 15 21 Z M 17 21 L 17 23 L 19 23 L 19 21 Z"
})));

/* eslint-disable max-len */
var IconCamera = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
const IconCar = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 26.45 17.32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.18,11.1,28,10.65a.75.75,0,0,0-.7-.46h-3l-.9-2.8a1.53,1.53,0,0,0-1.45-1H8.08a1.53,1.53,0,0,0-1.45,1l-.9,2.8h-3a.75.75,0,0,0-.7.46l-.18.45a.75.75,0,0,0,.45,1l2,.69L2.71,14.17a1.64,1.64,0,0,0-.55,1.23v7.51a.76.76,0,0,0,.76.76h3a.76.76,0,0,0,.76-.76V21.4H23.33v1.51a.76.76,0,0,0,.76.76h3a.76.76,0,0,0,.76-.76V15.4a1.64,1.64,0,0,0-.55-1.23l-1.56-1.38,2-.69A.75.75,0,0,0,28.18,11.1Zm-20,6.31H4.68a.8.8,0,0,1-.8-.8v-.75a.79.79,0,0,1,1-.78l3.49.75a.8.8,0,0,1-.17,1.58ZM6.73,12l1-3.18a1.37,1.37,0,0,1,1.31-1H21a1.37,1.37,0,0,1,1.31,1l1,3.18H6.73Zm19.42,3.88v.75a.8.8,0,0,1-.8.8H21.86a.8.8,0,0,1-.16-1.58l3.48-.75A.8.8,0,0,1,26.15,15.86Z",
    transform: "translate(-1.79 -6.35)"
  })));
};

/* eslint-disable max-len */
var IconCaretDown = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.76,6.78l7.3,7.3,7.29-7.3a1.72,1.72,0,1,1,2.43,2.44l-8.51,8.51a1.73,1.73,0,0,1-.72.43l-.16,0a1.84,1.84,0,0,1-.33,0,1.75,1.75,0,0,1-1.22-.5L2.33,9.22A1.72,1.72,0,0,1,4.76,6.78Z"
})));

/* eslint-disable max-len */
var IconCaretUp = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.35,17.22l-7.29-7.3-7.3,7.3a1.72,1.72,0,1,1-2.43-2.44l8.51-8.51a1.71,1.71,0,0,1,.73-.43l.16,0,.33,0a1.71,1.71,0,0,1,1.21.5l8.51,8.51a1.72,1.72,0,1,1-2.43,2.44Z"
})));

/* eslint-disable max-len */
var IconCarLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m27.34,14.59l1.97-.66-.62-1.88-1.94.66-1.38-4.59c-.38-1.27-1.55-2.12-2.88-2.12h-13c-1.32,0-2.5.86-2.88,2.12l-1.38,4.59-1.94-.66-.62,1.88,1.97.66-.62,2.12c-.02.09-.04.19-.03.28v8c0,.55.45,1,1,1h3l.34-1h15.31l.34,1h3c.55,0,1-.45,1-1v-.84c0-.05,0-.11,0-.16v-7c0-.09,0-.19-.03-.28l-.62-2.12Zm-18.81-5.88c.13-.43.52-.72.97-.72h13c.45,0,.84.29.97.72l1.28,4.28H7.25l1.28-4.28Zm17.47,14.28H6v-5.81l.66-2.19h18.69l.66,2.19v5.81Zm-15-5c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Zm14,0c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
})));

/* eslint-disable max-len */
const IconCity = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
  })));
};

var IconPrevious = props => /*#__PURE__*/React.createElement(IconCaretUp, _extends({
  rotate: -90
}, props));

var IconNext = props => /*#__PURE__*/React.createElement(IconCaretUp, _extends({
  rotate: 90
}, props));

/* eslint-disable max-len */
const IconOpenNew = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
  })));
};

/* eslint-disable max-len */
var IconChat = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  d: "m21.30124,18.94857l0.02789,-0.01255c0.00209,-0.03556 0.00697,-0.07183 0.00697,-0.10739l0,-10.47182c0,-0.13946 -0.00279,-0.14155 -0.13946,-0.14155l-4.46989,0c-0.12761,0 -0.12831,0 -0.12831,0.1297l0,4.0752c-0.0007,0.24337 -0.11297,0.38632 -0.34657,0.43792c-0.07462,0.01604 -0.15341,0.02092 -0.23012,0.02092c-2.43089,0.00139 -4.86179,0.00139 -7.29339,0.00139c-0.13946,0 -0.13946,0 -0.13946,0.13946l0,3.0571c0,0.15829 0,0.15829 0.15411,0.15829l6.27528,0c1.07946,0 2.15894,-0.00279 3.2384,0.00139c0.21059,0.0007 0.39888,0.06625 0.55786,0.22733c0.79426,0.80333 1.59549,1.59967 2.39394,2.39812c0.02998,0.02998 0.06207,0.05788 0.09275,0.08647m-18.29587,-4.19305c0.0509,-0.04881 0.08229,-0.07671 0.11157,-0.10599c0.82704,-0.82634 1.65547,-1.65198 2.47832,-2.4825a0.49511,0.49511 0 0 1 0.37517,-0.1562c0.80403,0 1.60734,-0.00697 2.41067,-0.00697l7.1309,0c0.14365,0 0.14434,-0.0007 0.14434,-0.14644c0,-1.32423 -0.0007,-2.64916 0.00139,-3.97339c0,-0.09623 0.02301,-0.19177 0.03905,-0.2873c0.01325,-0.08159 0.04602,-0.16178 0.04672,-0.24337c0.00279,-1.05227 0.00209,-2.10454 0.00139,-3.15681c0,-0.20571 0.0265,-0.19386 -0.19665,-0.19386a448368.94863,448368.94863 0 0 0 -12.41667,0c-0.13598,0 -0.13598,0 -0.13598,0.14086l0,10.46972c0,0.03835 0.00558,0.07671 0.00976,0.14225m6.32479,-11.60707c2.21612,0 4.43223,0 6.64765,0.00139c0.09344,0 0.19316,0 0.27894,0.03068c0.18898,0.06764 0.25452,0.22803 0.25452,0.417c0.00209,0.59483 0.00139,1.19034 0.00139,1.78517l0,1.84654c0,0.13249 0,0.13319 0.13249,0.13319l5.00335,0c0.19037,0 0.34727,0.06276 0.41979,0.25034c0.02998,0.0781 0.03347,0.17085 0.03347,0.25731c0.00209,1.69103 0.00139,3.38205 0.00139,5.07377l-0.0007,6.93007c0,0.10669 0.0007,0.21966 -0.03347,0.31798c-0.08368,0.24267 -0.33751,0.35424 -0.58646,0.288a0.54671,0.54671 0 0 1 -0.26848,-0.16318c-0.99021,-1.04739 -1.98391,-2.09199 -2.97411,-3.14008a0.27336,0.27336 0 0 0 -0.21896,-0.09344c-3.25165,0.00209 -6.50331,0.00139 -9.75496,0.0007c-0.0802,0 -0.16388,0.00349 -0.23988,-0.01743c-0.19386,-0.05439 -0.29358,-0.2092 -0.29428,-0.44071l0,-2.00831c0,-0.54043 -0.00209,-1.08225 0.00209,-1.62339c0,-0.09484 -0.0265,-0.1297 -0.12552,-0.12831c-0.46721,0.00418 -0.93442,0.00279 -1.40163,0a0.24755,0.24755 0 0 0 -0.19386,0.08438c-1.01811,1.04879 -2.03899,2.09618 -3.05849,3.14287c-0.11506,0.11854 -0.24615,0.21129 -0.4177,0.21966a0.35842,0.35842 0 0 1 -0.38214,-0.31938a1.35282,1.35282 0 0 1 -0.01325,-0.20153c0,-4.04801 0,-8.09601 -0.00139,-12.14471c0,-0.20223 0.03696,-0.38214 0.24546,-0.46302c0.08159,-0.03138 0.17782,-0.03486 0.26708,-0.03486c1.79563,-0.00139 3.59125,-0.0007 5.38688,0l1.29145,0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  d: "m9.27438,7.27385c-1.16245,0 -2.3256,-0.00139 -3.48874,0.00209c-0.09414,0 -0.12133,-0.02789 -0.11854,-0.11924c0.00558,-0.20223 0.0007,-0.40306 0.00139,-0.60529c0,-0.129 0,-0.1297 0.13667,-0.1297l6.9482,0c0.13807,0.0007 0.13807,0.0007 0.13807,0.13946c0,0.19804 -0.00418,0.39678 0.00209,0.59483c0.00209,0.09205 -0.0251,0.11994 -0.11924,0.11994c-1.16663,-0.00349 -2.33327,-0.00209 -3.4992,-0.00209m-1.81375,1.46509l1.67359,0c0.14016,0 0.14295,0.00209 0.14295,0.13807l0,0.5746c0,0.14155 -0.00139,0.14295 -0.13946,0.14295l-1.76425,0c-0.52718,0.0007 -1.05436,-0.00139 -1.58224,0.00279c-0.09693,0 -0.12831,-0.02789 -0.12552,-0.12552c0.00697,-0.2092 0.00558,-0.417 0.0007,-0.62551c-0.00209,-0.08368 0.02789,-0.10878 0.11018,-0.10878c0.56135,0.00349 1.12271,0.00209 1.68336,0.00209l0,-0.0007l0.0007,0l-0.00001,0z"
}))));

/* eslint-disable max-len */
var IconChainLink = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.75,4a6.27,6.27,0,0,0-4.44,1.84L15.84,7.31A6.28,6.28,0,0,0,14,11.75,6,6,0,0,0,14.44,14l1.62-1.62a4.28,4.28,0,0,1,1.19-3.69l1.47-1.47a4.28,4.28,0,0,1,3-1.25,4.21,4.21,0,0,1,3,1.25,4.27,4.27,0,0,1,0,6l-1.47,1.47a4.28,4.28,0,0,1-3,1.25,3.68,3.68,0,0,1-.66-.06L18,17.56a6,6,0,0,0,2.28.44,6.27,6.27,0,0,0,4.44-1.84l1.47-1.47A6.28,6.28,0,0,0,28,10.25,6.28,6.28,0,0,0,21.75,4Zm-2.47,7.28-8,8,1.44,1.44,8-8ZM11.75,14a6.27,6.27,0,0,0-4.44,1.84L5.84,17.31A6.28,6.28,0,0,0,4,21.75a6.26,6.26,0,0,0,10.69,4.41l1.47-1.47A6.28,6.28,0,0,0,18,20.25,6,6,0,0,0,17.56,18l-1.62,1.62a4.28,4.28,0,0,1-1.19,3.69l-1.47,1.47a4.28,4.28,0,0,1-3,1.25,4.21,4.21,0,0,1-3-1.25,4.27,4.27,0,0,1,0-6l1.47-1.47a4.28,4.28,0,0,1,3-1.25,3.68,3.68,0,0,1,.66.06L14,14.44A6,6,0,0,0,11.75,14Z"
})));

/* eslint-disable max-len */
var IconChatRound = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31,18.52a6.75,6.75,0,0,0-.46-2.46,7.52,7.52,0,0,0-1.28-2.17,8.87,8.87,0,0,0-2-1.75,10.31,10.31,0,0,0-2.12-1.08,9.14,9.14,0,0,0-.47-1.33,9.87,9.87,0,0,0-.92-1.6,11.52,11.52,0,0,0-1.22-1.41,10.36,10.36,0,0,0-1.49-1.21,12.81,12.81,0,0,0-3.61-1.73,14.71,14.71,0,0,0-4.25-.62,15.13,15.13,0,0,0-2.43.2A14,14,0,0,0,6.46,4.83,13.27,13.27,0,0,0,4.65,6,11.07,11.07,0,0,0,3.14,7.51,10,10,0,0,0,2,9.22a8.54,8.54,0,0,0-1,4A8.29,8.29,0,0,0,1.19,15a8.62,8.62,0,0,0,.57,1.69,9.41,9.41,0,0,0,1.81,2.67L1.86,24.09a1.35,1.35,0,0,0,.38,1.48,1.25,1.25,0,0,0,.82.31,1.18,1.18,0,0,0,.66-.19h0l5.12-3.16a14.48,14.48,0,0,0,4.05.66,8.9,8.9,0,0,0,1.4,1.34,9.7,9.7,0,0,0,2,1.19,11.57,11.57,0,0,0,2.29.74,12.22,12.22,0,0,0,5.92-.25l3.94,2.44h0a1.3,1.3,0,0,0,.66.19,1.25,1.25,0,0,0,.82-.31h0A1.36,1.36,0,0,0,30.3,27L29,23.44a7.48,7.48,0,0,0,1.38-2.1A6.76,6.76,0,0,0,31,18.52Zm-17.77,2a12.18,12.18,0,0,1-4.12-.71A1.2,1.2,0,0,0,8,19.93H8l-.53.33,0,0h0l0,0-.07.05-.12.1c-.19.16-.36.34-.55.5a6.4,6.4,0,0,1-1.29.91h0a.34.34,0,0,1-.28,0A.32.32,0,0,1,5,21.77a.31.31,0,0,1,0-.31c.24-.44.51-.87.77-1.3a10.73,10.73,0,0,0,.56-1,1.41,1.41,0,0,0,0-.54,1.28,1.28,0,0,0-.4-.68,6.42,6.42,0,0,1-2.34-4.76A6.55,6.55,0,0,1,6.33,8.05a11.2,11.2,0,0,1,6.9-2.23,11.4,11.4,0,0,1,6.48,1.92,7,7,0,0,1,3.11,4.52.22.22,0,0,0,0,.08,5.93,5.93,0,0,1,.06.84,6.55,6.55,0,0,1-2.76,5.13A11.26,11.26,0,0,1,13.23,20.53Zm13.63,1.9A4.21,4.21,0,0,0,27,23a7,7,0,0,0,.33,1.1c0,.09.06.18.1.27a1.21,1.21,0,0,0,.05.14l0,.06v0l.24.55a.41.41,0,0,1,0,.22.33.33,0,0,1-.1.15.28.28,0,0,1-.37,0l-.66-.69L26,24.2l-.28-.28-.11-.1-.13-.08h0l-.08,0-.29-.07a4.23,4.23,0,0,0-.94,0l-.47.08-.88.16c-.18,0-.36.05-.55.06a8.52,8.52,0,0,1-1.24.08,9,9,0,0,1-4.58-1.21,13.76,13.76,0,0,0,2.45-.8,12.37,12.37,0,0,0,1.8-1,11.13,11.13,0,0,0,1.58-1.2,10.23,10.23,0,0,0,1.3-1.42,9.3,9.3,0,0,0,1-1.61,8.31,8.31,0,0,0,.63-1.77,6.87,6.87,0,0,0,.17-1,5.33,5.33,0,0,1,3,4.45,4.69,4.69,0,0,1-1.54,3.35l0,.1a.25.25,0,0,0,0,.07C26.83,22.17,26.84,22.3,26.86,22.43Z"
})));

/* eslint-disable max-len */
var IconChatSquare = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2,4V15.47H4.86V19.1L6,18.17l3.37-2.7h6.9V4ZM3.43,5.47H14.86V14h-6l-.2.15L6.29,16.11V14H3.43ZM17.71,6.9V8.32h2.86V16.9H17.71V19L15.1,16.9H9.75L8,18.32h6.65L19.14,22V18.32H22V6.9Z"
})));

var IconCheck = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
})));

/* eslint-disable max-len */
var IconCheckLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 28.28125 6.28125 L 11 23.5625 L 3.71875 16.28125 L 2.28125 17.71875 L 10.28125 25.71875 L 11 26.40625 L 11.71875 25.71875 L 29.71875 7.71875 Z"
})));

/* eslint-disable max-len */
var IconCheckDouble = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 23.28125 7.28125 L 11.5 19.0625 L 8.71875 16.28125 L 7.28125 17.71875 L 10.0625 20.5 L 8 22.5625 L 1.71875 16.28125 L 0.28125 17.71875 L 7.28125 24.71875 L 8 25.40625 L 8.71875 24.71875 L 11.5 21.9375 L 14.28125 24.71875 L 15 25.40625 L 15.71875 24.71875 L 31.625 8.71875 L 30.1875 7.28125 L 15 22.5625 L 12.9375 20.5 L 24.71875 8.71875 Z"
})));

/* eslint-disable max-len */
var IconCheckCircle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4ZM12 22q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Z"
})));

/* eslint-disable max-len */
var IconCheckCircleLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.12,17l-.18.15A10,10,0,1,1,16,6a9.74,9.74,0,0,1,5.34,1.56l.1-.12,2.75-2.75A13.65,13.65,0,0,0,16,2,14,14,0,1,0,30,16a13.46,13.46,0,0,0-.26-2.68Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.72,12.87,8.87,15.72l5.72,5.72L16,22.79l1.43-1.36L23.88,15a.83.83,0,0,1,.11-.15l5.45-5.45.15-.12.54-.54L27.28,5.87,16,17.15Z"
})));

/* eslint-disable max-len */
const IconCheckCurved = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 26.69 20.84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.35,4.62s-2.23,1.6-3.26,2.47a65.13,65.13,0,0,0-8.78,9.25,12.6,12.6,0,0,0-1.37,2.2,15,15,0,0,0-2.76-2.87A26.55,26.55,0,0,0,5.71,13.9a2.31,2.31,0,0,0-1.2-.27c-.95.17-1.87.47-2.88.75l.57.32a18.86,18.86,0,0,1,6.57,6c.82,1.25,1.46,2.61,2.17,3.93a1.16,1.16,0,0,0,1,.72,1.11,1.11,0,0,0,1.1-.68l.11-.24a61.4,61.4,0,0,1,6.55-10.78,60.25,60.25,0,0,1,8.38-9l.21-.18Z",
    transform: "translate(-1.63 -4.49)"
  })));
};

var IconChevron = props => /*#__PURE__*/React.createElement(Icon, _extends({
  rotate: 270
}, props), /*#__PURE__*/React.createElement("svg", {
  "aria-hidden": "true",
  role: "img",
  viewBox: "0 0 24 24",
  strokeOpacity: "1",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,8 L12,16 L20,8"
})));

/* eslint-disable max-len */
var IconCircleX = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 12.21875 10.78125 L 10.78125 12.21875 L 14.5625 16 L 10.78125 19.78125 L 12.21875 21.21875 L 16 17.4375 L 19.78125 21.21875 L 21.21875 19.78125 L 17.4375 16 L 21.21875 12.21875 L 19.78125 10.78125 L 16 14.5625 Z"
})));

/* eslint-disable max-len */
var IconClear = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.82,18.07h0L15.75,12l6.07-6.07h0A.64.64,0,0,0,22,5.71a.63.63,0,0,0-.14-.66L19,2.18A.63.63,0,0,0,18.29,2a.64.64,0,0,0-.22.14h0L12,8.25,5.93,2.18h0A.64.64,0,0,0,5.71,2a.63.63,0,0,0-.66.14L2.18,5.05A.63.63,0,0,0,2,5.71a.64.64,0,0,0,.14.22h0L8.25,12,2.18,18.07h0a.64.64,0,0,0-.14.22.63.63,0,0,0,.14.66l2.87,2.87a.63.63,0,0,0,.66.14.64.64,0,0,0,.22-.14h0L12,15.75l6.07,6.07h0a.64.64,0,0,0,.22.14.63.63,0,0,0,.66-.14L21.82,19a.63.63,0,0,0,.14-.66A.64.64,0,0,0,21.82,18.07Z"
})));

/* eslint-disable max-len */
var IconClock = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 4 C 9.382813 4 4 9.382813 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 C 28 9.382813 22.617188 4 16 4 Z M 16 6 C 21.535156 6 26 10.464844 26 16 C 26 21.535156 21.535156 26 16 26 C 10.464844 26 6 21.535156 6 16 C 6 10.464844 10.464844 6 16 6 Z M 15 8 L 15 17 L 22 17 L 22 15 L 17 15 L 17 8 Z"
})));

/* eslint-disable max-len */
var IconClone = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m29.88,29.94H9.06V9.07h20.82v20.86Zm-18.82-2h16.83V11.07H11.05v16.87Zm-4.53-5.08H2v-4.54h1.99v2.54h2.53v2Zm-2.53-6.89h-1.99v-7.07h1.99v7.07ZM22.82,6.54h-1.99v-2.54h-2.53v-2h4.53v4.54Zm-18.82,0h-1.99V2h4.53v2h-2.53v2.54Zm11.95-2.54h-7.06v-2h7.06v2Z"
})));

/* eslint-disable max-len */
var IconClose = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
var IconCog = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 13.1875 3 L 13.03125 3.8125 L 12.4375 6.78125 C 11.484375 7.15625 10.625 7.683594 9.84375 8.3125 L 6.9375 7.3125 L 6.15625 7.0625 L 5.75 7.78125 L 3.75 11.21875 L 3.34375 11.9375 L 3.9375 12.46875 L 6.1875 14.4375 C 6.105469 14.949219 6 15.460938 6 16 C 6 16.539063 6.105469 17.050781 6.1875 17.5625 L 3.9375 19.53125 L 3.34375 20.0625 L 3.75 20.78125 L 5.75 24.21875 L 6.15625 24.9375 L 6.9375 24.6875 L 9.84375 23.6875 C 10.625 24.316406 11.484375 24.84375 12.4375 25.21875 L 13.03125 28.1875 L 13.1875 29 L 18.8125 29 L 18.96875 28.1875 L 19.5625 25.21875 C 20.515625 24.84375 21.375 24.316406 22.15625 23.6875 L 25.0625 24.6875 L 25.84375 24.9375 L 26.25 24.21875 L 28.25 20.78125 L 28.65625 20.0625 L 28.0625 19.53125 L 25.8125 17.5625 C 25.894531 17.050781 26 16.539063 26 16 C 26 15.460938 25.894531 14.949219 25.8125 14.4375 L 28.0625 12.46875 L 28.65625 11.9375 L 28.25 11.21875 L 26.25 7.78125 L 25.84375 7.0625 L 25.0625 7.3125 L 22.15625 8.3125 C 21.375 7.683594 20.515625 7.15625 19.5625 6.78125 L 18.96875 3.8125 L 18.8125 3 Z M 14.8125 5 L 17.1875 5 L 17.6875 7.59375 L 17.8125 8.1875 L 18.375 8.375 C 19.511719 8.730469 20.542969 9.332031 21.40625 10.125 L 21.84375 10.53125 L 22.40625 10.34375 L 24.9375 9.46875 L 26.125 11.5 L 24.125 13.28125 L 23.65625 13.65625 L 23.8125 14.25 C 23.941406 14.820313 24 15.402344 24 16 C 24 16.597656 23.941406 17.179688 23.8125 17.75 L 23.6875 18.34375 L 24.125 18.71875 L 26.125 20.5 L 24.9375 22.53125 L 22.40625 21.65625 L 21.84375 21.46875 L 21.40625 21.875 C 20.542969 22.667969 19.511719 23.269531 18.375 23.625 L 17.8125 23.8125 L 17.6875 24.40625 L 17.1875 27 L 14.8125 27 L 14.3125 24.40625 L 14.1875 23.8125 L 13.625 23.625 C 12.488281 23.269531 11.457031 22.667969 10.59375 21.875 L 10.15625 21.46875 L 9.59375 21.65625 L 7.0625 22.53125 L 5.875 20.5 L 7.875 18.71875 L 8.34375 18.34375 L 8.1875 17.75 C 8.058594 17.179688 8 16.597656 8 16 C 8 15.402344 8.058594 14.820313 8.1875 14.25 L 8.34375 13.65625 L 7.875 13.28125 L 5.875 11.5 L 7.0625 9.46875 L 9.59375 10.34375 L 10.15625 10.53125 L 10.59375 10.125 C 11.457031 9.332031 12.488281 8.730469 13.625 8.375 L 14.1875 8.1875 L 14.3125 7.59375 Z M 16 11 C 13.25 11 11 13.25 11 16 C 11 18.75 13.25 21 16 21 C 18.75 21 21 18.75 21 16 C 21 13.25 18.75 11 16 11 Z M 16 13 C 17.667969 13 19 14.332031 19 16 C 19 17.667969 17.667969 19 16 19 C 14.332031 19 13 17.667969 13 16 C 13 14.332031 14.332031 13 16 13 Z"
})));

/* eslint-disable max-len */
var IconCoronavirus = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  width: "24"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: "24",
  width: "24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.25,10.5c-0.41,0-0.75,0.34-0.75,0.75h-1.54c-0.15-1.37-0.69-2.63-1.52-3.65l1.09-1.09l0.01,0.01 c0.29,0.29,0.77,0.29,1.06,0s0.29-0.77,0-1.06L18.54,4.4c-0.29-0.29-0.77-0.29-1.06,0c-0.29,0.29-0.29,0.76-0.01,1.05l-1.09,1.09 c-1.02-0.82-2.27-1.36-3.64-1.51V3.5h0.01c0.41,0,0.75-0.34,0.75-0.75C13.5,2.34,13.16,2,12.75,2h-1.5c-0.41,0-0.75,0.34-0.75,0.75 c0,0.41,0.33,0.74,0.74,0.75v1.55C9.87,5.19,8.62,5.74,7.6,6.56L6.51,5.47l0.01-0.01c0.29-0.29,0.29-0.77,0-1.06 c-0.29-0.29-0.77-0.29-1.06,0L4.4,5.46c-0.29,0.29-0.29,0.77,0,1.06c0.29,0.29,0.76,0.29,1.05,0.01l1.09,1.09 c-0.82,1.02-1.36,2.26-1.5,3.63H3.5c0-0.41-0.34-0.75-0.75-0.75C2.34,10.5,2,10.84,2,11.25v1.5c0,0.41,0.34,0.75,0.75,0.75 c0.41,0,0.75-0.34,0.75-0.75h1.54c0.15,1.37,0.69,2.61,1.5,3.63l-1.09,1.09c-0.29-0.29-0.76-0.28-1.05,0.01 c-0.29,0.29-0.29,0.77,0,1.06l1.06,1.06c0.29,0.29,0.77,0.29,1.06,0c0.29-0.29,0.29-0.77,0-1.06l-0.01-0.01l1.09-1.09 c1.02,0.82,2.26,1.36,3.63,1.51v1.55c-0.41,0.01-0.74,0.34-0.74,0.75c0,0.41,0.34,0.75,0.75,0.75h1.5c0.41,0,0.75-0.34,0.75-0.75 c0-0.41-0.34-0.75-0.75-0.75h-0.01v-1.54c1.37-0.14,2.62-0.69,3.64-1.51l1.09,1.09c-0.29,0.29-0.28,0.76,0.01,1.05 c0.29,0.29,0.77,0.29,1.06,0l1.06-1.06c0.29-0.29,0.29-0.77,0-1.06c-0.29-0.29-0.77-0.29-1.06,0l-0.01,0.01l-1.09-1.09 c0.82-1.02,1.37-2.27,1.52-3.65h1.54c0,0.41,0.34,0.75,0.75,0.75c0.41,0,0.75-0.34,0.75-0.75v-1.5C22,10.84,21.66,10.5,21.25,10.5z M13.75,8c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S13.2,8,13.75,8z M12,13c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1 C13,12.55,12.55,13,12,13z M10.25,8c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S9.7,8,10.25,8z M8.5,13c-0.55,0-1-0.45-1-1 c0-0.55,0.45-1,1-1s1,0.45,1,1C9.5,12.55,9.05,13,8.5,13z M10.25,16c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1 C11.25,15.55,10.8,16,10.25,16z M13.75,16c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C14.75,15.55,14.3,16,13.75,16z M14.5,12 c0-0.55,0.45-1,1-1s1,0.45,1,1c0,0.55-0.45,1-1,1S14.5,12.55,14.5,12z"
})));

const GraphicIconSvgStyled = styled.span`
  display: inline-flex;
  align-self: center;

  svg {
    width: 1em;
    height: 1em;
    position: relative;
    fill: ${_ref => {
  let {
    color
  } = _ref;
  return color || 'currentcolor';
}};
    stroke: ${_ref2 => {
  let {
    color
  } = _ref2;
  return color || 'unset';
}};

    ${_ref3 => {
  let {
    rotate
  } = _ref3;
  return rotate && css`
        transform: rotate(${rotate}deg);
      `;
}};
    ${_ref4 => {
  let {
    isRotating
  } = _ref4;
  return isRotating && css`
        animation: ${rotateAnimation} 0.5s infinite linear;
      `;
}};
    ${_ref5 => {
  let {
    backgroundColor
  } = _ref5;
  return backgroundColor && css`
        overflow: visible;
        border: ${_ref6 => {
    let {
      fontSize
    } = _ref6;
    return fontSize ? `${fontSize * 0.2}rem` : '0.2rem';
  }} solid ${backgroundColor};
        background-color: ${backgroundColor};
        border-radius: 100px;
        svg {
          top: 0;
        }
      `;
}};
  }
`;
const GraphicIcon = _ref7 => {
  let {
    children,
    backgroundColor,
    color,
    rotate,
    ...props
  } = _ref7;
  return /*#__PURE__*/React.createElement(GraphicIconSvgStyled, _extends({}, props, {
    backgroundColor: backgroundColor,
    color: color,
    rotate: rotate
  }), children);
};
GraphicIcon.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  rotate: PropTypes.number,
  children: PropTypes.node.isRequired
};
GraphicIcon.defaultProps = {
  color: '',
  backgroundColor: '',
  rotate: 0
};
GraphicIcon.displayName = 'GraphicIconSvg';

/* eslint-disable max-len */
var IconCreditCards = props => /*#__PURE__*/React.createElement(GraphicIcon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 100 100",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing",
  transform: "translate(-825.000000, -1112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Get-your-free-Account",
  transform: "translate(133.000000, 1018.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Live-reports",
  transform: "translate(652.000000, 94.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ico",
  transform: "translate(40.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  className: "st0",
  d: "M75.2,40.2H9c0,1,0.1,1.9,0,2.8c-0.1,0.9,0.2,1.2,1.1,1.2c21.3,0,42.7,0,64,0\r c0.3,0,0.7,0,1.1,0V40.2z M75.5,37.8c0-1.5,0-2.9,0-4.3c0-2.2-0.6-2.8-2.8-2.8c-20.3,0-40.5,0-60.8,0c-0.3,0-0.5,0-0.8,0\r c-1,0.1-1.9,0.7-2,1.7c-0.1,1.8,0,3.6,0,5.4C9.1,37.8,75.5,37.8,75.5,37.8z M75.3,46.4c-0.4,0-0.7-0.1-1-0.1\r c-21.5,0-42.9,0-64.4,0c-0.9,0-1,0.3-1,1.1c0,7.4,0,14.8,0,22.2c0,2,0.7,2.7,2.7,2.7c20.3,0,40.7,0,61,0c2,0,2.7-0.7,2.7-2.6\r c0-7.4,0-14.7,0-22.1C75.3,47.6,75.3,46.4,75.3,46.4z M42.2,74.3c-10.2,0-20.3,0-30.5,0c-3.1,0-4.8-1.7-4.8-4.8\r c0-12.1,0-24.2,0-36.4c0-3.1,2.3-4.9,4.9-4.8c20.4,0,40.9,0,61.3,0c2.9,0,4.7,1.8,4.7,4.7c0,12.2,0,24.4,0,36.6\r c0,2.9-1.8,4.6-4.7,4.6C62.7,74.3,52.5,74.3,42.2,74.3L42.2,74.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-3",
  className: "st0",
  d: "M57.9,12.9c10.1,0,20.2,0.1,30.3,0c2.9,0,5.1,1.8,5.1,5c-0.1,12-0.1,24,0,36.1\r c0,3.3-2.2,5.1-5,5c-2.3-0.1-4.5,0-6.8,0c-1,0-1.5-0.4-1.5-1.2c0-0.9,0.6-1.2,1.5-1.2c2.3,0,4.7,0,7,0c1.7,0,2.5-0.8,2.5-2.5\r c0-12.2,0-24.3,0-36.5c0-1.7-0.8-2.5-2.5-2.5c-20.5,0-40.9,0-61.4,0c-1.8,0-2.5,0.8-2.5,2.5c0,2.2,0,4.5,0,6.7\r c0,0.3,0.1,0.6,0,0.8c-0.3,0.4-0.7,0.9-1.2,1c-0.3,0-1-0.6-1-1c-0.1-2.9-0.1-5.8,0.1-8.7c0.1-2,2.1-3.4,4.4-3.4\r c4.6,0,9.3,0,13.9,0L57.9,12.9L57.9,12.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(-0.000000, 84.413043)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-5",
  className: "st0",
  d: "M49.8,0.2c15.7,0,31.5,0,47.2,0c0.4,0,0.8,0,1.2,0c0.7,0.1,1.1,0.4,1.1,1.1s-0.4,1.1-1.1,1.2\r c-0.3,0-0.5,0-0.8,0c-31.7,0-63.5,0-95.2,0c-0.3,0-0.8,0.1-1-0.1C0.9,2.1,0.5,1.7,0.5,1.3s0.5-0.8,0.8-1s0.8-0.1,1.3-0.1\r C18.3,0.2,34.1,0.2,49.8,0.2"
})), /*#__PURE__*/React.createElement("path", {
  id: "Fill-8",
  className: "st0",
  d: "M49.8,93.1c-11.1,0-22.3,0-33.4,0c-1.5,0-2-0.3-2-1.2c0-0.9,0.6-1.2,2-1.2c22.3,0,44.6,0,67,0\r c0.3,0,0.8-0.1,1,0.1c0.4,0.3,0.8,0.8,0.9,1.2c0.1,0.6-0.4,1-1,1.1c-0.4,0-0.7,0-1.1,0C72,93.1,60.9,93.1,49.8,93.1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(26.086957, 96.666008)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-11"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-10",
  className: "st0",
  d: "M16.1,0.4c4.3,0,8.7,0,13,0c0.3,0,0.7,0,1,0c0.7,0.1,1.1,0.5,1,1.1C31,2,30.6,2.4,30.2,2.7\r c-0.1,0.1-0.5,0-0.8,0c-9,0-18,0-27,0c-0.2,0-0.4,0-0.6,0c-0.6,0-1-0.5-1-1.2s0.4-1.1,1.1-1.2c1.2,0,2.3,0,3.5,0\r C9,0.4,12.5,0.4,16.1,0.4"
})), /*#__PURE__*/React.createElement("path", {
  id: "Fill-13",
  className: "st0",
  d: "M73,22.9c-0.1,0.5-0.1,0.9-0.3,1.2c-0.3,0.3-0.8,0.6-1.1,0.5c-0.4-0.1-0.9-0.5-1-0.9\r c-0.2-0.7-0.2-1.4,0-2c0.1-0.4,0.7-0.9,1.1-0.9c4.1-0.1,8.3,0,12.4,0c0.8,0,1.2,0.5,1.2,1.3c0,4.1,0,8.2,0,12.2\r c0,0.1,0,0.3,0,0.4c-0.2,0.8-0.8,1-1.5,0.9c-0.9-0.1-2,0.4-2.3-0.9c-0.2-0.7,0.1-1.4,0.9-1.4c0.7-0.1,0.8-0.4,0.8-1\r c0-2.8,0-5.7,0-8.5c0-0.4,0-0.9-0.6-0.9C79.3,23,76.2,22.9,73,22.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-18",
  className: "st0",
  d: "M67.1,97c1.4,0,2.9,0,4.3,0c0.8,0,1.4,0.2,1.4,1.1c0,0.8-0.5,1.2-1.4,1.2c-3,0-5.9,0-8.9,0\r c-0.8,0-1.4-0.3-1.3-1.2c0-0.9,0.6-1.2,1.4-1.2C64.1,97,65.6,97,67.1,97"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-24",
  className: "st0",
  d: "M29.2,60.8c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.7c0-2-1.6-3.6-3.6-3.6\r C30.8,57.2,29.2,58.9,29.2,60.8 M32.8,54.8c3.2,0,5.9,2.7,5.8,6c0,3.2-2.7,5.8-5.9,5.8c-3.1,0-5.8-2.7-5.9-5.9\r C26.9,57.5,29.6,54.8,32.8,54.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-26",
  className: "st0",
  d: "M18.1,60.6c0.1,2.4,2.2,4.1,4.6,3.6c0.8-0.2,1.3-0.1,1.5,0.7c0.2,0.9-0.4,1.2-1.1,1.4\r c-3,0.8-6.3-1.2-7-4.3c-0.8-3.1,1.2-6.4,4.3-7.1c0.9-0.2,1.9-0.1,2.8,0c0.7,0.1,1.2,0.5,1,1.4c-0.2,0.8-0.7,0.9-1.5,0.7\r c-1.7-0.3-3.1,0.1-4,1.6C18.5,59.3,18.3,60,18.1,60.6"
})))))));

/* eslint-disable max-len */
var IconCreditCard = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.53,6H3.47A2.52,2.52,0,0,0,1,8.59V23.41A2.52,2.52,0,0,0,3.47,26H28.53A2.52,2.52,0,0,0,31,23.41V8.59A2.52,2.52,0,0,0,28.53,6ZM28,22.2A1.65,1.65,0,0,1,26.56,24H23.44A1.65,1.65,0,0,1,22,22.2V20.8A1.65,1.65,0,0,1,23.44,19h3.12A1.65,1.65,0,0,1,28,20.8ZM30,15H2V11H30Z"
})));

/* eslint-disable max-len */
var IconCarDoor = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20.67,19c-.92,0-1.67.67-1.67,1.5s.75,1.5,1.67,1.5h1.67c.92,0,1.67-.67,1.67-1.5s-.75-1.5-1.67-1.5h-1.67Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.67,5c1.29,0,2.33,1.05,2.33,2.33v18.78c0,.49-.4.89-.89.89H5.89c-.49,0-.89-.4-.89-.89v-8.19c0-1.12.37-2.24,1.04-3.13l4.91-6.55c1.52-2.03,3.95-3.24,6.49-3.24h7.22m0-2h-7.22c-3.18,0-6.18,1.5-8.09,4.04l-4.91,6.55c-.94,1.25-1.44,2.77-1.44,4.33v8.19c0,1.6,1.29,2.89,2.89,2.89h20.22c1.6,0,2.89-1.29,2.89-2.89V7.33c0-2.39-1.94-4.33-4.33-4.33h0Z",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4.76",
  y: "15",
  width: "23.3",
  height: "2",
  strokeWidth: "0"
})));

/* eslint-disable max-len */
var IconDownload = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,18a1.14,1.14,0,0,0,.82-.35l5.83-5.92a1.15,1.15,0,0,0,.35-.84A1.18,1.18,0,0,0,17.83,9.7H15.5V3.19A1.18,1.18,0,0,0,14.33,2H9.67A1.18,1.18,0,0,0,8.5,3.19V9.7H6.17A1.18,1.18,0,0,0,5,10.89a1.15,1.15,0,0,0,.35.84l5.83,5.92A1.14,1.14,0,0,0,12,18Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,18.25a1,1,0,1,1,2,0V20H20v-1.7a1,1,0,1,1,2,0V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z",
  fillRule: "evenodd"
})));

/* eslint-disable max-len */
var IconDragHandle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})));

/* eslint-disable max-len */
var IconDragNDrop = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: "18.59",
  y: "13.45",
  width: "2",
  height: "0.83"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.71",
  y: "13.45",
  width: "2",
  height: "0.83"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9.41",
  y: "7.17",
  width: "0.85",
  height: "1.95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9.41",
  y: "3.38",
  width: "0.85",
  height: "1.95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "18.59",
  y: "2",
  width: "2",
  height: "0.83"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.71",
  y: "2",
  width: "2",
  height: "0.83"
}), /*#__PURE__*/React.createElement("rect", {
  x: "10.82",
  y: "2",
  width: "2",
  height: "0.83"
}), /*#__PURE__*/React.createElement("rect", {
  x: "21.15",
  y: "7.17",
  width: "0.85",
  height: "1.95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "21.15",
  y: "10.95",
  width: "0.85",
  height: "1.95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "21.15",
  y: "3.38",
  width: "0.85",
  height: "1.95"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.41,10.41V6.9a.41.41,0,0,0-.13-.29.42.42,0,0,0-.3-.12h-3.6v.83H16l-.57.56L8.71,14.45l.61.58L14,10.39V20.88H3.15V10.26h9L13,9.43H2.72a.47.47,0,0,0-.3.12.43.43,0,0,0-.13.3V21.3a.41.41,0,0,0,.13.29.42.42,0,0,0,.3.12H14.46a.42.42,0,0,0,.3-.12.4.4,0,0,0,.12-.29V9.85a.46.46,0,0,0-.06-.23l1.73-1.71v2.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.46,22H2.72a.74.74,0,0,1-.51-.21A.71.71,0,0,1,2,21.3V9.85a.71.71,0,0,1,.21-.5.75.75,0,0,1,.51-.21H13.66l-1.44,1.41H3.44V20.6h10.3V11.09L9.32,15.44l-1-1,7-6.84H13.09V6.2H17a.75.75,0,0,1,.51.21.71.71,0,0,1,.21.49v3.8H16.26V8.61l-1.1,1.08a.78.78,0,0,1,0,.16V21.3a.71.71,0,0,1-.21.49A.75.75,0,0,1,14.46,22ZM2.72,9.72a.11.11,0,0,0-.09,0,.1.1,0,0,0,0,.09V21.3a.11.11,0,0,0,0,.09.15.15,0,0,0,.09,0H14.46a.15.15,0,0,0,.09,0,.11.11,0,0,0,0-.09V9.85a.14.14,0,0,0,0-.07l-.13-.2,2.41-2.36v2.9h.26V6.9a.12.12,0,0,0,0-.09.15.15,0,0,0-.09,0h-3.3V7h3L9.13,14.45l.19.18,5-4.93V21.17H2.85V10H12l.27-.26Z"
})))));

/* eslint-disable max-len */
var IconDuplicate = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2,19.83V11.17A1.18,1.18,0,0,1,3.19,10H5.92v4.8a2.29,2.29,0,0,0,.69,1.65,2.4,2.4,0,0,0,1.68.69h7.65v2.69A1.17,1.17,0,0,1,14.76,21H3.18A1.17,1.17,0,0,1,2,19.83Zm0,0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22,4.28v9.44A1.23,1.23,0,0,1,20.81,15H9.24a1.23,1.23,0,0,1-1.18-1.28V4.28A1.23,1.23,0,0,1,9.24,3H20.81A1.23,1.23,0,0,1,22,4.28Zm0,0"
}))));

/* eslint-disable max-len */
const IconEarth = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.74.94A14.32,14.32,0,1,0,29.05,15.26,14.32,14.32,0,0,0,14.74.94ZM11.67,9.72c-1.14.31-1,.57-1.73,2.9S9,14,8.29,13.4,7.1,13,6,13.84s3.77,3,5.72,4.33-1.19,4.54-2.84,6.66-2-.34-1.86-1.69-.09-1.6-1.4-2.85-.17-2.6.3-3.38S7.12,16.23,4.18,14c-1.92-1.48-2.08-2.71-1.49-3.87C5.47,4.52,8.48,4.23,8.48,4.23c1.43-.47,1.58-.22,1.8.6s1.31,1.39,3,2.6S12.81,9.42,11.67,9.72ZM16,4.31c-.69.82-.62.67-1.37,1.62s-.84.88-1.29.44a1.64,1.64,0,0,1-.67-1.45,2.85,2.85,0,0,0-.27-1.8c-.33-.7-.52,0-1.15-.39-.1-.06-.12-.13-.09-.19A11.83,11.83,0,0,1,14.76,2c.28,0,.55,0,.82,0-.26.42-.4.88.28.8C16.78,2.71,16.7,3.48,16,4.31ZM26.55,15.94a1.08,1.08,0,0,1-1.19-.39c-.28-.37-.66-1-1.07-1.66a1,1,0,0,1-.17-.26c-.3-.31,0,1.33.36,2s.63.57,1.27.66.25.83-.14,1.28A4.74,4.74,0,0,0,25,19.93a2.85,2.85,0,0,1-.83,1.83c-.47.61-.52,1-.94,1.52s-1.46.6-1.38.37a5.4,5.4,0,0,0-.44-1.71,2.08,2.08,0,0,1-.08-1.61,1.77,1.77,0,0,0-.19-2c-.14-.2-.48.12-.64-.37s-.94-.46-2.1-.4-.93-.36-1.29-1a2.11,2.11,0,0,1,.11-1.89,6.51,6.51,0,0,0,.46-1,1.1,1.1,0,0,1,.78-.8,2.81,2.81,0,0,1,2.68.19c.49.46,1,.86,1.1.58.31-.66,1.54-.35,2.07-.66l0,0,.18-.18c.67-.64.05-1.14.18-1.87s-1.2-.32-2.1.68-1.33.05-2.45-.59-1.2,1.23-2.05,1,.13-1,0-2.55.36-.92,1.52-1.74,1.73-2.42,2.64-2.61c.62-.13,1.32.67,2,1.36,1.08,1.08,3.23,5.36,3.14,8C27.34,15.88,27,16.15,26.55,15.94Z"
  })));
};

/* eslint-disable max-len */
const IconEco = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.05,8.05c-2.73,2.73-2.73,7.15-0.02,9.88c1.47-3.4,4.09-6.24,7.36-7.93c-2.77,2.34-4.71,5.61-5.39,9.32 c2.6,1.23,5.8,0.78,7.95-1.37C19.43,14.47,20,4,20,4S9.53,4.57,6.05,8.05z"
  })))));
};

/* eslint-disable max-len */
var IconEdit = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
var IconEditDocument = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 25 4.03125 C 24.234375 4.03125 23.484375 4.328125 22.90625 4.90625 L 13 14.78125 L 12.78125 15 L 12.71875 15.3125 L 12.03125 18.8125 L 11.71875 20.28125 L 13.1875 19.96875 L 16.6875 19.28125 L 17 19.21875 L 17.21875 19 L 27.09375 9.09375 C 28.246094 7.941406 28.246094 6.058594 27.09375 4.90625 C 26.515625 4.328125 25.765625 4.03125 25 4.03125 Z M 25 5.96875 C 25.234375 5.96875 25.464844 6.089844 25.6875 6.3125 C 26.132813 6.757813 26.132813 7.242188 25.6875 7.6875 L 16 17.375 L 14.28125 17.71875 L 14.625 16 L 24.3125 6.3125 C 24.535156 6.089844 24.765625 5.96875 25 5.96875 Z M 4 8 L 4 28 L 24 28 L 24 14.8125 L 22 16.8125 L 22 26 L 6 26 L 6 10 L 15.1875 10 L 17.1875 8 Z"
})));

/* eslint-disable max-len */
var IconEllipsisHorizCircle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 28 28"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,2A12,12,0,1,0,26,14,12,12,0,0,0,14,2Zm0,22A10,10,0,1,1,24,14,10,10,0,0,1,14,24Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "14",
  r: "2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "14",
  r: "2"
})));

/* eslint-disable max-len */
var IconEllipsisHorizontal = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "25.5",
  cy: "16",
  r: "2.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5.5",
  cy: "16",
  r: "2.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "15.5",
  cy: "16",
  r: "2.5"
})));

/* eslint-disable max-len */
var IconEmail = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.72,12.86,2,5.47V4.88a.93.93,0,0,1,.21-.66A.9.9,0,0,1,2.89,4H21.1a.79.79,0,0,1,.9.88v.59l-9.72,7.39Zm.27,2.9a1.4,1.4,0,0,0,.37,0,1,1,0,0,0,.28-.1,1.14,1.14,0,0,0,.23-.15L22,8.53V19.86a.94.94,0,0,1-.1.43,1.15,1.15,0,0,1-.25.37,1.24,1.24,0,0,1-.35.25,1,1,0,0,1-.4.09H3.1a1,1,0,0,1-.41-.09,1.24,1.24,0,0,1-.35-.25,1.15,1.15,0,0,1-.25-.37A1.07,1.07,0,0,1,2,19.86V8.53l9.13,6.94a1.14,1.14,0,0,0,.49.25A1.4,1.4,0,0,0,12,15.76Z",
  strokeMiterlimit: "10",
  strokeWidth: "0.31"
})));

/* eslint-disable max-len */
var IconEmailLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 3 8 L 3 26 L 29 26 L 29 8 Z M 7.3125 10 L 24.6875 10 L 16 15.78125 Z M 5 10.875 L 15.4375 17.84375 L 16 18.1875 L 16.5625 17.84375 L 27 10.875 L 27 24 L 5 24 Z"
})));

/* eslint-disable max-len */
var IconEmptyExpense = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.72,22H3.33A.32.32,0,0,1,3,21.68V4a.32.32,0,0,1,.33-.31H17.72a.33.33,0,0,1,.34.31V21.68A.33.33,0,0,1,17.72,22Zm-14-.63H17.39V4.28H3.67Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.35,20.35A.32.32,0,0,1,19,20V2.63H5A.32.32,0,1,1,5,2H19.35a.33.33,0,0,1,.34.32V20A.33.33,0,0,1,19.35,20.35Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,14.09H6.07a.32.32,0,1,1,0-.63H15a.32.32,0,1,1,0,.63Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,15.63H6.07a.32.32,0,1,1,0-.63H15a.32.32,0,1,1,0,.63Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.53,17.26H6.07a.32.32,0,0,1-.33-.32.33.33,0,0,1,.33-.32h5.46a.33.33,0,0,1,.33.32A.32.32,0,0,1,11.53,17.26Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.74,18.93H6.07a.32.32,0,0,1-.33-.32.33.33,0,0,1,.33-.32H9.74a.33.33,0,0,1,.34.32A.33.33,0,0,1,9.74,18.93Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.58,11.57H10.5a1.71,1.71,0,0,1-1.84-1.5A.33.33,0,0,1,9,9.76H9a.32.32,0,0,1,.33.32c0,.46.52.85,1.18.85h.05a1.47,1.47,0,0,0,.87-.26.73.73,0,0,0,.33-.57h0c0-.47-.52-.85-1.17-.86A2.23,2.23,0,0,1,9.3,8.82a1.34,1.34,0,0,1-.55-1.08,1.69,1.69,0,0,1,1.87-1.45h.06A2.07,2.07,0,0,1,12,6.71a1.38,1.38,0,0,1,.56,1.08.34.34,0,0,1-.34.31h0a.32.32,0,0,1-.33-.32.74.74,0,0,0-.32-.58,1.37,1.37,0,0,0-.86-.28H10.6c-.65,0-1.18.37-1.18.83a.73.73,0,0,0,.31.58,1.52,1.52,0,0,0,.86.28,1.69,1.69,0,0,1,1.84,1.5h0a1.31,1.31,0,0,1-.58,1.06A2.11,2.11,0,0,1,10.58,11.57Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6,6.74h0a.33.33,0,0,1-.33-.32V5.69a.33.33,0,0,1,.34-.31.33.33,0,0,1,.33.32v.73A.32.32,0,0,1,10.6,6.74Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6,12.32h0a.34.34,0,0,1-.33-.32v-.73a.34.34,0,0,1,.67,0V12A.32.32,0,0,1,10.6,12.32Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.49,20.21a1.82,1.82,0,1,1,1.91-1.82A1.88,1.88,0,0,1,14.49,20.21Zm0-3a1.18,1.18,0,1,0,1.24,1.18A1.22,1.22,0,0,0,14.49,17.21Z"
}))));

/* eslint-disable max-len */
var IconEmptyExpTrip = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 -3 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M3.66,20,3,19.84a9.63,9.63,0,0,1,18.74-.09l-.67.16A8.94,8.94,0,0,0,3.66,20Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.29,19.86l-.65-.21a2.86,2.86,0,0,1,1.49-1.48,2.4,2.4,0,0,1,1-.31,2.05,2.05,0,0,0,.37-1.24,2.81,2.81,0,0,0-.69-.47c-.42-.23-.83-.45-.95-.78-.05-.11-.18-.46,0-2.11l.68.08a6.06,6.06,0,0,0,0,1.78,2.26,2.26,0,0,0,.64.43,2.77,2.77,0,0,1,.92.67c.4.56-.13,1.62-.19,1.74-.21.4-.41.59-.64.59s-.25,0-.8.24A2.32,2.32,0,0,0,8.29,19.86Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.83,17.29a.9.9,0,0,1-.35-.09,1.14,1.14,0,0,1-.69-.9c0-.3,0-.9,0-1.14v0a.77.77,0,0,1-.26-.73A.57.57,0,0,1,11.7,14a2.8,2.8,0,0,1,1.69-.23,3.75,3.75,0,0,1,1.22.24,1.85,1.85,0,0,1,.44.53l.18.29a.63.63,0,0,1,.1.57,1.27,1.27,0,0,1-.64.73,2.42,2.42,0,0,1-.47.12,4.07,4.07,0,0,0-.7.19c-.07,0-.13.23-.17.34a.85.85,0,0,1-.24.41A.42.42,0,0,1,12.83,17.29Zm-.19-.59Zm-.47-2.19c0,.09,0,.1.05.14a.63.63,0,0,1,.21.39,10.92,10.92,0,0,1,0,1.26c0,.06.13.17.23.24a1.19,1.19,0,0,1,.5-.7,3.46,3.46,0,0,1,.89-.26l.34-.08a.62.62,0,0,0,.24-.29,2.61,2.61,0,0,1-.2-.3,2.27,2.27,0,0,0-.23-.32,4,4,0,0,0-.88-.14h0A2.94,2.94,0,0,0,12.17,14.51Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.18,11.28h-.07l-1-.2a.33.33,0,0,1-.26-.22.33.33,0,0,1,.06-.33l1.51-1.83-2,0c-.57,0-.73-.66-.85-1.14,0-.09-.05-.19-.08-.27v0l-.18-.94A.32.32,0,0,1,12.38,6a.35.35,0,0,1,.27-.13H13.8a.35.35,0,0,1,.32.22l.21.56,6.66,0a1,1,0,0,1,0,2h0l-2.75,0-2.82,2.48A.35.35,0,0,1,15.18,11.28Zm-.35-.77.25.05,2.8-2.45A.32.32,0,0,1,18.11,8l2.87,0h0a.32.32,0,0,0,.32-.32A.33.33,0,0,0,21,7.39l-6.9,0a.35.35,0,0,1-.32-.22l-.21-.56h-.5l.1.51a1.71,1.71,0,0,1,.08.29,2.62,2.62,0,0,0,.22.62l2.7,0a.33.33,0,0,1,.31.2.34.34,0,0,1,0,.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M16.1,6.44a.31.31,0,0,1-.27-.13L14.65,4.84a.35.35,0,0,1-.05-.33.33.33,0,0,1,.26-.22l1-.18a.35.35,0,0,1,.29.09l1.8,1.62a.35.35,0,0,1,0,.49.34.34,0,0,1-.48,0L15.81,4.82l-.26,0,.81,1a.34.34,0,0,1-.05.48A.33.33,0,0,1,16.1,6.44Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.65,13.85,2,13.63c1.23-3.7,5.19-6.28,9.63-6.28V8C7.48,8,3.79,10.43,2.65,13.85Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.64,11.19l-.45-.52a8.65,8.65,0,0,1,5.11-2l0,.68A8.07,8.07,0,0,0,6.64,11.19Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.15,10.06l-.56-.4A8.72,8.72,0,0,1,7.08,6.49l.21.65A8.05,8.05,0,0,0,3.15,10.06Z"
}))));

/* eslint-disable max-len */
var IconEmptyReceipt = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.69,22a.32.32,0,0,1-.21-.08L19.2,20.8l-1.28,1.12a.31.31,0,0,1-.42,0L16.22,20.8l-1.28,1.12a.31.31,0,0,1-.42,0L13.24,20.8,12,21.92a.31.31,0,0,1-.42,0L10.26,20.8,9,21.92a.33.33,0,0,1-.33.06.3.3,0,0,1-.19-.28V7.58a.81.81,0,0,0-1.62,0v7.9a1.39,1.39,0,0,1-1.42,1.35,1.45,1.45,0,0,1-1-.4,1.32,1.32,0,0,1-.41-1L4,2.7a.3.3,0,0,1,.17-.27.32.32,0,0,1,.33,0l1.29,1,1.3-1a.33.33,0,0,1,.38,0l1.29,1,1.3-1a.33.33,0,0,1,.38,0l1.29,1,1.29-1a.35.35,0,0,1,.39,0l1.29,1,1.29-1a.33.33,0,0,1,.33,0,.29.29,0,0,1,.18.27V6.22h2.75A1.67,1.67,0,0,1,21,7.85V21.7a.3.3,0,0,1-.19.28Zm-7.45-1.9a.32.32,0,0,1,.21.08l1.28,1.12L16,20.18a.31.31,0,0,1,.42,0l1.28,1.12L19,20.18a.31.31,0,0,1,.42,0l1,.85V7.85a1.07,1.07,0,0,0-1.09-1H8.83a1.31,1.31,0,0,1,.25.77V21l1-.85a.31.31,0,0,1,.42,0l1.28,1.12L13,20.18A.34.34,0,0,1,13.24,20.1ZM4.66,3.3l0,12.18a.73.73,0,0,0,.24.54.82.82,0,0,0,.56.22.78.78,0,0,0,.8-.76V7.58A1.4,1.4,0,0,1,7.65,6.22h8.26V3.3l-1,.74a.33.33,0,0,1-.38,0l-1.29-1L12,4a.33.33,0,0,1-.38,0l-1.29-1L9,4a.33.33,0,0,1-.38,0l-1.29-1L6,4a.33.33,0,0,1-.38,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.77,16.83H5.42a.3.3,0,1,1,0-.59H8.77a.3.3,0,1,1,0,.59Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.86,16.83h-.11a2.72,2.72,0,0,1-1.6-.53A1.63,1.63,0,0,1,12.47,15a.3.3,0,0,1,.31-.3h0a.32.32,0,0,1,.31.3,1.09,1.09,0,0,0,.46.86,2,2,0,0,0,1.21.4h.07c.93,0,1.69-.53,1.7-1.22h0a1.08,1.08,0,0,0-.46-.85,1.91,1.91,0,0,0-1.21-.4,2.12,2.12,0,0,1-2.28-1.86,2.12,2.12,0,0,1,2.33-1.8H15a2.66,2.66,0,0,1,1.6.54A1.63,1.63,0,0,1,17.26,12a.3.3,0,0,1-.31.29.31.31,0,0,1-.31-.3,1.07,1.07,0,0,0-.46-.86A1.93,1.93,0,0,0,15,10.7h-.1c-.91,0-1.66.55-1.67,1.22s.74,1.25,1.67,1.26a2.59,2.59,0,0,1,1.6.53A1.63,1.63,0,0,1,17.15,15h0A2.1,2.1,0,0,1,14.86,16.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.78,18.07h0a.29.29,0,0,1-.3-.3V16.53a.31.31,0,0,1,.32-.29.3.3,0,0,1,.3.3v1.24A.31.31,0,0,1,14.78,18.07Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.88,10.46h0a.32.32,0,0,1-.31-.3l0-1a.3.3,0,0,1,.31-.29h0a.3.3,0,0,1,.31.3v.95A.32.32,0,0,1,14.88,10.46Z"
})))));

/* eslint-disable max-len */
var IconExpired = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 7 4 L 7 6 L 9 6 L 9 10 C 9 12.542969 10.367188 14.773438 12.40625 16 C 10.367188 17.226563 9 19.457031 9 22 L 9 26 L 7 26 L 7 28 L 25 28 L 25 26 L 23 26 L 23 22 C 23 19.457031 21.632813 17.226563 19.59375 16 C 21.632813 14.773438 23 12.542969 23 10 L 23 6 L 25 6 L 25 4 Z M 11 6 L 21 6 L 21 10 C 21 12.773438 18.773438 15 16 15 C 13.226563 15 11 12.773438 11 10 Z M 16 17 C 18.773438 17 21 19.226563 21 22 L 21 26 L 20 26 L 20 24 C 20 21.789063 18.210938 20 16 20 C 13.789063 20 12 21.789063 12 24 L 12 26 L 11 26 L 11 22 C 11 19.226563 13.226563 17 16 17 Z"
})));

/* eslint-disable max-len */
var IconEye = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 8 C 7.664063 8 1.25 15.34375 1.25 15.34375 L 0.65625 16 L 1.25 16.65625 C 1.25 16.65625 7.097656 23.324219 14.875 23.9375 C 15.246094 23.984375 15.617188 24 16 24 C 16.382813 24 16.753906 23.984375 17.125 23.9375 C 24.902344 23.324219 30.75 16.65625 30.75 16.65625 L 31.34375 16 L 30.75 15.34375 C 30.75 15.34375 24.335938 8 16 8 Z M 16 10 C 18.203125 10 20.234375 10.601563 22 11.40625 C 22.636719 12.460938 23 13.675781 23 15 C 23 18.613281 20.289063 21.582031 16.78125 21.96875 C 16.761719 21.972656 16.738281 21.964844 16.71875 21.96875 C 16.480469 21.980469 16.242188 22 16 22 C 15.734375 22 15.476563 21.984375 15.21875 21.96875 C 11.710938 21.582031 9 18.613281 9 15 C 9 13.695313 9.351563 12.480469 9.96875 11.4375 L 9.9375 11.4375 C 11.71875 10.617188 13.773438 10 16 10 Z M 16 12 C 14.34375 12 13 13.34375 13 15 C 13 16.65625 14.34375 18 16 18 C 17.65625 18 19 16.65625 19 15 C 19 13.34375 17.65625 12 16 12 Z M 7.25 12.9375 C 7.09375 13.609375 7 14.285156 7 15 C 7 16.753906 7.5 18.394531 8.375 19.78125 C 5.855469 18.324219 4.105469 16.585938 3.53125 16 C 4.011719 15.507813 5.351563 14.203125 7.25 12.9375 Z M 24.75 12.9375 C 26.648438 14.203125 27.988281 15.507813 28.46875 16 C 27.894531 16.585938 26.144531 18.324219 23.625 19.78125 C 24.5 18.394531 25 16.753906 25 15 C 25 14.285156 24.90625 13.601563 24.75 12.9375 Z"
})));

var IconFile = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
var IconFilter = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.44,26c-.44,0-.81-.14-1.11-.43-.3-.29-.45-.64-.45-1.07,0-.42.15-.78.45-1.07.3-.29.67-.43,1.11-.43h3.11c.44,0,.81.14,1.11.43.3.29.45.64.45,1.07,0,.42-.15.78-.45,1.07-.3.29-.67.43-1.11.43h-3.11Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.56,10c-.44,0-.81-.14-1.11-.43-.3-.29-.45-.64-.45-1.07,0-.42.15-.78.45-1.07.3-.29.67-.43,1.11-.43h24.89c.44,0,.81.14,1.11.43.3.29.45.64.45,1.07,0,.42-.15.78-.45,1.07-.3.29-.67.43-1.11.43H3.56Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.22,18c-.44,0-.81-.14-1.11-.43-.3-.29-.45-.64-.45-1.07,0-.42.15-.78.45-1.07.3-.29.67-.43,1.11-.43h15.56c.44,0,.81.14,1.11.43.3.29.45.64.45,1.07,0,.42-.15.78-.45,1.07-.3.29-.67.43-1.11.43h-15.56Z"
})));

/* eslint-disable max-len */
var IconFreeAlcoholicDrinks = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18,20.62v.91c0,.23-.12.47-.31.47H6.36c-.19,0-.36-.24-.36-.47v-.91a.39.39,0,0,1,.36-.42h4.75V18.5h0V11.2L3,2H21l-8,9.23V18.5h0v1.7h4.72C17.88,20.2,18,20.38,18,20.62Z"
})));

/* eslint-disable max-len */
var IconGearShift = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m16.03,22.42l3.43-9.31c.15.02.31.05.47.05,2.25,0,4.08-1.83,4.08-4.07s-1.83-4.08-4.08-4.08-4.07,1.83-4.07,4.08c0,1.38.69,2.59,1.74,3.33l-3.69,10.03c-2.26.1-4.59.47-6.89,1.29-.7.25-1.37.52-2,.82v2.46h22v-2.46c-2.58-.88-6.54-1.98-10.97-2.12Zm3.9-15.42c1.14,0,2.08.93,2.08,2.08s-.93,2.07-2.08,2.07-2.08-.93-2.08-2.07.93-2.08,2.08-2.08Z",
  strokeWidth: "0"
})));

/* eslint-disable max-len */
var IconGoogle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.76,12.23a12.54,12.54,0,0,0-.17-2H12.15v3.85h5.4a4.63,4.63,0,0,1-2,3v2.5h3.22A9.8,9.8,0,0,0,21.76,12.23Z",
  fill: "#4285f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.15,22a9.61,9.61,0,0,0,6.63-2.41l-3.22-2.5a6.08,6.08,0,0,1-9-3.17H3.22v2.57A10,10,0,0,0,12.15,22Z",
  fill: "#34a853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.54,13.92a6,6,0,0,1,0-3.83V7.51H3.22a10,10,0,0,0,0,9Z",
  fill: "#fbbc04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.15,6A5.42,5.42,0,0,1,16,7.46h0L18.84,4.6A9.57,9.57,0,0,0,12.15,2,10,10,0,0,0,3.22,7.51l3.32,2.58A6,6,0,0,1,12.15,6Z",
  fill: "#ea4335"
}))));

/* eslint-disable max-len */
const IconGridView = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    strokeOpacity: "0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2.15V22H21.85V2.15ZM8,20H4V16H8Zm0-6H4V10H8ZM8,8H4V4H8Zm6,12H10V16h4Zm0-6H10V10h4Zm0-6H10V4h4Zm6,12H16V16h4Zm0-6H16V10h4Zm0-6H16V4h4Z"
  })));
};

/* eslint-disable max-len */
var IconHalfCircle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 50 50",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
})));

/* eslint-disable max-len */
const IconHalfmoon = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.33.5a14.27,14.27,0,0,1,5.81,1.23,12,12,0,1,0,4.27,23.33A14.35,14.35,0,1,1,17.33.5Z"
  })));
};

/* eslint-disable max-len */
var IconHistory = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 4 C 11.832031 4 8.152344 6.113281 6 9.34375 L 6 6 L 4 6 L 4 13 L 11 13 L 11 11 L 7.375 11 C 9.101563 8.019531 12.296875 6 16 6 C 21.535156 6 26 10.464844 26 16 C 26 21.535156 21.535156 26 16 26 C 10.464844 26 6 21.535156 6 16 L 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 C 28 9.382813 22.617188 4 16 4 Z M 15 8 L 15 17 L 22 17 L 22 15 L 17 15 L 17 8 Z"
})));

/* eslint-disable max-len */
const IconHotel = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.24,28V.83H4.72V28H4v1.17H26V28ZM10.52,24.2H7.3V19.68h3.22Zm0-7.76H7.3V11.92h3.22Zm0-7.77H7.3V4.15h3.22Zm6.07,18.2H13.37V19.68h3.22Zm0-10.43H13.37V11.92h3.22Zm0-7.77H13.37V4.15h3.22ZM22.66,24.2H19.44V19.68h3.22Zm0-7.76H19.44V11.92h3.22Zm0-7.77H19.44V4.15h3.22Z"
  })));
};

/* eslint-disable max-len */
const IconHotelBed = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
  })));
};

/* eslint-disable max-len */
var IconHotelLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,4,8,6l2,2,2-2Zm2,2,2,2,2-2L14,4Zm4,0,2,2,2-2L18,4Zm4,0,2,2,2-2L22,4Zm2,2H5V28H27V8ZM7,10H25V26H19V21H13v5H7Zm2,2v2h2V12Zm4,0v2h2V12Zm4,0v2h2V12Zm4,0v2h2V12ZM9,15v2h2V15Zm4,0v2h2V15Zm4,0v2h2V15Zm4,0v2h2V15ZM9,18v2h2V18Zm4,0v2h2V18Zm4,0v2h2V18Zm4,0v2h2V18ZM9,21v2h2V21Zm12,0v2h2V21Zm-6,2h2v3H15Z"
})));

var IconInfo = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
})));

var IconInfoLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z"
})));

/* eslint-disable max-len */
const IconJet = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 29.26 25.26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57,17.49c2.75-1.64,11.77-5.84,11.77-5.84,0-2.9.23-6.4.87-8.18.23-.8.58-1.07.86-1.07s.63.27.87,1.07c.64,1.79.83,5.28.86,8.18,0,0,9,4.21,11.76,5.85.37.22,1.29.76,1.12,1.31-.11.32-.43.51-1.77.21l-11-2.27c-.17,2.41-.29,2.48-.63,5.29a7.9,7.9,0,0,0,.14,3,14,14,0,0,0,2.53,2.31c.18.15.12.27-.13.27l-3.54-.4h-.37l-3.55.4c-.24,0-.3-.12-.13-.28a14.29,14.29,0,0,0,2.53-2.3,7.94,7.94,0,0,0,.15-3c-.33-2.8-.45-2.87-.63-5.29L2.23,19c-1.34.31-1.67.12-1.77-.21C.28,18.25,1.2,17.71,1.57,17.49Z",
    transform: "translate(-0.43 -2.4)"
  })));
};

/* eslint-disable max-len */
var IconKeyboard = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.47,5A1.52,1.52,0,0,0,1,6.56V17.44A1.52,1.52,0,0,0,2.47,19H21.53A1.52,1.52,0,0,0,23,17.44V6.56A1.52,1.52,0,0,0,21.53,5Zm0,1.56H21.53V17.44H2.47ZM3.93,8.11V9.67H5.4V8.11Zm2.94,0V9.67H8.33V8.11Zm2.93,0V9.67h1.47V8.11Zm2.93,0V9.67H14.2V8.11Zm2.94,0V9.67h1.46V8.11Zm2.93,0V9.67h1.47V8.11ZM3.93,11.22v1.56H6.87V11.22Zm4.4,0v1.56H9.8V11.22Zm2.94,0v1.56h1.46V11.22Zm2.93,0v1.56h1.47V11.22Zm2.93,0v1.56h2.94V11.22ZM3.93,14.33v1.56H6.87V14.33Zm4.4,0v1.56h7.34V14.33Zm8.8,0v1.56h2.94V14.33Z"
})));

var IconLieFlatPod = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "7.5",
  cy: "10.5",
  r: "2.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.36,7H11.09v7H3.82V7H2V17H22V11A3.83,3.83,0,0,0,18.36,7Z"
})));

var IconLieFlatSeat = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22,11v2H9V7h9A4,4,0,0,1,22,11ZM2,14v2H8v2h8V16h6V14Zm5.14-1.9a3,3,0,1,0-4.24,0A3,3,0,0,0,7.14,12.1Z"
})));

var IconLieFlatSuite = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24,4H8L2,10v1H4.15v-.11L8.89,6.15H23.11l4.74,4.74V11H30V10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,18.33V21H12V13H24.46A5.44,5.44,0,0,1,30,18.33Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "2 22 2 25 10.4 25 10.4 28 21.6 28 21.6 25 30 25 30 22 2 22"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.42,19.8a3.89,3.89,0,0,0-.05-5.65,4.27,4.27,0,0,0-5.87,0,3.9,3.9,0,0,0,0,5.66A4.27,4.27,0,0,0,9.42,19.8Z"
})));

/* eslint-disable max-len */
var IconLineHotel = props => /*#__PURE__*/React.createElement(GraphicIcon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 100 100",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M96.16,87.29H3.84a1.86,1.86,0,0,0,0,3.71H96.16a1.86,1.86,0,0,0,0-3.71Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.56,38.91a1.84,1.84,0,1,0-3.68,0v4.76a1.84,1.84,0,1,0,3.68,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.12,38.91a1.84,1.84,0,1,0-3.68,0v4.76a1.84,1.84,0,1,0,3.68,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.56,54.23a1.84,1.84,0,1,0-3.68,0V59a1.84,1.84,0,1,0,3.68,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.12,54.23a1.84,1.84,0,1,0-3.68,0V59a1.84,1.84,0,1,0,3.68,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.72,67.7a1.86,1.86,0,0,0-1.84,1.85v4.76a1.84,1.84,0,1,0,3.68,0V69.55A1.86,1.86,0,0,0,54.72,67.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.28,67.7a1.86,1.86,0,0,0-1.84,1.85v4.76a1.84,1.84,0,1,0,3.68,0V69.55A1.86,1.86,0,0,0,45.28,67.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.28,83.26a1.82,1.82,0,0,0,1.84-1.85V29.8L62.8,14.16V81.41a1.84,1.84,0,1,0,3.68,0V10.85a1.77,1.77,0,0,0-1-1.61,1.88,1.88,0,0,0-1.84,0L34.32,27.14a1.86,1.86,0,0,0-.88,1.61V81.41A1.87,1.87,0,0,0,35.28,83.26Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.56,54.23a1.87,1.87,0,0,0-1.84-1.85,1.81,1.81,0,0,0-1.84,1.85V59a1.86,1.86,0,0,0,1.84,1.85A1.81,1.81,0,0,0,80.56,59Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.8,67.7A1.86,1.86,0,0,0,77,69.55v4.76a1.86,1.86,0,0,0,1.84,1.85,1.81,1.81,0,0,0,1.84-1.85V69.55A1.92,1.92,0,0,0,78.8,67.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.6,42.3,87.52,52V81.41a1.84,1.84,0,1,0,3.68,0V51a1.85,1.85,0,0,0-.88-1.61L73.52,39.16A1.84,1.84,0,1,0,71.6,42.3Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23,54.23a1.87,1.87,0,0,0-1.84-1.85,1.81,1.81,0,0,0-1.84,1.85V59a1.86,1.86,0,0,0,1.84,1.85A1.81,1.81,0,0,0,23,59Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2,67.7a1.86,1.86,0,0,0-1.84,1.85v4.76a1.86,1.86,0,0,0,1.84,1.85A1.81,1.81,0,0,0,23,74.31V69.55A1.81,1.81,0,0,0,21.2,67.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.8,51v30.4a1.84,1.84,0,1,0,3.68,0V52.06L28.4,42.38A2,2,0,0,0,29,39.8a1.9,1.9,0,0,0-2.56-.64L9.68,49.4A1.85,1.85,0,0,0,8.8,51Z"
}))));

/* eslint-disable max-len */
var IconLineCar = props => /*#__PURE__*/React.createElement(GraphicIcon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 100 100",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("title", null, "IconLineCar"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.58,51a7.24,7.24,0,1,0,7.19,7.24A7.19,7.19,0,0,0,19.58,51Zm0,10.07a2.83,2.83,0,1,1,2.81-2.83A2.81,2.81,0,0,1,19.58,61Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79,51a7.24,7.24,0,1,0,7.18,7.24A7.2,7.2,0,0,0,79,51ZM79,61a2.83,2.83,0,1,1,2.81-2.83A2.81,2.81,0,0,1,79,61Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.69,35.71a6.63,6.63,0,0,0-6.32-4.64,6.18,6.18,0,0,0-2,.31l-3.83,1.26L79,18.8l-2-.71C69.57,15.49,58.64,14,47.94,14s-20.08,1.49-26.56,4.17l-1.8.71L13.41,33.35l-2.73-.86a5.72,5.72,0,0,0-2-.32,6.65,6.65,0,0,0-6.33,4.64,6.48,6.48,0,0,0,.47,5.12,6.54,6.54,0,0,0,3.9,3.3l.71.24-.47.86a23.46,23.46,0,0,0-2.66,9.28c-.08,1.5,0,4.57.08,7.48l.08,16.36v.16A13.35,13.35,0,0,0,4.9,84a4.44,4.44,0,0,0,4.45,3H19a4.35,4.35,0,0,0,4.45-3,12.88,12.88,0,0,0,.47-4.4v-2c11.32,1,18.59,1.49,25.78,1.49h0c7.1,0,14.13-.47,24.91-1.49v1.89a13.35,13.35,0,0,0,.47,4.4,4.46,4.46,0,0,0,4.45,3H89.1a4.35,4.35,0,0,0,4.45-3,12.88,12.88,0,0,0,.47-4.4l.08-16.29v-.15c.24-3,.39-6.14.39-8a22.52,22.52,0,0,0-2.58-9.6l-.46-1,2.1-.63A6.42,6.42,0,0,0,97.69,35.71ZM22.86,22.42l.16-.08C29,19.9,37.86,18.56,47.86,18.56c10.31,0,20.7,1.42,27.81,3.86l.15.08L81.21,34c-9.53,2.52-20.7,2.6-26.32,2.6H50.51c-12.34,0-24,.08-32.88-1.89ZM19.43,79.68a14.31,14.31,0,0,1-.16,2.84H9.11A15.25,15.25,0,0,1,9,79.68V75.91a5.54,5.54,0,0,0,2.19.71c3,.31,5.7.55,8.28.78v2.28Zm70.06-.15v.15a15.25,15.25,0,0,1-.15,2.84H79.26a14.31,14.31,0,0,1-.16-2.84V77.4c2.43-.23,5-.47,7.82-.7a5.46,5.46,0,0,0,2.73-1Zm2.58-39.65-7,2.28,2.81,5.74A18.72,18.72,0,0,1,90,55.53c.08,1.5-.15,4.33-.31,6.93h-.08v.86c-.08,1.65-.23,3.23-.23,4.33-.08,1.81-1.25,4.48-3,4.64-18.28,1.73-27.5,2.6-36.79,2.6h0c-9.38,0-19-.87-38.12-2.68-1.41-.16-2-2.44-2.27-3.77s-.31-3.31-.39-5.35v-.55h0c-.08-2.6-.15-5.2-.08-6.61a19.75,19.75,0,0,1,2-7.32l3-5.58L7.94,41.14A2,2,0,0,1,6.69,40a2.43,2.43,0,0,1-.15-1.65,2.18,2.18,0,0,1,2.11-1.58,1.48,1.48,0,0,1,.62.08L15.83,39l.08-.08c8.36,2,19,2.12,30.39,2.12H55c5.93,0,18,0,28.27-2.91h0l1.88-.63h0l5.7-1.81a1.71,1.71,0,0,1,.63-.08,2.25,2.25,0,0,1,2.1,1.58A2.31,2.31,0,0,1,92.07,39.88Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "31.22",
  y: "62.22",
  width: "36.56",
  height: "4.48"
}), /*#__PURE__*/React.createElement("rect", {
  x: "31.22",
  y: "52.78",
  width: "36.56",
  height: "4.48"
}))));

/* eslint-disable max-len */
const IconListView = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    strokeOpacity: "0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2.15V8H7.85V2.15ZM6,6H4V4H6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "9",
    y: "4",
    width: "13",
    height: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,9v6H8V9Zm4,4H4V11H6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "9",
    y: "11",
    width: "13",
    height: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,16.07V22H7.93V16.07ZM6,20H4V18H6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "9",
    y: "18",
    width: "13",
    height: "2"
  })));
};

/* eslint-disable max-len */
var IconLiveTV = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.42,13.24H7V12h4.37v1.22H9.88v4.29H8.42Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.88,12h1.54L14,14.43c.08.29.15.58.21.86s.12.58.2.88h0c.08-.3.15-.59.21-.88s.13-.57.2-.86L15.4,12h1.49l-1.63,5.51H13.5Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.18,7.11H13.66l3-3.06-1-1L12,6.72,8.36,3l-1,1,3,3.06H3.82A1.84,1.84,0,0,0,2,9V20.14A1.85,1.85,0,0,0,3.82,22H20.18A1.85,1.85,0,0,0,22,20.14V9A1.84,1.84,0,0,0,20.18,7.11Zm0,13H3.82V9H20.18Z"
})));

/* eslint-disable max-len */
var IconLocation = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 3 C 11.042969 3 7 7.042969 7 12 C 7 13.40625 7.570313 15.019531 8.34375 16.78125 C 9.117188 18.542969 10.113281 20.414063 11.125 22.15625 C 13.148438 25.644531 15.1875 28.5625 15.1875 28.5625 L 16 29.75 L 16.8125 28.5625 C 16.8125 28.5625 18.851563 25.644531 20.875 22.15625 C 21.886719 20.414063 22.882813 18.542969 23.65625 16.78125 C 24.429688 15.019531 25 13.40625 25 12 C 25 7.042969 20.957031 3 16 3 Z M 16 5 C 19.878906 5 23 8.121094 23 12 C 23 12.800781 22.570313 14.316406 21.84375 15.96875 C 21.117188 17.621094 20.113281 19.453125 19.125 21.15625 C 17.554688 23.867188 16.578125 25.300781 16 26.15625 C 15.421875 25.300781 14.445313 23.867188 12.875 21.15625 C 11.886719 19.453125 10.882813 17.621094 10.15625 15.96875 C 9.429688 14.316406 9 12.800781 9 12 C 9 8.121094 12.121094 5 16 5 Z M 16 10 C 14.894531 10 14 10.894531 14 12 C 14 13.105469 14.894531 14 16 14 C 17.105469 14 18 13.105469 18 12 C 18 10.894531 17.105469 10 16 10 Z"
})));

/* eslint-disable max-len */
var IconLock = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  width: "24px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
})));

/* eslint-disable max-len */
var IconLuggage = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: "24",
  width: "24"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17,6h-2V3c0-0.55-0.45-1-1-1h-4C9.45,2,9,2.45,9,3v3H7C5.9,6,5,6.9,5,8v11c0,1.1,0.9,2,2,2c0,0.55,0.45,1,1,1 c0.55,0,1-0.45,1-1h6c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1c1.1,0,2-0.9,2-2V8C19,6.9,18.1,6,17,6z M9.5,18H8V9h1.5V18z M12.75,18 h-1.5V9h1.5V18z M13.5,6h-3V3.5h3V6z M16,18h-1.5V9H16V18z"
}))));

/* eslint-disable max-len */
var IconLuggageLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14,2c-1.65,0-3,1.57-3,3.5v3.5h2v-3.5c0-.64.45-1.17,1-1.17h4c.55,0,1,.52,1,1.17v3.5h2v-3.5c0-1.93-1.35-3.5-3-3.5h-4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6,11v16.76h2.22v2.24h2.22v-2.24h11.11v2.24h2.22v-2.24h2.22V11H6Zm18,15H8v-13h16v13Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "10",
  y: "16",
  width: "11.96",
  height: "2"
}), /*#__PURE__*/React.createElement("rect", {
  x: "10",
  y: "21.04",
  width: "11.96",
  height: "1.96"
})));

/* eslint-disable max-len */
var IconMagnifyingGlass = props => /*#__PURE__*/React.createElement(GraphicIcon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 100 100",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1133.000000, -1112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(133.000000, 1018.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(953.000000, 94.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 16.382470)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69,44.1c-1.3,1.3-2.6,2.6-3.8,3.8c0.9,0.9,1.9,1.9,2.7,2.7c1.2-1.2,2.5-2.5,3.8-3.7\r C70.8,46,69.9,45,69,44.1 M67.8,58c3.8-3.8,7.5-7.5,11.2-11.2c-0.6-0.6-1.2-1.3-1.7-1.8c-3.7,3.7-7.5,7.5-11.2,11.2\r C66.6,56.8,67.3,57.5,67.8,58 M71.7,58.1c-0.1,0-0.3,0-0.4,0c0.4,0.3,0.8,0.5,1.1,0.8c2.5,2.5,5,5.1,7.6,7.6\r c2.2,2.2,5.7,2.1,7.8,0c2.2-2.2,2.1-5.4-0.2-7.7c-1.1-1.1-2.2-2.2-3.2-3.2c-1.7-1.7-3.5-3.5-5.3-5.3\r C76.6,52.9,74.1,55.5,71.7,58.1 M70.4,41.9c1.1,1.1,2.1,2.1,3.3,3.3c0.7-0.8,1.5-1.7,2.3-2.5c0.9-0.9,1.4-0.9,2.3,0\r c1,1,2,2,3,3c1.1,1.1,1.1,1.4,0,2.5c-0.2,0.2-0.4,0.4-0.6,0.6c0.2,0.3,0.4,0.5,0.7,0.7c2.6,2.6,5.2,5.2,7.8,7.8\r c3,3,3.3,7,0.8,10.3c-0.1,0.1-0.2,0.3-0.4,0.7c0.5,0,0.9,0,1.2,0c2.5,0,4.9,0,7.4,0c0.8,0,1.5,0.2,1.5,1.2\r c0,0.8-0.5,1.2-1.5,1.2c-0.2,0-0.4,0-0.6,0c-31.8,0-63.7,0-95.5,0c-0.4,0-0.9,0.1-1.2-0.1C0.4,70.4,0,69.9,0,69.5\r s0.5-0.9,0.9-1.1c0.3-0.2,0.8-0.1,1.3-0.1c25,0,49.9,0,74.9,0h1.3c-2.9-2.9-5.8-5.7-8.6-8.5c0,0-0.1,0.1-0.2,0.2\r c-1.5,1.4-1.5,1.4-2.9,0c-0.9-0.9-1.8-1.8-2.7-2.7c-0.8-0.8-0.8-1.7,0-2.5c0.8-0.8,1.6-1.5,2.4-2.4c-1-1-2-2-3-3\r c-0.1-0.1-0.7,0.1-0.9,0.2c-3.7,2.6-7.7,4.3-12,5.3c-14.8,3.5-30.8-3.6-38.1-17c-0.9-1.7-1.7-3.5-2.4-5.3\r c-0.4-1.1-0.2-1.7,0.5-1.9c1-0.2,1.3,0.4,1.5,1.1C14.7,39.2,19.4,45,26.2,49c15.2,9.2,35.5,4.2,44.4-11.2\r c6.7-11.6,6.2-23.3-0.9-34.6c-0.2-0.3-0.4-0.6-0.6-0.9c-0.4-0.6-0.5-1.2,0.1-1.7s1.2-0.2,1.7,0.4C72.4,3.6,74,6.3,75,9.3\r c3.9,11.4,2.5,22.1-4.3,32C70.6,41.5,70.5,41.7,70.4,41.9"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.5,37.7c0,14.4,11.7,26.1,26.1,26.1s26.2-11.7,26.1-26.2c0-14.4-11.7-26.1-26.1-26.1\r C28.2,11.6,16.4,23.3,16.5,37.7 M14.2,37.7C14.2,22,26.9,9.3,42.6,9.3S70.9,22,70.9,37.7C70.8,53.4,58.2,66,42.5,66\r C26.9,66,14.2,53.3,14.2,37.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.9,38.3c0-14.9,8.5-27.8,22.3-32.8c13-4.7,24.9-2.1,35.5,6.8c0.6,0.5,0.9,1.1,0.3,1.8\r c-0.4,0.6-1.2,0.5-1.9-0.1c-3.5-3.1-7.4-5.5-11.9-7c-18.2-5.7-37,5.3-41.4,23.5c-0.9,3.8-1,7.5-0.6,11.4\r c0.1,0.9-0.4,1.6-1.1,1.3c-0.4-0.1-0.9-0.7-0.9-1.1C7.9,40.9,7.9,39.6,7.9,38.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.7,93.3c-11.2,0-22.4,0-33.6,0c-0.4,0-0.7,0-1.1,0c-0.6,0-1-0.4-1-1\r c-0.1-0.6,0.2-1.1,0.8-1.3c0.3-0.1,0.7-0.1,1-0.1c22.6,0,45.1,0,67.7,0c0.3,0,0.7,0,1,0.1c0.6,0.2,1,0.7,0.8,1.3\r c-0.1,0.4-0.6,0.8-1,1c-0.3,0.2-0.7,0-1.1,0C72.1,93.3,60.9,93.3,49.7,93.3"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.294821, 96.860558)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6,2.8c-4.5,0-9,0-13.4,0c-0.3,0-0.7,0.1-0.9,0C0.9,2.4,0.5,2,0.4,1.6\r C0.2,1,0.6,0.5,1.3,0.4c0.3-0.1,0.7,0,1,0c8.9,0,17.8,0,26.7,0c1.4,0,2,0.3,2,1.2c0,0.8-0.6,1.2-2,1.2\r C24.5,2.8,20,2.8,15.6,2.8"
})), /*#__PURE__*/React.createElement("path", {
  d: "M67,99.6c-1.5,0-3,0-4.5,0c-0.8,0-1.4-0.3-1.4-1.2c0-0.9,0.6-1.2,1.4-1.2c3,0,6,0,9.1,0\r c0.8,0,1.3,0.3,1.3,1.1c0,0.9-0.5,1.2-1.3,1.3C70,99.6,68.5,99.6,67,99.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.7,27.3h-5.6v1.2c0,7.3,0,14.6,0,21.9c0,0.3,0,0.5,0,0.8c0,0.8-0.4,1.3-1.2,1.2\r c-0.7,0-1.2-0.4-1.2-1.2s0-1.6,0-2.4c0-4.8,0-9.6,0-14.3c0-0.8-0.2-1.1-1.1-1.1c-1.5,0.1-2.9,0-4.5,0c0,0.5-0.1,0.8-0.1,1.2\r c0,5.3,0,10.6,0,15.8c0,0.3,0.1,0.7-0.1,1c-0.3,0.4-0.7,0.9-1.1,0.9c-0.4,0-0.9-0.5-1.2-0.9c-0.2-0.3-0.1-0.8-0.1-1.3\r c0-9.3,0-18.5,0-27.8V21c-1.8,0-3.5,0-5.1,0c-0.1,0-0.4,0.3-0.4,0.5c-0.1,0.3,0,0.6,0,0.9c0,9.4,0,18.8,0,28.2\r c0,0.4,0.1,0.8-0.1,1.1c-0.2,0.4-0.7,0.9-1.1,0.9c-0.4,0-0.9-0.4-1.2-0.8c-0.2-0.2-0.1-0.7-0.1-1.1c0-3.2,0-6.4,0-9.6V40\r c-1.8,0-3.5,0-5.1,0c-0.2,0-0.4,0.6-0.4,0.9c0,3.2,0,6.4,0,9.7c0,0.3,0,0.7,0,1c0,0.6-0.3,1-1,1.1s-1.2-0.2-1.4-0.9\r c-0.1-0.2-0.1-0.5-0.1-0.8c0-3.9,0-7.7,0-11.6c0-1.3,0.4-1.7,1.7-1.7c2,0,4.1,0,6.3,0v-1.3c0-5.3,0-10.6,0-15.8\r c0-1.5,0.3-1.9,1.9-1.9c2.3,0,4.6,0,6.9,0c1.2,0,1.5,0.4,1.5,1.5c0,3.3,0,6.6,0,10v1.1h5.6c0-1.5,0-3,0-4.5\r c0-1.6,0.3-1.9,1.9-1.9c2.2,0,4.4,0,6.6,0c1.4,0,2.1,0.6,2.1,2c0,7.9,0,15.9,0,23.8c0,0.2,0,0.4,0,0.6c0,0.7-0.5,1.1-1.2,1.1\r s-1.1-0.4-1.2-1.1c0-0.5,0-1.1,0-1.6c0-7.1,0-14.1,0-21.2L56.7,27.3L56.7,27.3z"
})))))));

/* eslint-disable max-len */
var IconMarketingBubbles = props => /*#__PURE__*/React.createElement(GraphicIcon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 309 393",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: "167",
  cy: "24.56",
  r: "22.06",
  fill: "#15203d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167,3a21.56,21.56,0,1,1-21.56,21.56A21.56,21.56,0,0,1,167,3m0-1a22.56,22.56,0,1,0,22.56,22.56A22.59,22.59,0,0,0,167,2Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: "67.11",
  cy: "301.08",
  r: "13.5",
  fill: "#15203d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.11,287.83a13.25,13.25,0,1,1-13.25,13.25,13.25,13.25,0,0,1,13.25-13.25m0-.5a13.75,13.75,0,1,0,13.75,13.75,13.77,13.77,0,0,0-13.75-13.75Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: "39.25",
  cy: "180.92",
  r: "36.25",
  fill: "#15203d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.25,145.67A35.25,35.25,0,1,1,4,180.92a35.25,35.25,0,0,1,35.25-35.25m0-2A37.25,37.25,0,1,0,76.5,180.92a37.29,37.29,0,0,0-37.25-37.25Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: "227.25",
  cy: "353.25",
  r: "36.25",
  fill: "#15203d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.25,318A35.25,35.25,0,1,1,192,353.25,35.25,35.25,0,0,1,227.25,318m0-2a37.25,37.25,0,1,0,37.25,37.25A37.29,37.29,0,0,0,227.25,316Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: "255.33",
  cy: "84.33",
  r: "50.33",
  transform: "translate(15.15 205.25) rotate(-45)",
  fill: "#15203d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.33,35A49.34,49.34,0,1,1,206,84.33,49.34,49.34,0,0,1,255.33,35m0-2a51.34,51.34,0,1,0,51.34,51.33A51.39,51.39,0,0,0,255.33,33Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: "169.78",
  cy: "193.78",
  r: "112.39",
  transform: "translate(-87.29 176.81) rotate(-45)",
  fill: "#0a61ce"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.78,82.89A110.89,110.89,0,1,1,58.89,193.78,110.89,110.89,0,0,1,169.78,82.89m0-3a113.9,113.9,0,1,0,80.53,33.36,113.15,113.15,0,0,0-80.53-33.36Z",
  fill: "#fff"
}))));

/* eslint-disable max-len */
var IconMap = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 22 3 C 18.699219 3 16 5.699219 16 9 C 16 9.992188 16.382813 11.003906 16.875 12.125 C 17.367188 13.246094 17.988281 14.433594 18.625 15.53125 C 19.898438 17.726563 21.1875 19.5625 21.1875 19.5625 L 22 20.75 L 22.8125 19.5625 C 22.8125 19.5625 24.101563 17.726563 25.375 15.53125 C 26.011719 14.433594 26.632813 13.246094 27.125 12.125 C 27.617188 11.003906 28 9.992188 28 9 C 28 5.699219 25.300781 3 22 3 Z M 11.96875 4.9375 L 4 8.34375 L 4 27.53125 L 12.03125 24.0625 L 20.03125 27.0625 L 28 23.65625 L 28 14.9375 C 27.363281 16.160156 26.65625 17.332031 26 18.375 L 26 22.34375 L 21 24.46875 L 21 22.84375 L 19.53125 20.71875 C 19.375 20.492188 19.191406 20.222656 19 19.9375 L 19 24.5625 L 13 22.3125 L 13 7.4375 L 14.09375 7.84375 C 14.191406 7.167969 14.367188 6.515625 14.625 5.90625 Z M 22 5 C 24.21875 5 26 6.78125 26 9 C 26 9.386719 25.757813 10.300781 25.3125 11.3125 C 24.867188 12.324219 24.238281 13.472656 23.625 14.53125 C 22.808594 15.9375 22.457031 16.4375 22 17.125 C 21.542969 16.4375 21.191406 15.9375 20.375 14.53125 C 19.761719 13.472656 19.132813 12.324219 18.6875 11.3125 C 18.242188 10.300781 18 9.386719 18 9 C 18 6.78125 19.78125 5 22 5 Z M 11 7.5 L 11 22.34375 L 6 24.46875 L 6 9.65625 Z M 22 7.5 C 21.171875 7.5 20.5 8.171875 20.5 9 C 20.5 9.828125 21.171875 10.5 22 10.5 C 22.828125 10.5 23.5 9.828125 23.5 9 C 23.5 8.171875 22.828125 7.5 22 7.5 Z"
})));

/* eslint-disable max-len */
var IconMeal = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.23,20.6l-.57-9.08c.09-.34,1.26-2.38,1.32-3.76,0,0,.36-5.81-3.51-5.65l.18,6.81c0,.06-.16,11.7-.16,11.7a1.34,1.34,0,0,0,1.4,1.28A1.28,1.28,0,0,0,17.23,20.6Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.9,9.27a2.53,2.53,0,0,0,2-2.28l0-4.62a.46.46,0,0,0-.91,0l0,3.32a.42.42,0,0,1-.46.37.41.41,0,0,1-.45-.37l0-3.41A.31.31,0,0,0,9.78,2a.32.32,0,0,0-.34.28l0,3.41A.43.43,0,0,1,9,6.06a.41.41,0,0,1-.45-.37l0-3.41A.3.3,0,0,0,8.2,2a.32.32,0,0,0-.34.28l0,3.41a.44.44,0,0,1-.46.37.42.42,0,0,1-.45-.37L7,2.37A.42.42,0,0,0,6.5,2a.42.42,0,0,0-.45.37L6,7A2.48,2.48,0,0,0,8,9.27l-.5,11.42A1.32,1.32,0,0,0,8.83,22a1.31,1.31,0,0,0,1.39-1.29Z",
  fillRule: "evenodd"
})));

/* eslint-disable max-len */
var IconMeeting = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.91,17.79A5.45,5.45,0,0,0,27,13.5,5.51,5.51,0,0,0,21.5,8h-.39l-.5.07a.93.93,0,0,0-.51.5L20,8.72A1.45,1.45,0,0,0,20,9a1,1,0,0,0,1,1h0l.2,0h.3a3.49,3.49,0,0,1,.5,7v2.14c3.29.15,5.93,3.2,6,7H24.74l-.13,0a.91.91,0,0,0-.51.51l-.06.14a1.45,1.45,0,0,0,0,.3,1,1,0,0,0,.79,1H29l.2,0h0a1,1,0,0,0,.75-.76v-.12c0-.06,0-.12,0-.18,0-.24,0-.5,0-.77A9.18,9.18,0,0,0,24.91,17.79Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.57,15.41a6,6,0,1,0-5.2,0A10.88,10.88,0,0,0,2,26a6.75,6.75,0,0,0,.07,1,1.8,1.8,0,0,0,0,.22l0,.2h0a1,1,0,0,0,.73.64H21a1,1,0,0,0,.75-.76.59.59,0,0,0,0-.13.28.28,0,0,0,0-.09V27c0-.31.05-.62.05-1A10.89,10.89,0,0,0,14.57,15.41ZM8,10a4,4,0,1,1,4,4A4,4,0,0,1,8,10ZM19.85,26.06H4c0-5,3.54-9.06,7.92-9.06s7.93,4,7.93,9Z"
})));

const IconMerge = props => {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    rotate: 90
  }, props), /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
  })));
};

/* eslint-disable max-len */
var IconMiddleSeatFree = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.55,16.12a2,2,0,0,0-1.88-1.28H10.18c0-.09,0-.2-.07-.33S10,14,9.77,13.32l6-.52c.42,0,.71-.14.71-.48s-.42-.44-.84-.44H9.37C8.79,9.81,8.07,7.19,8,6.7a15,15,0,0,1-.16-2.56A2.94,2.94,0,0,0,5.5,2.28C4.2,2,3.85,1.77,4.05,2.53l4,12.32a1,1,0,0,0,.39.63.85.85,0,0,0-.09.38v.26c0,.57.63.7,1.28.7l3.65.21v3.55H10.92a.31.31,0,0,0-.32.29v.85a.31.31,0,0,0,.32.28h6.27a.3.3,0,0,0,.32-.28v-.85a.3.3,0,0,0-.32-.29H14.82V17.13l4.78.28C20.24,17.41,20,17.16,19.55,16.12Z"
})));

/* eslint-disable max-len */
var IconMinimize = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.08,10H19.92a2,2,0,1,1,0,4H4.08a2,2,0,1,1,0-4Z"
})));

/* eslint-disable max-len */
const IconMoney = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 15.85 28.03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.62,13.3C12.09,12.38,11,11.43,11,10c0-1.69,1.57-2.88,4.2-2.88s3.8,1.33,3.9,3.27h3.44a6.21,6.21,0,0,0-5-5.93V1H12.82V4.36C9.8,5,7.37,7,7.37,10c0,3.59,3,5.38,7.32,6.43,3.89.93,4.67,2.3,4.67,3.75,0,1.07-.76,2.79-4.21,2.79-3.2,0-4.47-1.43-4.64-3.27H7.09c.18,3.41,2.74,5.32,5.73,6V29h4.67V25.68c3-.57,5.45-2.33,5.45-5.53C22.94,15.73,19.16,14.22,15.62,13.3Z",
    transform: "translate(-7.09 -1)"
  })));
};

/* eslint-disable max-len */
var IconMoneySlash = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m3.29,4.71l2.29,2.29c-1.98,0-3.59,1.62-3.59,3.6v10.8c0,1.99,1.61,3.6,3.6,3.6h17.99l3.71,3.71,1.41-1.41L4.71,3.29l-1.41,1.41Zm2.31,18.29c-.88,0-1.6-.72-1.6-1.6v-10.8c0-.88.72-1.6,1.6-1.6h1.99l4.97,4.97c-.35.59-.56,1.28-.56,2.03,0,2.21,1.79,4,4,4,.74,0,1.43-.21,2.03-.56l3.56,3.56H5.6Zm10.91-5.08c-.16.04-.33.08-.51.08-1.1,0-2-.9-2-2,0-.18.03-.35.08-.51l2.43,2.43Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "8.5",
  cy: "15.5",
  r: "1.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "23.5",
  cy: "15.5",
  r: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.4,7h-13.4l2,2h11.4c.88,0,1.6.72,1.6,1.6v10.8c0,.18-.04.35-.09.51l1.49,1.49c.38-.57.61-1.26.61-2v-10.8c0-1.99-1.61-3.6-3.6-3.6Z"
})));

/* eslint-disable max-len */
var IconMSTeams = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 2 C 14.416667 2 13.101892 2.6297556 12.251953 3.5859375 C 11.402014 4.5421194 11 5.7777779 11 7 C 11 8.0568215 11.320353 9.1124493 11.951172 10 L 1 10 L 1 11 L 1 25 L 8.5878906 25 C 9.7771929 27.932591 12.652284 30 16 30 C 19.378243 30 22.242463 27.87368 23.412109 24.902344 C 24.308711 25.533813 25.325569 26 26.5 26 C 29.525577 26 32 23.525577 32 20.5 L 32 14 L 24 14 L 23 14 L 16 14 L 16 12 C 17.583333 12 18.898108 11.370244 19.748047 10.414062 C 20.597986 9.4578811 21 8.2222221 21 7 C 21 5.7777779 20.597986 4.5421194 19.748047 3.5859375 C 18.898108 2.6297556 17.583333 2 16 2 z M 16 4 C 17.083333 4 17.768559 4.3702444 18.251953 4.9140625 C 18.735347 5.4578806 19 6.2222221 19 7 C 19 7.7777779 18.735347 8.5421194 18.251953 9.0859375 C 17.768559 9.6297556 17.083333 10 16 10 C 14.916667 10 14.231441 9.6297556 13.748047 9.0859375 C 13.264653 8.5421194 13 7.7777779 13 7 C 13 6.2222221 13.264653 5.4578806 13.748047 4.9140625 C 14.231441 4.3702444 14.916667 4 16 4 z M 26.5 5 C 25.416667 5 24.476892 5.4422556 23.876953 6.1171875 C 23.277014 6.7921194 23 7.6527779 23 8.5 C 23 9.3472221 23.277014 10.207881 23.876953 10.882812 C 24.476892 11.557745 25.416667 12 26.5 12 C 27.583333 12 28.523108 11.557744 29.123047 10.882812 C 29.722986 10.207882 30 9.3472221 30 8.5 C 30 7.6527779 29.722986 6.7921194 29.123047 6.1171875 C 28.523108 5.4422556 27.583333 5 26.5 5 z M 26.5 7 C 27.083333 7 27.393559 7.1827444 27.626953 7.4453125 C 27.860347 7.7078806 28 8.0972221 28 8.5 C 28 8.9027779 27.860347 9.2921194 27.626953 9.5546875 C 27.393559 9.8172556 27.083333 10 26.5 10 C 25.916667 10 25.606441 9.8172556 25.373047 9.5546875 C 25.139653 9.2921194 25 8.9027779 25 8.5 C 25 8.0972221 25.139653 7.7078806 25.373047 7.4453125 C 25.606441 7.1827444 25.916667 7 26.5 7 z M 3 12 L 14 12 L 14 23 L 3 23 L 3 12 z M 5 14 L 5 16 L 7 16 L 7 21 L 9 21 L 9 16 L 11 16 L 11 14 L 5 14 z M 16 16 L 22 16 L 22 22 C 22 25.325562 19.325562 28 16 28 C 13.776108 28 11.861135 26.785839 10.824219 25 L 16 25 L 16 16 z M 24 16 L 30 16 L 30 20.5 C 30 22.444423 28.444423 24 26.5 24 C 25.425819 24 24.490167 23.508667 23.847656 22.753906 C 23.873436 22.493441 24 22.267056 24 22 L 24 16 z"
})));

/* eslint-disable max-len */
var IconOutlook = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.39,6.24v3.91l1.36.86h.16l5.88-4a.84.84,0,0,0-.69-.81Z",
  fill: "#d9a603"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.39,11.61l1.25.86a.36.36,0,0,0,.38,0l5.77-3.84v7.19a1,1,0,0,1-1.06,1.11H14.39V11.61Z",
  fill: "#d9a603"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.93,9.81a1.15,1.15,0,0,0-1,.6A2.93,2.93,0,0,0,6.54,12a2.86,2.86,0,0,0,.37,1.58,1.13,1.13,0,0,0,1,.58,1.11,1.11,0,0,0,1-.56A2.83,2.83,0,0,0,9.26,12a3.1,3.1,0,0,0-.36-1.63A1.08,1.08,0,0,0,7.93,9.81Z",
  fill: "#d9a603"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,4.25V19.56L13.65,22V2ZM9.8,14.49a2.3,2.3,0,0,1-1.93,1,2.26,2.26,0,0,1-1.88-1,3.84,3.84,0,0,1-.73-2.45A4.22,4.22,0,0,1,6,9.49a2.33,2.33,0,0,1,2-1,2.25,2.25,0,0,1,1.87.95,4,4,0,0,1,.71,2.48A4.12,4.12,0,0,1,9.8,14.49Z",
  fill: "#d9a603"
}))));

/* eslint-disable max-len */
var IconOutlookOnline = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.39,6.24v3.91l1.36.86h.16l5.88-4a.84.84,0,0,0-.69-.81Z",
  fill: "#0072c6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.39,11.61l1.25.86a.36.36,0,0,0,.38,0l5.77-3.84v7.19a1,1,0,0,1-1.06,1.11H14.39V11.61Z",
  fill: "#0072c6"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.93,9.81a1.15,1.15,0,0,0-1,.6A2.93,2.93,0,0,0,6.54,12a2.86,2.86,0,0,0,.37,1.58,1.13,1.13,0,0,0,1,.58,1.11,1.11,0,0,0,1-.56A2.83,2.83,0,0,0,9.26,12a3.1,3.1,0,0,0-.36-1.63A1.08,1.08,0,0,0,7.93,9.81Z",
  fill: "#0072c6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,4.25V19.56L13.65,22V2ZM9.8,14.49a2.3,2.3,0,0,1-1.93,1,2.26,2.26,0,0,1-1.88-1,3.84,3.84,0,0,1-.73-2.45A4.22,4.22,0,0,1,6,9.49a2.33,2.33,0,0,1,2-1,2.25,2.25,0,0,1,1.87.95,4,4,0,0,1,.71,2.48A4.12,4.12,0,0,1,9.8,14.49Z",
  fill: "#0072c6"
}))));

/* eslint-disable max-len */
var IconPersonalVideo = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "10.5",
  r: "4.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.61,23A10.14,10.14,0,0,0,2.39,23Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "2 2 2 16 5.72 16 5.72 14.23 3.81 14.23 3.81 3.77 20.18 3.77 20.18 14.23 18.28 14.23 18.28 16 22 16 22 2 2 2"
})));

/* eslint-disable max-len */
var IconPhone = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  d: "m17.16535,20.90379c0.66462,0.00794 1.15534,-0.06035 1.61985,-0.28586a6.29599,6.29599 0 0 0 1.40149,-0.93777c0.22313,-0.19613 0.45022,-0.39861 0.62491,-0.63524c0.3065,-0.4137 0.18581,-0.99732 -0.22233,-1.25062c-0.9608,-0.59712 -1.92239,-1.19107 -2.8808,-1.79296c-0.26045,-0.16357 -0.50978,-0.34462 -0.76228,-0.52248c-0.19057,-0.13499 -0.39464,-0.21995 -0.63285,-0.19375c-0.25409,0.027 -0.46055,0.15404 -0.63762,0.32953c-0.28427,0.2803 -0.57171,0.55742 -0.84487,0.84804c-0.24615,0.26204 -0.53916,0.4129 -0.89568,0.43673c-0.39623,0.027 -0.75434,-0.06194 -1.04497,-0.35335c-0.45181,-0.45261 -0.9068,-0.90283 -1.35861,-1.35544a5000.58645,5000.58645 0 0 1 -4.0806,-4.09331a0.99732,0.99732 0 0 1 -0.13896,-0.17707c-0.15325,-0.24695 -0.2001,-0.51931 -0.18501,-0.80596c0.01747,-0.3335 0.13022,-0.62253 0.37082,-0.85836c0.22233,-0.21916 0.44308,-0.44149 0.66303,-0.66382c0.12308,-0.12546 0.25409,-0.24615 0.36209,-0.38352c0.31524,-0.40099 0.28983,-0.85836 -0.05241,-1.23315a1.58412,1.58412 0 0 1 -0.17469,-0.23186c-0.68685,-1.10372 -1.37052,-2.20983 -2.05737,-3.31435a0.81549,0.81549 0 0 0 -0.72814,-0.40338c-0.29062,-0.00079 -0.52328,0.14055 -0.7202,0.34144c-0.35097,0.35732 -0.65588,0.75434 -0.92427,1.17598c-0.374,0.58759 -0.667,1.20457 -0.73449,1.91206a7.6419,7.6419 0 0 0 0.07464,2.13837c0.12943,0.69479 0.35811,1.35861 0.65985,1.99861c0.44149,0.93459 1.014,1.78502 1.64844,2.59653c0.60427,0.7742 1.26095,1.50234 1.93906,2.21301c1.11643,1.17042 2.30591,2.25589 3.64388,3.17063c1.43405,0.97985 2.96179,1.75484 4.66899,2.13678c0.51216,0.11514 1.03067,0.18025 1.39911,0.19454m0.31603,1.02432a10.03198,10.03198 0 0 1 -1.53092,-0.15563c-1.97162,-0.36923 -3.73361,-1.22045 -5.38205,-2.3337c-1.37291,-0.92665 -2.59812,-2.02561 -3.74313,-3.22065c-0.9338,-0.9735 -1.82313,-1.98512 -2.60368,-3.08805c-0.57568,-0.8139 -1.08308,-1.6675 -1.46422,-2.59336a9.49997,9.49997 0 0 1 -0.55266,-1.8541c-0.1334,-0.70511 -0.14849,-1.41499 -0.10878,-2.12725c0.04764,-0.85281 0.34938,-1.62303 0.78452,-2.3472c0.31921,-0.53122 0.68685,-1.0275 1.10849,-1.48169c0.66541,-0.71702 1.85807,-0.86154 2.66641,-0.32715c0.16993,0.11275 0.3073,0.25251 0.41608,0.42879c0.67494,1.09896 1.35623,2.19474 2.03673,3.28973c0.12864,0.20645 0.28824,0.39782 0.39226,0.61618c0.35891,0.75673 0.19931,1.78899 -0.4129,2.37737c-0.30571,0.2938 -0.6003,0.59871 -0.89965,0.89965c-0.16199,0.16278 -0.16278,0.21836 0.00159,0.38273c1.25459,1.26095 2.51157,2.5203 3.76775,3.77966c0.53836,0.53995 1.07911,1.07673 1.61827,1.61509l0.0532,0.0532c0.15881,0.15404 0.21836,0.15404 0.37638,-0.00318c0.30253,-0.30174 0.60348,-0.60586 0.9076,-0.9076c0.38194,-0.37955 0.84804,-0.56377 1.38164,-0.58759a2.15266,2.15266 0 0 1 1.41023,0.43117c0.36526,0.26601 0.75752,0.4939 1.14104,0.7329c0.8004,0.50025 1.60397,0.99573 2.40437,1.49757c0.28824,0.18025 0.45022,0.46452 0.55186,0.77578c0.21916,0.67494 0.15722,1.32606 -0.21916,1.93589c-0.16913,0.27315 -0.41926,0.47166 -0.65985,0.67573c-0.60348,0.51057 -1.24665,0.9608 -1.98512,1.25618c-0.33032,0.13181 -0.66938,0.23345 -1.02988,0.24933c-0.15643,0.00635 -0.31365,0.02223 -0.4264,0.03017m2.67355,-10.26146c0.02541,0.28189 -0.19534,0.51931 -0.46849,0.5471c-0.28586,0.02938 -0.52883,-0.19137 -0.56695,-0.50104c-0.12943,-1.04179 -0.41608,-2.03752 -0.91871,-2.96179c-0.86392,-1.58809 -2.12725,-2.74105 -3.79395,-3.44775a8.28905,8.28905 0 0 0 -2.04149,-0.56695c-0.13261,-0.01906 -0.26759,-0.03573 -0.39544,-0.07385c-0.24298,-0.07146 -0.39941,-0.32397 -0.35732,-0.55583c0.04764,-0.26998 0.25727,-0.45816 0.52407,-0.4407c0.22789,0.01509 0.45578,0.05241 0.6797,0.09529c0.60348,0.11672 1.19425,0.28347 1.76675,0.50978c1.76914,0.70114 3.18889,1.83028 4.20289,3.45013a8.68766,8.68766 0 0 1 1.06164,2.42978c0.11672,0.45022 0.19851,0.90839 0.2938,1.36338c0.01112,0.04923 0.00953,0.10164 0.0135,0.15246",
  id: "svg_2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  d: "m12.17715,6.04718c0.18342,0.03256 0.43037,0.0667 0.67176,0.12228a6.70334,6.70334 0 0 1 1.6675,0.61618a5.83227,5.83227 0 0 1 2.55921,2.65847c0.27236,0.5598 0.4669,1.1466 0.57171,1.76199c0.01985,0.1207 0.04288,0.2406 0.06035,0.36209c0.04288,0.28744 -0.16437,0.5463 -0.46452,0.58362c-0.25727,0.03176 -0.51216,-0.17469 -0.54789,-0.44308c-0.11672,-0.85757 -0.36526,-1.6675 -0.85598,-2.38929c-0.66144,-0.97191 -1.54442,-1.65797 -2.67276,-2.00258c-0.36685,-0.11275 -0.74879,-0.17787 -1.12675,-0.2533c-0.26204,-0.05241 -0.45261,-0.27792 -0.43276,-0.53598c0.02144,-0.27315 0.23821,-0.47802 0.56933,-0.4804",
  id: "svg_3"
}))));

/* eslint-disable max-len */
var IconPhoneHandle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 8.65625 3 C 8.132813 3 7.617188 3.1875 7.1875 3.53125 L 7.125 3.5625 L 7.09375 3.59375 L 3.96875 6.8125 L 4 6.84375 C 3.035156 7.734375 2.738281 9.066406 3.15625 10.21875 C 3.160156 10.226563 3.152344 10.242188 3.15625 10.25 C 4.003906 12.675781 6.171875 17.359375 10.40625 21.59375 C 14.65625 25.84375 19.402344 27.925781 21.75 28.84375 L 21.78125 28.84375 C 22.996094 29.25 24.3125 28.960938 25.25 28.15625 L 28.40625 25 C 29.234375 24.171875 29.234375 22.734375 28.40625 21.90625 L 24.34375 17.84375 L 24.3125 17.78125 C 23.484375 16.953125 22.015625 16.953125 21.1875 17.78125 L 19.1875 19.78125 C 18.464844 19.433594 16.742188 18.542969 15.09375 16.96875 C 13.457031 15.40625 12.621094 13.609375 12.3125 12.90625 L 14.3125 10.90625 C 15.152344 10.066406 15.167969 8.667969 14.28125 7.84375 L 14.3125 7.8125 L 14.21875 7.71875 L 10.21875 3.59375 L 10.1875 3.5625 L 10.125 3.53125 C 9.695313 3.1875 9.179688 3 8.65625 3 Z M 8.65625 5 C 8.730469 5 8.804688 5.035156 8.875 5.09375 L 12.875 9.1875 L 12.96875 9.28125 C 12.960938 9.273438 13.027344 9.378906 12.90625 9.5 L 10.40625 12 L 9.9375 12.4375 L 10.15625 13.0625 C 10.15625 13.0625 11.304688 16.136719 13.71875 18.4375 L 13.9375 18.625 C 16.261719 20.746094 19 21.90625 19 21.90625 L 19.625 22.1875 L 22.59375 19.21875 C 22.765625 19.046875 22.734375 19.046875 22.90625 19.21875 L 27 23.3125 C 27.171875 23.484375 27.171875 23.421875 27 23.59375 L 23.9375 26.65625 C 23.476563 27.050781 22.988281 27.132813 22.40625 26.9375 C 20.140625 26.046875 15.738281 24.113281 11.8125 20.1875 C 7.855469 16.230469 5.789063 11.742188 5.03125 9.5625 C 4.878906 9.15625 4.988281 8.554688 5.34375 8.25 L 5.40625 8.1875 L 8.4375 5.09375 C 8.507813 5.035156 8.582031 5 8.65625 5 Z"
})));

/* eslint-disable max-len */
const IconPlace = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
  })));
};

var IconPlane = props => /*#__PURE__*/React.createElement(Icon, _extends({
  rotate: 90
}, props), /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
var IconPlaneAlt = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.57,15.94l-.12-.08a5.11,5.11,0,0,0-3-.94H19.17l-.64-.52L11.78,9h-3l3.44,5.4.33.52H7.51L4,11.38H2l1.54,3.95h0a.29.29,0,0,0,.09.16L6,17.78a1.33,1.33,0,0,0,.93.37l5.45.13-3.6,5.65h3l6.87-5.5h.64l7,.17a5.68,5.68,0,0,0,3.24-1h0A1,1,0,0,0,29.57,15.94Z"
})));

/* eslint-disable max-len */
var IconPlaneDeparture = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.61,22.11l.52.63.72-.4,5.43-2.89-1.09,6-.36,1.91,1.81-.76,2.69-1.15.4-.16.16-.4,3.91-9.49,5.52-3a3.13,3.13,0,0,0-.56-5.79,3.52,3.52,0,0,0-1.21-.13,3.27,3.27,0,0,0-1.19.36l-5,2.63L13.7,7.85l-.4-.1-.39.2L10.64,9.26l-1.34.79,1.24.95,2.86,2.17L9.82,15.08,6,13.34l-.46-.2-.46.23-1.84,1L2,15l.92,1Zm4.46-11.83.5-.29,4,1-2.17,1.12ZM5.58,15.47l3.85,1.71.49.23.43-.26,16-8.45a.8.8,0,0,1,.39-.09,1.07,1.07,0,0,1,.4,0,1,1,0,0,1,.62.49,1,1,0,0,1-.42,1.41l-5.89,3.19-.32.17-.14.36-3.91,9.4-.46.19,1.12-6.21.39-2.13-1.9,1L9.59,20.11,5.42,15.57Z"
})));

/* eslint-disable max-len */
var IconPlaneLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.11,16.11a3,3,0,0,0-3-3H18.77L15,4.7l-.25-.59H10l1,9H9.14L7.42,10.55l-.28-.44H2.89l.25,1.19,1,4.81-1,4.81-.25,1.19H7.14l.28-.44,1.72-2.56H11l-1,9h4.79l.25-.59,3.75-8.41h7.34A3,3,0,0,0,29.11,16.11Zm-2,0a1,1,0,0,1-1,1H17.45l-.25.59-3.75,8.41H12.23l1-9H8.05l-.28.44L6.05,20.11H5.33l.75-3.81.06-.19-.06-.19-.75-3.81h.72l1.72,2.56.28.44h5.18l-1-9h1.22l3.75,8.41.25.59h8.66A1,1,0,0,1,27.11,16.11Z"
})));

/* eslint-disable max-len */
var IconPlaneLand = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0V0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M0 0h24v24H0V0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z",
  clipPath: "url(#d)"
})));

/* eslint-disable max-len */
var IconPlaneTakeOff = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0V0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z",
  clipPath: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#b)",
  fill: "none",
  d: "M0 0h24v24H0V0z"
})));

/* eslint-disable max-len */
var IconPlaneTicket = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.46,5H4.8c-1.54,0-2.79,1.24-2.79,2.75v5.5c1.55,0,2.8,1.24,2.79,2.76,0,1.52-1.26,2.75-2.81,2.74v5.5c0,1.52,1.26,2.75,2.8,2.75H27.2c1.54,0,2.8-1.23,2.8-2.75V7.75c.07-1.44-1.06-2.67-2.53-2.75Zm-.46,19H5v-3.39c1.7-.95,2.74-2.71,2.75-4.61,0-1.9-1.04-3.66-2.74-4.61v-3.39s21.99,0,21.99,0V24Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.36,20.95l-2.36-4.1,1.32-.36,1.79,1.41,3.4-.91-3.42-5.92,1.99-.54,5.71,5.32,3.47-.93c.73-.19,1.48,.24,1.68,.97,.18,.74-.25,1.49-.98,1.69l-12.61,3.36Z"
})));

/* eslint-disable max-len */
var IconPlug = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.5,30h-3v-11h3v11Zm6.5-23h-4V2.5h-2v4.5h-4V2.5h-2v4.5h-4v2h1v4c0,3.31,2.69,6,6,6h2c3.31,0,6-2.69,6-6v-4h1v-2Z",
  strokeWidth: "0"
})));

var IconPrint = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("rect", {
  x: "6",
  y: "19",
  width: "12",
  height: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,10V2H5v8H2V20H5V18H19v2h3V10ZM6,14H4V12H6ZM17,9H7V4H17Z"
})));

/* eslint-disable max-len */
var IconPriceTag = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.11,30c-.72,0-1.43-.27-1.98-.81l-7.31-7.32c-1.09-1.09-1.09-2.87,0-3.96L18.18,2.56c.36-.36.84-.56,1.34-.56h7.69c1.55,0,2.79,1.27,2.78,2.8v7.68c0,.51-.2.98-.55,1.34l-15.35,15.35c-.55.54-1.26.82-1.98.82Zm7.41-26l-15.29,15.33c-.31.31-.31.82,0,1.13l7.31,7.31c.31.31.82.31,1.13,0l15.35-15.35-.03-7.62c0-.44-.35-.8-.79-.8v-1s0,1,0,1h-7.68Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24,10c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
})));

/* eslint-disable max-len */
var IconPrintLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 9 4 L 9 11 L 7 11 C 5.355469 11 4 12.355469 4 14 L 4 24 L 9 24 L 9 28 L 23 28 L 23 24 L 28 24 L 28 14 C 28 12.355469 26.644531 11 25 11 L 23 11 L 23 4 Z M 11 6 L 21 6 L 21 11 L 11 11 Z M 7 13 L 25 13 C 25.566406 13 26 13.433594 26 14 L 26 22 L 23 22 L 23 18 L 9 18 L 9 22 L 6 22 L 6 14 C 6 13.433594 6.433594 13 7 13 Z M 8 14 C 7.449219 14 7 14.449219 7 15 C 7 15.550781 7.449219 16 8 16 C 8.550781 16 9 15.550781 9 15 C 9 14.449219 8.550781 14 8 14 Z M 11 20 L 21 20 L 21 26 L 11 26 Z"
})));

/* eslint-disable max-len */
var IconPower = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.68,6.44V2H14.33V6.44H9.67V2H7.33V6.44h0A2.43,2.43,0,0,0,5,8.66v6.1l4.08,3.91V22h5.84V18.67L19,14.77V8.66A2.43,2.43,0,0,0,16.68,6.44Z"
})));

/* eslint-disable max-len */
var IconQuoteRight = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 4 8 L 4 18 L 12 18 C 12 20.21875 10.21875 22 8 22 L 8 24 C 11.300781 24 14 21.300781 14 18 L 14 8 Z M 18 8 L 18 18 L 26 18 C 26 20.21875 24.21875 22 22 22 L 22 24 C 25.300781 24 28 21.300781 28 18 L 28 8 Z M 6 10 L 12 10 L 12 16 L 6 16 Z M 20 10 L 26 10 L 26 16 L 20 16 Z"
})));

/* eslint-disable max-len */
var IconReclinerSeat = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6,6.59A2.3,2.3,0,1,1,9.18,6,2.31,2.31,0,0,1,6,6.59Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,19.94H9.92a3.31,3.31,0,0,1-3.38-2.53L4.29,8H2l2.27,9.71a5.55,5.55,0,0,0,5.66,4.22H18Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.41,15.43H11.67l-1-3.81a7.78,7.78,0,0,0,5,1.14v-2a6.09,6.09,0,0,1-4.55-1.16L9.53,8.44a2.21,2.21,0,0,0-.74-.36A2.18,2.18,0,0,0,7.84,8h0A2.11,2.11,0,0,0,6,10.45L7.34,16a2.88,2.88,0,0,0,2.86,2.26h6.64L20.55,21,22,19.61Z"
})));

/* eslint-disable max-len */
var IconRefresh = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
})));

var IconRemove = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 13H5v-2h14v2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
var IconResendEmail = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,20.11H4.92V7.72L15,14.3l.54.32L16,14.3l10-6.58V14H28V5H3V22H15ZM23.85,6.89,15.5,12.35,7.15,6.89Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.23,17.75a6,6,0,0,0-9.77,1.94h1.81a4.38,4.38,0,0,1,6.83-.81l-1.94,1.94H29V16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.75,24.25a4.38,4.38,0,0,1-6.86.86l1.94-1.94H17V28l1.76-1.76a6,6,0,0,0,9.78-2Z"
})));

/* eslint-disable max-len */
var IconSearch = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.72,19.29,17.83,15.4a.92.92,0,0,0-.66-.28h-.64a8.13,8.13,0,1,0-1.41,1.41v.64a.92.92,0,0,0,.28.66l3.89,3.89a.94.94,0,0,0,1.33,0l1.1-1.1A.94.94,0,0,0,21.72,19.29Zm-11.6-4.17a5,5,0,1,1,5-5A5,5,0,0,1,10.12,15.12Z"
})));

/* eslint-disable max-len */
var IconSearchLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 19 3 C 13.488281 3 9 7.488281 9 13 C 9 15.394531 9.839844 17.589844 11.25 19.3125 L 3.28125 27.28125 L 4.71875 28.71875 L 12.6875 20.75 C 14.410156 22.160156 16.605469 23 19 23 C 24.511719 23 29 18.511719 29 13 C 29 7.488281 24.511719 3 19 3 Z M 19 5 C 23.429688 5 27 8.570313 27 13 C 27 17.429688 23.429688 21 19 21 C 14.570313 21 11 17.429688 11 13 C 11 8.570313 14.570313 5 19 5 Z"
})));

/* eslint-disable max-len */
var IconSendArrow = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.67,13.08,2,19.59a.3.3,0,0,0,0,.34A.28.28,0,0,0,2.4,20l19.41-7.74a.29.29,0,0,0,.17-.38.3.3,0,0,0-.17-.16L2.4,4a.28.28,0,0,0-.33.08.3.3,0,0,0,0,.34l3.63,6.51,9.19,1a.11.11,0,1,1,0,.22Z",
  fillRule: "evenodd"
})));

/* eslint-disable max-len */
var IconSlackApp = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.5,19.4a2.69,2.69,0,0,1-2.7,2.7A2.78,2.78,0,0,1,3,19.4a2.69,2.69,0,0,1,2.7-2.7H8.4v2.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.8,19.4a2.7,2.7,0,0,1,5.4,0v6.8a2.7,2.7,0,0,1-5.4,0Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.6,8.5A2.69,2.69,0,0,1,9.9,5.8,2.78,2.78,0,0,1,12.6,3a2.69,2.69,0,0,1,2.7,2.7V8.4H12.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6,9.8a2.7,2.7,0,1,1,0,5.4H5.7a2.7,2.7,0,0,1,0-5.4Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.5,12.6a2.7,2.7,0,1,1,2.7,2.7H23.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2,12.6a2.7,2.7,0,0,1-5.4,0V5.7a2.7,2.7,0,0,1,5.4,0Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.4,23.5a2.7,2.7,0,1,1-2.7,2.7V23.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.4,22.2a2.7,2.7,0,0,1,0-5.4h6.8a2.7,2.7,0,0,1,0,5.4Z"
})))));

/* eslint-disable max-len */
var IconSmile = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 4 C 9.382813 4 4 9.382813 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 C 28 9.382813 22.617188 4 16 4 Z M 16 6 C 21.535156 6 26 10.464844 26 16 C 26 21.535156 21.535156 26 16 26 C 10.464844 26 6 21.535156 6 16 C 6 10.464844 10.464844 6 16 6 Z M 11.5 12 C 10.671875 12 10 12.671875 10 13.5 C 10 14.328125 10.671875 15 11.5 15 C 12.328125 15 13 14.328125 13 13.5 C 13 12.671875 12.328125 12 11.5 12 Z M 20.5 12 C 19.671875 12 19 12.671875 19 13.5 C 19 14.328125 19.671875 15 20.5 15 C 21.328125 15 22 14.328125 22 13.5 C 22 12.671875 21.328125 12 20.5 12 Z M 10.8125 19 L 9.09375 20 C 10.476563 22.386719 13.046875 24 16 24 C 18.953125 24 21.523438 22.386719 22.90625 20 L 21.1875 19 C 20.148438 20.792969 18.226563 22 16 22 C 13.773438 22 11.851563 20.792969 10.8125 19 Z"
})));

/* eslint-disable max-len */
var IconSnack = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.06,18.4a12.77,12.77,0,0,0,2.29-.65l.4-.16.4-.18a9.83,9.83,0,0,0,1.5-.87,14.53,14.53,0,0,0,1.41-1.13l.07-.07-.07-.06a9.72,9.72,0,0,1-1.54-1.63l0-.07-.07.06a12.43,12.43,0,0,1-1.11.88A8.36,8.36,0,0,1,7,15.66l-.35.1-.35.1c-.33.08-.53.11-.54.11a1.18,1.18,0,0,0-.78.48,1.29,1.29,0,0,0-.23.91,1.22,1.22,0,0,0,1.19,1.05Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,15.41l-.08-.11a8.8,8.8,0,0,1-.71-1.22L5,13.68a7.92,7.92,0,0,1-.28-.82,8.13,8.13,0,0,1-.31-1.78,1.77,1.77,0,0,1,0-.23,4.58,4.58,0,0,1,.34-1.8c0-.07.07-.15.1-.23L5,8.57a4.86,4.86,0,0,1,.88-1.08,3,3,0,0,1,.62-.44l.36-.17A4.88,4.88,0,0,1,8.7,6.52a5.2,5.2,0,0,1,1.43.2l.32.11.3.13a3.12,3.12,0,0,1,1.59,1.61A2.9,2.9,0,0,1,12.5,9a3.51,3.51,0,0,1,.1.53,2.48,2.48,0,0,1,0,.39v.09a3.79,3.79,0,0,0,1.59,2.54l.07.07.05-.09A5.67,5.67,0,0,0,15,9.27a6.13,6.13,0,0,0-.53-1.86q-.06-.13-.15-.3l-.18-.3a5.43,5.43,0,0,0-1.66-1.68l-.32-.2-.33-.17c-.2-.1-.37-.17-.54-.24a7.18,7.18,0,0,0-2.57-.46,7.08,7.08,0,0,0-3.15.72c-.16.08-.31.17-.46.26a5.4,5.4,0,0,0-.85.64A7.46,7.46,0,0,0,3.07,7.05c-.14.23-.27.46-.38.68a6.17,6.17,0,0,0-.35.86v0l0,0a6.79,6.79,0,0,0-.2.86A7.84,7.84,0,0,0,2,10.69a10.28,10.28,0,0,0,.06,1.1,11,11,0,0,0,.35,1.76,9.77,9.77,0,0,0,.33.95c.06.16.13.31.2.47a10.84,10.84,0,0,0,1.14,1.94l.11.16,0-.19a1.76,1.76,0,0,1,.31-.73,1.66,1.66,0,0,1,1.1-.68l.19,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.74,6.08a4.47,4.47,0,0,0-.34-.4l0,0a4.94,4.94,0,0,0-1.82-1.24A3.14,3.14,0,0,0,18,4.25,6.74,6.74,0,0,0,16.18,4a7,7,0,0,0-3,.64l-.15.08-.17.09.11.08a6,6,0,0,1,1.6,1.75l0,.06.06,0a4.59,4.59,0,0,1,1.48-.24,5,5,0,0,1,.95.1l.38.09a2.84,2.84,0,0,1,1.26.84A3.88,3.88,0,0,1,19,7.8c.75,1.19.81,3.13.18,5.32a6.54,6.54,0,0,1-.72,1.61l-.06.1.11,0,.34.09a1.71,1.71,0,0,1,1.33,1.29l0,.19.1-.16a9.23,9.23,0,0,0,1.14-2.46C22.38,10.63,22.12,7.88,20.74,6.08Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.23,18.36a13.08,13.08,0,0,1-2.56-.84l0,0,0,0a7.26,7.26,0,0,1-3.67,1A7.07,7.07,0,0,1,9.15,18h0l0,0a13.1,13.1,0,0,1-2.9.89l-.19,0,.16.12a9.39,9.39,0,0,0,5.76,2,9.76,9.76,0,0,0,6.44-2.48l.14-.12-.21,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.75,15.45l-.61-.16-.33-.11-.33-.11a11.48,11.48,0,0,1-2.38-1.18c-.21-.13-.42-.28-.61-.42l-.26-.2L14,13.06a6,6,0,0,1-1.54-1.79,3.52,3.52,0,0,1-.18-.4,2.53,2.53,0,0,1-.13-.84.53.53,0,0,1,0-.12,2.28,2.28,0,0,0,0-.27A2.65,2.65,0,0,0,10.49,7.4l-.07,0,0,.08a7,7,0,0,0-.6,2,5,5,0,0,0,.72,3.3q.09.16.18.3c.06.09.12.18.2.28a8.94,8.94,0,0,0,1.57,1.65,2.75,2.75,0,0,0,.26.22l.27.21c.27.2.55.4.84.59a14.45,14.45,0,0,0,1.74,1l.36.16.37.15a12.76,12.76,0,0,0,2,.63l.21,0a1.18,1.18,0,0,0,.82-.34l.15-.17a1.43,1.43,0,0,0,.21-.49,1.29,1.29,0,0,0-.19-.92A1.17,1.17,0,0,0,18.75,15.45Z"
}))));

/* eslint-disable max-len */
var IconSort = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

/* eslint-disable max-len */
const IconSpeedometer = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.73,8,15.12,16.4a3.3,3.3,0,1,0,3,1.73l4-9.89A.22.22,0,0,0,21.73,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81,17.84a1.33,1.33,0,0,0,1.27-.94,10.41,10.41,0,0,1,10-7.21,10.83,10.83,0,0,1,3.66.64.37.37,0,0,0,.43-.12h0A.38.38,0,0,0,19,9.6a11.59,11.59,0,0,0-3.93-.68A11.2,11.2,0,0,0,4.52,16.14a.67.67,0,0,1-.61.43h0a.66.66,0,0,1-.61-.87A12.53,12.53,0,0,1,15.1,7.6a12.74,12.74,0,0,1,5,1,.4.4,0,0,0,.46-.11h0a.38.38,0,0,0-.15-.59,13.56,13.56,0,0,0-5.3-1.07A13.26,13.26,0,0,0,2.38,16a1.46,1.46,0,0,0,1.4,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.39,17.84h0a1.47,1.47,0,0,0,1.4-1.91,13,13,0,0,0-4.93-6.66.39.39,0,0,0-.58.17h0a.38.38,0,0,0,.14.46,12.19,12.19,0,0,1,4.47,5.79.65.65,0,0,1-.61.87h0a.67.67,0,0,1-.61-.43,10.86,10.86,0,0,0-3.59-4.87.39.39,0,0,0-.59.16h0a.39.39,0,0,0,.13.46,10,10,0,0,1,3.49,5A1.34,1.34,0,0,0,26.39,17.84Z"
  })));
};

var IconStarSolid = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23,9.5l-7.8-.83L12,1.51,8.8,8.67,1,9.5l5.83,5.25L5.2,22.43,12,18.51l6.8,3.92-1.63-7.68Z"
})));

/* eslint-disable max-len */
var IconStreamingVideo = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.78,5h-.43a.24.24,0,0,0-.22.26v.12A.57.57,0,0,1,20.6,6H19.16a.57.57,0,0,1-.53-.61V5.26A.24.24,0,0,0,18.41,5H18a.24.24,0,0,0-.22.26.67.67,0,0,1-.62.71H6.78a.67.67,0,0,1-.62-.71h0A.24.24,0,0,0,5.94,5H5.51a.24.24,0,0,0-.22.26v.12A.57.57,0,0,1,4.76,6H3.33a.57.57,0,0,1-.53-.61V5.26A.24.24,0,0,0,2.58,5H2.22A.24.24,0,0,0,2,5.26V19.74a.24.24,0,0,0,.22.26h.36a.24.24,0,0,0,.22-.26v-.21a.58.58,0,0,1,.53-.62H4.76a.58.58,0,0,1,.53.62v.21a.24.24,0,0,0,.22.26h.43a.24.24,0,0,0,.22-.26v0A.67.67,0,0,1,6.78,19H17.15a.67.67,0,0,1,.62.71v0A.24.24,0,0,0,18,20h.42a.24.24,0,0,0,.22-.26v-.21a.58.58,0,0,1,.53-.62H20.6a.58.58,0,0,1,.53.62v.21a.24.24,0,0,0,.22.26h.43a.24.24,0,0,0,.22-.26V5.26A.24.24,0,0,0,21.78,5ZM5.29,16.52a.57.57,0,0,1-.53.61H3.33a.57.57,0,0,1-.53-.61v-.71a.57.57,0,0,1,.53-.61H4.76a.57.57,0,0,1,.53.61Zm0-3.71a.58.58,0,0,1-.53.61H3.33a.58.58,0,0,1-.53-.61V12.1a.57.57,0,0,1,.53-.61H4.76a.57.57,0,0,1,.53.61Zm0-3.72a.57.57,0,0,1-.53.61H3.33a.57.57,0,0,1-.53-.61V8.38a.58.58,0,0,1,.53-.61H4.76a.58.58,0,0,1,.53.61Zm12.48,7.27a.67.67,0,0,1-.62.71H6.78a.67.67,0,0,1-.62-.71V8.51a.67.67,0,0,1,.62-.72H17.15a.68.68,0,0,1,.62.72Zm3.36.16a.57.57,0,0,1-.53.61H19.16a.57.57,0,0,1-.53-.61v-.71a.57.57,0,0,1,.53-.61H20.6a.57.57,0,0,1,.53.61Zm0-3.71a.58.58,0,0,1-.53.61H19.16a.58.58,0,0,1-.53-.61V12.1a.57.57,0,0,1,.53-.61H20.6a.57.57,0,0,1,.53.61Zm0-3.72a.57.57,0,0,1-.53.61H19.16a.57.57,0,0,1-.53-.61V8.38a.58.58,0,0,1,.53-.61H20.6a.58.58,0,0,1,.53.61Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.77,12.14,10.71,10a.48.48,0,0,0-.71.37v4.28a.48.48,0,0,0,.71.37l4.06-2.15A.39.39,0,0,0,14.77,12.14Z"
}))));

/* eslint-disable max-len */
var IconSuitcase = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M18.29,9V7s0,0,0-.07H13.72s0,0,0,.07V9H12V7a1.83,1.83,0,0,1,1.6-2h4.8A1.83,1.83,0,0,1,20,7V9Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,8.22A1.16,1.16,0,0,0,6.91,7H5.09A1.16,1.16,0,0,0,4,8.22V9H8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28,8.22A1.16,1.16,0,0,0,26.91,7H25.09A1.16,1.16,0,0,0,24,8.22V9h4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,10H4.32A2.15,2.15,0,0,0,2,11.94V25.09A2.15,2.15,0,0,0,4.32,27H7Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "23 10 9 10.02 9 27 23 27 23 10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.73,10H25V27h2.73A2.12,2.12,0,0,0,30,25.09V11.94A2.12,2.12,0,0,0,27.73,10Z"
}))));

/* eslint-disable max-len */
var IconSuitcases = props => /*#__PURE__*/React.createElement(GraphicIcon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 136.67 137.11",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M51.78,130.47H13.26A11.27,11.27,0,0,1,2,119.21V54.41A11.27,11.27,0,0,1,13.26,43.16H51.78A11.27,11.27,0,0,1,63,54.41v64.8A11.27,11.27,0,0,1,51.78,130.47ZM13.26,45.25a9.18,9.18,0,0,0-9.17,9.16v64.8a9.19,9.19,0,0,0,9.17,9.17H51.78a9.18,9.18,0,0,0,9.16-9.17V54.41a9.17,9.17,0,0,0-9.16-9.16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.63,135.11h-1.9a4,4,0,0,1-4-4v-2.78h9.81v2.78A4,4,0,0,1,17.63,135.11Zm-3.76-4.64v.69A1.87,1.87,0,0,0,15.73,133h1.9a1.86,1.86,0,0,0,1.86-1.86v-.69Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.3,135.11H47.4a4,4,0,0,1-3.95-4v-2.78h9.81v2.78A4,4,0,0,1,49.3,135.11Zm-3.76-4.64v.69A1.86,1.86,0,0,0,47.4,133h1.9a1.86,1.86,0,0,0,1.86-1.86v-.69Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.08,19H48.59A2.92,2.92,0,0,1,45.68,16V11.5H19.35V16A2.91,2.91,0,0,1,16.44,19H13A2.92,2.92,0,0,1,10,16V5.25a3.15,3.15,0,0,1,3.14-3.14H51.85A3.15,3.15,0,0,1,55,5.25V16A2.91,2.91,0,0,1,52.08,19ZM17.26,9.41H47.77V16a.82.82,0,0,0,.82.82h3.49A.82.82,0,0,0,52.9,16V5.25a1,1,0,0,0-1-1H13.18a1,1,0,0,0-1,1V16a.82.82,0,0,0,.81.82h3.49a.82.82,0,0,0,.82-.82Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "13.65",
  y: "17.9",
  width: "2.09",
  height: "26.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.92,117.79a1,1,0,0,1-1.05-1.05V56.88a1.05,1.05,0,0,1,2.1,0v59.86A1,1,0,0,1,12.92,117.79Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.72,117.79a1,1,0,0,1-1-1.05V102.32a1.05,1.05,0,0,1,2.1,0v14.42A1,1,0,0,1,22.72,117.79Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.72,96.8a1,1,0,0,1-1-1V56.88a1.05,1.05,0,0,1,2.1,0V95.75A1,1,0,0,1,22.72,96.8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.52,117.79a1,1,0,0,1-1.05-1.05V56.88a1,1,0,0,1,2.09,0v59.86A1,1,0,0,1,32.52,117.79Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.31,117.79a1,1,0,0,1-1-1.05V74.86a1,1,0,1,1,2.09,0v41.88A1,1,0,0,1,42.31,117.79Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.31,69.65a1,1,0,0,1-1-1.05V56.88a1,1,0,0,1,2.09,0V68.6A1,1,0,0,1,42.31,69.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.11,117.79a1,1,0,0,1-1-1.05V56.88a1,1,0,0,1,2.09,0v59.86A1,1,0,0,1,52.11,117.79Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "49.29",
  y: "17.9",
  width: "2.09",
  height: "26.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.47,45.25H23.56V43a6.29,6.29,0,0,1,6.29-6.28h5.34A6.29,6.29,0,0,1,41.47,43ZM25.66,43.16H39.38V43a4.2,4.2,0,0,0-4.19-4.19H29.85A4.2,4.2,0,0,0,25.66,43Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M101.08,60.63H98.51a2.43,2.43,0,0,1-2.43-2.43V56.44H80.27V58.2a2.43,2.43,0,0,1-2.43,2.43H75.27a2.43,2.43,0,0,1-2.43-2.43V51.56A2.6,2.6,0,0,1,75.43,49h25.48a2.61,2.61,0,0,1,2.6,2.6V58.2A2.43,2.43,0,0,1,101.08,60.63ZM79.33,54.35H97a1.16,1.16,0,0,1,1.17,1.16V58.2a.33.33,0,0,0,.33.33h2.57a.33.33,0,0,0,.33-.33V51.56a.5.5,0,0,0-.5-.5H75.43a.5.5,0,0,0-.5.5V58.2a.34.34,0,0,0,.34.33h2.57a.33.33,0,0,0,.33-.33V55.51A1.16,1.16,0,0,1,79.33,54.35Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "75.5",
  y: "59.58",
  width: "2.09",
  height: "7.12"
}), /*#__PURE__*/React.createElement("rect", {
  x: "98.75",
  y: "59.58",
  width: "2.09",
  height: "7.12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.25,91.16a1,1,0,0,1-1-1V86a1,1,0,1,1,2.09,0v4.12A1,1,0,0,1,128.25,91.16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.25,82.38a1,1,0,0,1-1-1V75.79a2.33,2.33,0,0,0-2.34-2.33h-2.38a1,1,0,0,1,0-2.1h2.38a4.43,4.43,0,0,1,4.43,4.43v5.54A1,1,0,0,1,128.25,82.38Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.3,135.11H56.89a1,1,0,1,1,0-2.09H125.3a7.63,7.63,0,0,0,7.61-7.61V75.35a7.62,7.62,0,0,0-7.61-7.6H67.12a1.05,1.05,0,0,1,0-2.1H125.3a9.72,9.72,0,0,1,9.7,9.7v50.06A9.71,9.71,0,0,1,125.3,135.11Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.41,135.11H109.7V65.65h7.71ZM111.79,133h3.53V67.75h-3.53Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.19,90.41a3.15,3.15,0,0,1-.52,0h0l-7.2-1.55a2.51,2.51,0,0,1-1.91-3l1.18-5.45a2.48,2.48,0,0,1,3-1.9L99.89,80a2.49,2.49,0,0,1,1.91,3l-1.17,5.45A2.5,2.5,0,0,1,98.19,90.41Zm-.08-2.1a.4.4,0,0,0,.47-.3l1.17-5.45a.39.39,0,0,0-.3-.47l-7.2-1.55a.38.38,0,0,0-.3.06.39.39,0,0,0-.17.24l-1.17,5.45a.37.37,0,0,0,.06.3.36.36,0,0,0,.24.17Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.69,124.9A4.95,4.95,0,1,1,82.63,120,5,5,0,0,1,77.69,124.9Zm0-7.79A2.85,2.85,0,1,0,80.54,120,2.85,2.85,0,0,0,77.69,117.11Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.49,117.65h0a3.41,3.41,0,0,1-3-1.72l-2.65-4.59a3.45,3.45,0,0,1,0-3.46,3.42,3.42,0,0,1,3-1.73h5.3a3.46,3.46,0,0,1,3,5.19l-2.65,4.59A3.41,3.41,0,0,1,96.49,117.65Zm-2.65-9.4a1.33,1.33,0,0,0-1.18.68,1.36,1.36,0,0,0,0,1.36l2.65,4.59a1.36,1.36,0,0,0,1.18.68h0a1.34,1.34,0,0,0,1.18-.68l2.65-4.59a1.36,1.36,0,0,0-1.18-2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.87,98.65a3.46,3.46,0,0,1-3.05-5.07l2.48-4.69a3.45,3.45,0,0,1,6-.22l2.82,4.49a3.45,3.45,0,0,1-2.8,5.29l-5.29.2Zm0-6.43-1.24,2.34a1.36,1.36,0,0,0,1.26,2l5.29-.2a1.33,1.33,0,0,0,1.16-.72,1.36,1.36,0,0,0,0-1.36L77.5,89.78a1.32,1.32,0,0,0-1.2-.63,1.35,1.35,0,0,0-1.15.72Z"
})))));

/* eslint-disable max-len */
var IconSuitcaseLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 14 3 C 12.90625 3 12 3.90625 12 5 L 12 6 L 9 6 L 9 5 L 7 5 L 7 6 L 5 6 C 3.90625 6 3 6.90625 3 8 L 3 24 C 3 25.09375 3.90625 26 5 26 L 27 26 C 28.09375 26 29 25.09375 29 24 L 29 8 C 29 6.90625 28.09375 6 27 6 L 25 6 L 25 5 L 23 5 L 23 6 L 20 6 L 20 5 C 20 3.90625 19.09375 3 18 3 Z M 14 5 L 18 5 L 18 6 L 14 6 Z M 5 8 L 27 8 L 27 24 L 25 24 L 25 9 L 23 9 L 23 24 L 9 24 L 9 9 L 7 9 L 7 24 L 5 24 Z"
})));

/* eslint-disable max-len */
var IconTextSMS = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 2 5 L 2 25 L 7 25 L 7 30.09375 L 8.625 28.78125 L 13.34375 25 L 30 25 L 30 5 Z M 4 7 L 28 7 L 28 23 L 12.65625 23 L 12.375 23.21875 L 9 25.90625 L 9 23 L 4 23 Z M 8 12 L 8 14 L 24 14 L 24 12 Z M 8 16 L 8 18 L 20 18 L 20 16 Z"
})));

/* eslint-disable max-len */
var IconThumbsUp = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.38,11.75h-8.28l1.25-5.71,.04-.4c0-.5-.21-.97-.58-1.32l-1.39-1.31L9.77,11.24c-.5,.46-.78,1.1-.77,1.76v12.5c.01,1.39,1.18,2.5,2.62,2.5h11.81c1.05,0,2-.6,2.42-1.53l3.96-8.81c.12-.29,.18-.6,.18-.91v-2.5c-.01-1.39-1.18-2.5-2.62-2.5Zm-.38,4.95l-3.75,8.3H12V13.15l5.42-5.15-1.39,6.33h10.96v2.37Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2",
  y: "13",
  width: "5",
  height: "15"
})));

/* eslint-disable max-len */
var IconTicketLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 2 7 L 2 14 L 3 14 C 4.191406 14 5 14.808594 5 16 C 5 17.191406 4.191406 18 3 18 L 2 18 L 2 25 L 30 25 L 30 18 L 29 18 C 27.808594 18 27 17.191406 27 16 C 27 14.808594 27.808594 14 29 14 L 30 14 L 30 7 Z M 4 9 L 28 9 L 28 12.1875 C 26.285156 12.636719 25 14.144531 25 16 C 25 17.855469 26.285156 19.363281 28 19.8125 L 28 23 L 4 23 L 4 19.8125 C 5.714844 19.363281 7 17.855469 7 16 C 7 14.144531 5.714844 12.636719 4 12.1875 Z"
})));

/* eslint-disable max-len */
var IconTicket = props => /*#__PURE__*/React.createElement(GraphicIcon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 100 100",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.9,84.4h48.4c0.7,0.1,1.1,0.4,1.1,1.1c0,0.6-0.4,1.2-1.1,1.2l0,0h-96c-0.3,0-0.8,0.1-1-0.1s-0.7-0.7-0.7-1.1s0.5-0.8,0.8-1s0.8-0.1,1.3-0.1H49.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.9,92.9H16.5c-1.5,0-2-0.3-2-1.2s0.6-1.2,2-1.2h67c0.3,0,0.8-0.1,1,0.1c0.4,0.3,0.7,0.7,0.9,1.2c0.1,0.6-0.4,1-1,1.1H49.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.3,96.9h14c0.7,0.1,1.1,0.5,1,1.1c-0.1,0.5-0.5,0.9-0.9,1.2c-0.1,0.1-0.5,0-0.8,0H28c-0.6,0-1-0.5-1-1.2c0-0.6,0.4-1.2,1.1-1.2l0,0h3.5C35.2,96.9,38.7,96.9,42.3,96.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2,96.8h4.3c0.8,0,1.4,0.2,1.4,1.1s-0.5,1.2-1.4,1.2h-8.9c-0.8,0-1.4-0.3-1.3-1.2s0.6-1.2,1.4-1.2C64.2,96.8,65.7,96.8,67.2,96.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80,28.4H12.1c-2.8-0.1-5.2,2.1-5.3,5c0,0.1,0,0.1,0,0.2v34.9c0,2.9,2.3,5.3,5.2,5.3c0,0,0,0,0.1,0H80\r c2.9,0,5.3-2.3,5.3-5.2v-0.1v-35C85.2,30.7,82.9,28.4,80,28.4z M83.3,50.3h-7.1c-0.5-0.1-1,0.3-1,0.8c-0.1,0.5,0.3,1,0.8,1\r c0.1,0,0.1,0,0.2,0h7.1v16.3c0,1.8-1.5,3.3-3.3,3.3H12.1c-1.8,0-3.3-1.5-3.3-3.3V52h29.6c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9\r H8.6V33.5c0-1.8,1.5-3.3,3.3-3.3h67.9c1.8,0,3.3,1.5,3.3,3.3v16.8H83.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.5,11.7C82.7,8.9,79.8,7.3,77,8L20.1,24.1c-0.5,0.1-0.9,0.6-0.8,1.1s0.6,0.9,1.1,0.8c0.1,0,0.2,0,0.2-0.1\r l57-16.1c1.8-0.5,3.6,0.6,4.1,2.4l0,0l1.9,7.1l-18.1,5.1c-0.5,0.2-0.8,0.7-0.6,1.2c0.1,0.4,0.5,0.7,1,0.6h0.3l18.1-5.1l6.9,24.8\r c0.5,1.8-0.5,3.6-2.3,4.1c-1.1,0.3-2.3,0.5-2,1.5c0.3,1.2,1.5,0.6,2.6,0.3c2.8-0.8,4.4-3.7,3.6-6.5L83.5,11.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.2,48.1L67.2,48.1l-6.1,0.1l-7.7-12.5c-0.9-1.4-3.8,1.4-3.5,2.3l2.7,10.6c-3.3,0.1-3.5,0.1-5.1,0.3l-4.4-5.5\r c-0.9-1.2-2.9,0.9-2.6,1.8c2.6,5.8,2.4,5.6,2.6,5.8c-0.2,0.3,0-0.1-2.6,5.8c-0.5,0.8,1.6,3,2.6,1.8l4.4-5.5c1.7,0.2,1.8,0.2,4.8,0.3\r L49.6,64c-0.2,0.9,2.7,3.6,3.5,2.3l7.7-12.6c2.9,0.2,11,1,11-2.9C72.1,49,68.2,48.1,67.2,48.1z M67.2,52.1c-9.2-0.3-5.6-2.7-15,12.2\r l-0.6-0.5c3.6-14.1,4.7-12.2-2.1-12.4c-3.8-0.2-1.8-1.7-6.3,4.2c2.4-5.5,2.4-3.8,0-9.4c4.5,5.8,2.6,4.2,6.5,4.1\r c6.7-0.3,5.6,1.7,2.1-12.4l0.6-0.5c9.4,15,5.8,12.6,14.8,12.2c1.1,0.1,2.1,0.5,3,1.2C69.3,51.7,68.3,52.1,67.2,52.1z"
})));

/* eslint-disable max-len */
const IconTotalSpend$1 = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.13 25.86 9.75 17.86 16.35 21.68 22.79 10.53 24.98 11.79 24.98 4.19 18.39 7.99 20.59 9.26 15.42 18.2 8.82 14.39 4.2 22.39 4.2 1.71 1.65 1.71 1.65 28.41 28.35 28.41 28.35 25.86 5.13 25.86"
  })));
};

/* eslint-disable max-len */
var IconTrain = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "17.29 22 19 22 16.36 17 14.67 17 17.29 22"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "8.16 19.1 9.29 17 7.61 17 5 22 6.68 22 7.36 20.67 8.16 19.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,2C8.39,2,5.47,3.79,5.47,6v9.33A2.62,2.62,0,0,0,8,18h8a2.62,2.62,0,0,0,2.55-2.67V6C18.53,3.79,15.6,2,12,2ZM8.5,15A1.5,1.5,0,1,1,10,13.5,1.5,1.5,0,0,1,8.5,15Zm3-5H7.7a.66.66,0,0,1-.64-.67V6.67A.66.66,0,0,1,7.7,6h3.82Zm1-4H16.3a.66.66,0,0,1,.64.67V9.33a.66.66,0,0,1-.64.67H12.48Zm3,9A1.5,1.5,0,1,1,17,13.5,1.5,1.5,0,0,1,15.5,15Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "11.25",
  y: "6",
  width: "1.5",
  height: "4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "7",
  y: "19.25",
  width: "10",
  height: "1.5"
})));

/* eslint-disable max-len */
var IconTrainLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 14 3 C 12.742188 3 11.847656 3.890625 11.40625 5 L 10 5 C 7.25 5 5 7.25 5 10 L 5 21 C 5 23.425781 6.449219 25.523438 8.53125 26.46875 L 6 29 L 8.34375 29 L 10.375 26.96875 C 10.574219 26.988281 10.792969 27 11 27 L 21 27 C 21.207031 27 21.425781 26.988281 21.625 26.96875 L 23.65625 29 L 26 29 L 23.46875 26.46875 C 25.550781 25.523438 27 23.425781 27 21 L 27 10 C 27 7.25 24.75 5 22 5 L 20.59375 5 C 20.152344 3.890625 19.257813 3 18 3 Z M 14 5 L 18 5 C 18.566406 5 19 5.433594 19 6 L 19 7 L 22 7 C 23.320313 7 24.4375 7.828125 24.84375 9 L 7.15625 9 C 7.5625 7.828125 8.679688 7 10 7 L 13 7 L 13 6 C 13 5.433594 13.433594 5 14 5 Z M 7 11 L 25 11 L 25 16 L 7 16 Z M 7 18 L 25 18 L 25 21 C 25 23.21875 23.21875 25 21 25 L 11 25 C 8.78125 25 7 23.21875 7 21 Z M 16 19 C 14.894531 19 14 19.894531 14 21 C 14 22.105469 14.894531 23 16 23 C 17.105469 23 18 22.105469 18 21 C 18 19.894531 17.105469 19 16 19 Z"
})));

/* eslint-disable max-len */
var IconTransfer = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "16.16 16.12 10 16.12 10 13.39 16.16 13.39 16.16 10.3 22 14.76 16.16 19.21 16.16 16.12",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "7.84 10.61 14 10.61 14 7.88 7.84 7.88 7.84 4.79 2 9.24 7.84 13.7 7.84 10.61",
  fillRule: "evenodd"
}))));

/* eslint-disable max-len */
var IconTrashCan = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 15 4 C 14.476563 4 13.941406 4.183594 13.5625 4.5625 C 13.183594 4.941406 13 5.476563 13 6 L 13 7 L 7 7 L 7 9 L 8 9 L 8 25 C 8 26.644531 9.355469 28 11 28 L 23 28 C 24.644531 28 26 26.644531 26 25 L 26 9 L 27 9 L 27 7 L 21 7 L 21 6 C 21 5.476563 20.816406 4.941406 20.4375 4.5625 C 20.058594 4.183594 19.523438 4 19 4 Z M 15 6 L 19 6 L 19 7 L 15 7 Z M 10 9 L 24 9 L 24 25 C 24 25.554688 23.554688 26 23 26 L 11 26 C 10.445313 26 10 25.554688 10 25 Z M 12 12 L 12 23 L 14 23 L 14 12 Z M 16 12 L 16 23 L 18 23 L 18 12 Z M 20 12 L 20 23 L 22 23 L 22 12 Z"
})));

/* eslint-disable max-len */
const IconTotalSpend = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 28.04 16.22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.37,7.63a2.08,2.08,0,0,1,3.2,0L28.62,21.22c.88,1,.22,1.88-1.33,1.88H2.76c-1.65,0-2.32-.88-1.32-1.88Z",
    transform: "translate(-0.97 -6.88)"
  })));
};

/* eslint-disable max-len */
const IconTrips = props => {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.78,9.74V24.83A2.07,2.07,0,0,0,2.85,26.9h3V7.67h-3A2.07,2.07,0,0,0,.78,9.74ZM27.27,7.67h-3V26.9h3a2.07,2.07,0,0,0,2.07-2.07V9.74A2.07,2.07,0,0,0,27.27,7.67ZM8.15,26.9H22V7.67H8.15ZM11.46,6.27a1.85,1.85,0,0,1,1.85-1.85h3.5a1.85,1.85,0,0,1,1.84,1.85v.36h1.89v-.5a2.83,2.83,0,0,0-2.82-2.82H12.39A2.83,2.83,0,0,0,9.58,6.13v.5h1.88Z"
  })));
};

/* eslint-disable max-len */
var IconUSB = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.06,8.38V12h1v1.79h-3V6.58h2L12.1,3l-3,3.58h2v7.17h-3V11.9a1.94,1.94,0,0,0,1.19-1.73,2.09,2.09,0,0,0-2.17-2,2.09,2.09,0,0,0-2.17,2A2,2,0,0,0,6.18,11.9v1.85a1.89,1.89,0,0,0,2,1.8h3v2.73A2,2,0,0,0,9.93,20a2.08,2.08,0,0,0,2.17,2,2.08,2.08,0,0,0,2.17-2,2,2,0,0,0-1.19-1.75V15.55h3a1.88,1.88,0,0,0,2-1.8V12h1V8.38Z"
})));

/* eslint-disable max-len */
var IconUSAFlag = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,7V17H29V15H17V13H29V11H17V9H29V7H3ZM5,8A1,1,0,1,1,4,9,1,1,0,0,1,5,8ZM9,8A1,1,0,1,1,8,9,1,1,0,0,1,9,8Zm4,0a1,1,0,1,1-1,1A1,1,0,0,1,13,8ZM7,11a1,1,0,1,1-1,1A1,1,0,0,1,7,11Zm4,0a1,1,0,1,1-1,1A1,1,0,0,1,11,11Zm4,0a1,1,0,1,1-1,1A1,1,0,0,1,15,11ZM5,14a1,1,0,1,1-1,1A1,1,0,0,1,5,14Zm4,0a1,1,0,1,1-1,1A1,1,0,0,1,9,14Zm4,0a1,1,0,1,1-1,1A1,1,0,0,1,13,14ZM3,19v2H29V19Zm0,4v2H29V23Z"
})));

/* eslint-disable max-len */
var IconUser = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 5 C 12.144531 5 9 8.144531 9 12 C 9 14.410156 10.230469 16.550781 12.09375 17.8125 C 8.527344 19.34375 6 22.882813 6 27 L 8 27 C 8 22.570313 11.570313 19 16 19 C 20.429688 19 24 22.570313 24 27 L 26 27 C 26 22.882813 23.472656 19.34375 19.90625 17.8125 C 21.769531 16.550781 23 14.410156 23 12 C 23 8.144531 19.855469 5 16 5 Z M 16 7 C 18.773438 7 21 9.226563 21 12 C 21 14.773438 18.773438 17 16 17 C 13.226563 17 11 14.773438 11 12 C 11 9.226563 13.226563 7 16 7 Z"
})));

/* eslint-disable max-len */
var IconUserCheck = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 12 2 C 8.144531 2 5 5.144531 5 9 C 5 11.410156 6.230469 13.550781 8.09375 14.8125 C 4.527344 16.34375 2 19.882813 2 24 L 4 24 C 4 19.570313 7.570313 16 12 16 C 13.375 16 14.65625 16.359375 15.78125 16.96875 C 14.671875 18.34375 14 20.101563 14 22 C 14 26.40625 17.59375 30 22 30 C 26.40625 30 30 26.40625 30 22 C 30 17.59375 26.40625 14 22 14 C 20.253906 14 18.628906 14.574219 17.3125 15.53125 C 16.871094 15.253906 16.390625 15.019531 15.90625 14.8125 C 17.769531 13.550781 19 11.410156 19 9 C 19 5.144531 15.855469 2 12 2 Z M 12 4 C 14.773438 4 17 6.226563 17 9 C 17 11.773438 14.773438 14 12 14 C 9.226563 14 7 11.773438 7 9 C 7 6.226563 9.226563 4 12 4 Z M 22 16 C 25.324219 16 28 18.675781 28 22 C 28 25.324219 25.324219 28 22 28 C 18.675781 28 16 25.324219 16 22 C 16 18.675781 18.675781 16 22 16 Z M 25.28125 19.28125 L 22 22.5625 L 19.71875 20.28125 L 18.28125 21.71875 L 21.28125 24.71875 L 22 25.40625 L 22.71875 24.71875 L 26.71875 20.71875 Z"
})));

/* eslint-disable max-len */
var IconUserCog = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.92,2A5.25,5.25,0,0,0,5.64,7.28,5.24,5.24,0,0,0,8,11.67a7.59,7.59,0,0,0-4.58,6.94H4.88a6.06,6.06,0,0,1,6-6A5.29,5.29,0,1,0,10.92,2Zm0,1.51A3.78,3.78,0,1,1,7.15,7.28,3.74,3.74,0,0,1,10.92,3.51ZM17,11.81V13.4a3.86,3.86,0,0,0-1.29.53L14.62,12.8l-1.06,1L14.7,15a2.57,2.57,0,0,0-.53,1.35H12.43v1.51H14a4.94,4.94,0,0,0,.52,1.36l-1.13,1.14,1.06,1,1.13-1.13a3.9,3.9,0,0,0,1.28.53v1.58h1.51V20.8a3.86,3.86,0,0,0,1.29-.53l1.13,1.13,1.06-1-1.13-1.14a2.65,2.65,0,0,0,.52-1.36H23V16.34H21.41A5,5,0,0,0,20.89,15L22,13.85,21,12.8l-1.13,1.13a3.9,3.9,0,0,0-1.28-.53V11.81Zm.68,3a2.27,2.27,0,1,1-2.27,2.27A2.23,2.23,0,0,1,17.72,14.83Zm0,1.51a.68.68,0,0,0-.28.07.81.81,0,0,0-.24.17,1.08,1.08,0,0,0-.18.24.71.71,0,0,0-.06.28.81.81,0,0,0,.48.69.67.67,0,0,0,.28.06.81.81,0,0,0,.75-.75A.82.82,0,0,0,17.72,16.34Z"
})));

/* eslint-disable max-len */
var IconUserCircle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 16 8 C 13.25 8 11 10.25 11 13 C 11 14.515625 11.707031 15.863281 12.78125 16.78125 C 10.53125 17.949219 9 20.300781 9 23 L 11 23 C 11 20.226563 13.226563 18 16 18 C 18.773438 18 21 20.226563 21 23 L 23 23 C 23 20.300781 21.46875 17.949219 19.21875 16.78125 C 20.292969 15.863281 21 14.515625 21 13 C 21 10.25 18.75 8 16 8 Z M 16 10 C 17.667969 10 19 11.332031 19 13 C 19 14.667969 17.667969 16 16 16 C 14.332031 16 13 14.667969 13 13 C 13 11.332031 14.332031 10 16 10 Z"
})));

/* eslint-disable max-len */
var IconViewModify = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2,19.12H2V17.68H2v-10a1.92,1.92,0,0,1,.77-1.55L6,2.93a2.11,2.11,0,0,1,1.78-.88h7.66a2,2,0,0,1,2,2V6.48l-.06-.05h0v0h0l0,0,0,0h0l0,0h0l0,0,0,0h0v0l0,0h0l0,0h0v0h0l0,0h0l0,0h0l0,0h0l0,0-.05,0h0l-.05,0h0l0,0h0l0,0-.05,0h0l-.06,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0v0l0,0h0l0,0h0l0-1.54a.8.8,0,0,0-.8-.78H7.91V6.12A1.85,1.85,0,0,1,6.06,8H3.24V20a.81.81,0,0,0,.81.8H15.39a.79.79,0,0,0,.78-.8V17.49l1.26,1.4V20a2.06,2.06,0,0,1-2,2H4.05a2.05,2.05,0,0,1-2-2Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.81,17.69,19,14.51a.77.77,0,0,0-.92-.18l-.64-.72A4.86,4.86,0,0,0,18.32,11a4.77,4.77,0,0,0-4.49-5,4.79,4.79,0,0,0-5.06,4.49A4.77,4.77,0,0,0,10,13.92a4.78,4.78,0,0,0,6,.95l.65.74a.75.75,0,0,0,.06.92l2.87,3.19a.74.74,0,0,0,1.07.06l1.15-1A.79.79,0,0,0,21.81,17.69Zm-5.89-4.28a3.64,3.64,0,0,1-2.58.89,3.55,3.55,0,0,1-2.44-1.18,3.57,3.57,0,0,1,.28-5A3.56,3.56,0,0,1,17.1,11,3.51,3.51,0,0,1,15.92,13.41Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.22,17.5a.57.57,0,0,0-.63-.5H5.84a.58.58,0,0,0-.64.5.58.58,0,0,0,.64.5h7.75a.58.58,0,0,0,.63-.5Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.78,11H5.84c-.36,0-.64.17-.64.37s.28.39.64.39h2A1.82,1.82,0,0,1,7.78,11Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.57,14H5.84c-.36,0-.64.21-.64.46s.28.47.64.47H9.56a3.75,3.75,0,0,1-.33-.26A5.2,5.2,0,0,1,8.57,14Z",
  fillRule: "evenodd"
}))));

/* eslint-disable max-len */
var IconWallet = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2 7.2h-15v-0.6l13.2-1.056v1.056h1.8v-1.8c0-1.32-1.069-2.246-2.375-2.060l-12.049 1.721c-1.307 0.187-2.376 1.42-2.376 2.74v12c0 1.325 1.074 2.4 2.4 2.4h14.4c1.325 0 2.4-1.075 2.4-2.4v-9.6c0-1.325-1.075-2.4-2.4-2.4zM17.4 15.607c-0.994 0-1.8-0.806-1.8-1.8s0.806-1.8 1.8-1.8 1.8 0.806 1.8 1.8-0.806 1.8-1.8 1.8z"
})));

/* eslint-disable max-len */
var IconWalletLine = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 22.96875 4 C 22.816406 4.003906 22.65625 4.023438 22.5 4.0625 L 6.25 8.34375 C 4.9375 8.6875 4 9.890625 4 11.25 L 4 25 C 4 26.644531 5.355469 28 7 28 L 25 28 C 26.644531 28 28 26.644531 28 25 L 28 12 C 28 10.355469 26.644531 9 25 9 L 11.625 9 L 23 6 L 23 8 L 25 8 L 25 6 C 25 4.875 24.042969 3.984375 22.96875 4 Z M 7 11 L 25 11 C 25.566406 11 26 11.433594 26 12 L 26 25 C 26 25.566406 25.566406 26 25 26 L 7 26 C 6.433594 26 6 25.566406 6 25 L 6 12 C 6 11.433594 6.433594 11 7 11 Z M 22.5 17 C 21.671875 17 21 17.671875 21 18.5 C 21 19.328125 21.671875 20 22.5 20 C 23.328125 20 24 19.328125 24 18.5 C 24 17.671875 23.328125 17 22.5 17 Z"
})));

/* eslint-disable max-len */
var IconWarning = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  "aria-hidden": "true",
  role: "img",
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
})));

/* eslint-disable max-len */
var IconWarningCircle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 4 C 9.382813 4 4 9.382813 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 C 28 9.382813 22.617188 4 16 4 Z M 16 6 C 21.535156 6 26 10.464844 26 16 C 26 21.535156 21.535156 26 16 26 C 10.464844 26 6 21.535156 6 16 C 6 10.464844 10.464844 6 16 6 Z M 15 10 L 15 18 L 17 18 L 17 10 Z M 15 20 L 15 22 L 17 22 L 17 20 Z"
})));

/* eslint-disable max-len */
var IconWarningCircleSolid = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 17q.425 0 .713-.288Q13 16.425 13 16t-.287-.713Q12.425 15 12 15t-.712.287Q11 15.575 11 16t.288.712Q11.575 17 12 17Zm-1-4h2V7h-2Zm1 9q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Z"
})));

/* eslint-disable max-len */
var IconWarningTriangle = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  "aria-hidden": "true",
  role: "img",
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 16 3.21875 L 15.125 4.71875 L 3.125 25.5 L 2.28125 27 L 29.71875 27 L 28.875 25.5 L 16.875 4.71875 Z M 16 7.21875 L 26.25 25 L 5.75 25 Z M 15 14 L 15 20 L 17 20 L 17 14 Z M 15 21 L 15 23 L 17 23 L 17 21 Z"
})));

/* eslint-disable max-len */
var IconWiFi = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12,17.25a3.27,3.27,0,0,1,1.92.63.57.57,0,0,0,.75-.05l.85-.85a.58.58,0,0,0,0-.86,5.57,5.57,0,0,0-7,0,.58.58,0,0,0,0,.86l.85.85a.57.57,0,0,0,.75.05A3.27,3.27,0,0,1,12,17.25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,12.8a7.68,7.68,0,0,1,5.07,1.92.53.53,0,0,0,.73,0l.9-.9a.55.55,0,0,0,0-.79A10,10,0,0,0,5.32,13a.55.55,0,0,0,0,.79l.9.9a.53.53,0,0,0,.73,0A7.68,7.68,0,0,1,12,12.8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,8.35a12.07,12.07,0,0,1,8.2,3.21.55.55,0,0,0,.76,0l.88-.89a.55.55,0,0,0,0-.79,14.42,14.42,0,0,0-19.64,0,.55.55,0,0,0,0,.79l.88.89a.55.55,0,0,0,.76,0A12.07,12.07,0,0,1,12,8.35Z"
}))));

/* eslint-disable max-len */
var IconWiFiFast = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.91,7.48l.78-2.25A14.68,14.68,0,0,0,2.18,8.86a.55.55,0,0,0,0,.79l.89.89a.55.55,0,0,0,.76,0A12.28,12.28,0,0,1,12.1,7.35,12.05,12.05,0,0,1,13.91,7.48Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "16.85 4 20.87 4 18.29 9.91 22 9.91 14 21 17.45 12.09 14.3 12.09 16.85 4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.44,11.81l.8-2.29a10.9,10.9,0,0,0-1.14-.07A10.12,10.12,0,0,0,5.36,12a.54.54,0,0,0,0,.79l.91.9a.54.54,0,0,0,.74,0A7.79,7.79,0,0,1,12.1,11.8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.73,16.69l.93-2.17a5.65,5.65,0,0,0-6.08.6.58.58,0,0,0,0,.86l.86.85a.58.58,0,0,0,.76.05,3.31,3.31,0,0,1,1.94-.63A3.23,3.23,0,0,1,13.73,16.69Z"
})));

/* eslint-disable max-len */
var IconYahoo = props => /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  strokeOpacity: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.31,2a7.14,7.14,0,0,0,1.28.15A12.38,12.38,0,0,0,7.19,2L12,10.58,16.81,2a9.76,9.76,0,0,0,1.61.19A4.69,4.69,0,0,0,19.69,2L13.35,13.15,13.54,22A5.87,5.87,0,0,0,12,21.62a5.87,5.87,0,0,0-1.54.38l.19-8.85Z",
  fill: "#4a089f"
})));

/* eslint-disable max-len */
var AdjustmentsHorizontal = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 6l8 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 6l4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 12l2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 12l10 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 18l11 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 18l1 0"
}));

/* eslint-disable max-len */
var Alarm = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 10l0 3l2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 4l-2.75 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 4l2.75 2"
}));

/* eslint-disable max-len */
var AlarmAverage = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 4l-2.75 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 4l2.75 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 13h1l2 3l2 -6l2 3h1"
}));

/* eslint-disable max-len */
var AlertTriangle = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 9v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 16h.01"
}));

/* eslint-disable max-len */
var ArmchairLounge = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 10v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 15v-2a3 3 0 1 1 3 3v3h-14v-3a3 3 0 1 1 3 -3v2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 12h8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 19v2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 19v2"
}));

/* eslint-disable max-len */
var ArrowGuide = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 19h3a2 2 0 0 0 2 -2v-8a2 2 0 0 1 2 -2h7"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 4l3 3l-3 3"
}));

/* eslint-disable max-len */
var ArrowLeft = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l14 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l6 6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l6 -6"
}));

/* eslint-disable max-len */
var ArrowNarrowDown = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 5l0 14"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 15l-4 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 15l4 4"
}));

/* eslint-disable max-len */
var ArrowNarrowLeft = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l14 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l4 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l4 -4"
}));

/* eslint-disable max-len */
var ArrowNarrowRight = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l14 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 16l4 -4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 8l4 4"
}));

/* eslint-disable max-len */
var ArrowNarrowUp = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 5l0 14"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 9l-4 -4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 9l4 -4"
}));

/* eslint-disable max-len */
var ArrowRampRight = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 3l0 8.707"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 7l-4 -4l-4 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 14l4 -4l-4 -4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 21a11 11 0 0 1 11 -11h3"
}));

/* eslint-disable max-len */
var ArrowRight = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l14 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 18l6 -6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 6l6 6"
}));

/* eslint-disable max-len */
var ArrowUpLeft = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 7l10 10"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 7l-9 0l0 9"
}));

/* eslint-disable max-len */
var ArrowUpRight = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 7l-10 10"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 7l9 0l0 9"
}));

/* eslint-disable max-len */
var ArrowUp = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 5l0 14"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 11l-6 -6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 11l6 -6"
}));

/* eslint-disable max-len */
var AutomaticGearbox = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 17v4h1a2 2 0 1 0 0 -4h-1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 11h1.5a1.5 1.5 0 0 0 0 -3h-1.5v5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  vectorEffect: "non-scaling-stroke",
  d: "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 7v3a1 1 0 0 0 1 1h3v7a1 1 0 0 0 1 1h3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 11h4"
}));

/* eslint-disable max-len */
var Award = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 9m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 15l3.4 5.89l1.598 -3.233l3.598 .232l-3.4 -5.889"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6.802 12l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889"
}));

/* eslint-disable max-len */
var Backpack = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 18v-6a6 6 0 0 1 6 -6h2a6 6 0 0 1 6 6v6a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 6v-1a2 2 0 1 1 4 0v1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 10h2"
}));

/* eslint-disable max-len */
var Bed = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M22 17v-3h-20"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M2 8v9"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 14h10v-2a3 3 0 0 0 -3 -3h-7v5z"
}));

/* eslint-disable max-len */
var Books = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 8h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 16h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13.803 4.56l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.695 13.418a1.02 1.02 0 0 1 -.634 1.219l-.133 .041l-2.184 .53c-.562 .135 -1.133 -.19 -1.282 -.732l-3.695 -13.418a1.02 1.02 0 0 1 .634 -1.219l.133 -.041z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 9l4 -1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 16l3.923 -.98"
}));

/* eslint-disable max-len */
var BrandSlack = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12v-6a2 2 0 0 1 4 0v6m0 -2a2 2 0 1 1 2 2h-6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12h6a2 2 0 0 1 0 4h-6m2 0a2 2 0 1 1 -2 2v-6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12v6a2 2 0 0 1 -4 0v-6m0 2a2 2 0 1 1 -2 -2h6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12h-6a2 2 0 0 1 0 -4h6m-2 0a2 2 0 1 1 2 -2v6"
}));

/* eslint-disable max-len */
var BrandTeams = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 7h10v10h-10z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 10h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 10v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8.104 17c.47 2.274 2.483 4 4.896 4a5 5 0 0 0 5 -5v-7h-5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 18a4 4 0 0 0 4 -4v-5h-4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13.003 8.83a3 3 0 1 0 -1.833 -1.833"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15.83 8.36a2.5 2.5 0 1 0 .594 -4.117"
}));

/* eslint-disable max-len */
var Briefcase = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 13a20 20 0 0 0 18 0"
}));

/* eslint-disable max-len */
var BuildingCommunity = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 7l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 7l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 11l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 15l0 .01"
}));

/* eslint-disable max-len */
var BuildingFortress = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 7h0v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 10h0v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 13h0v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 7h0v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 10h0v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 13h0v.01"
}));

/* eslint-disable max-len */
var BuildingSkyscraper = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 21l18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 21v-14l8 -4v18"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 21v-10l-6 -4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 9l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 12l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 15l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 18l0 .01"
}));

/* eslint-disable max-len */
var Calculator = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 3m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 14l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 14l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 14l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 17l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 17l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 17l0 .01"
}));

/* eslint-disable max-len */
var CalendarClock = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 3v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 3v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 11h10"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 16.5v1.5l.5 .5"
}));

/* eslint-disable max-len */
var CalendarDollar = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 3v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 3v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 11h12.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 21v1m0 -8v1"
}));

/* eslint-disable max-len */
var CalendarEvent = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 3l0 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 3l0 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 11l16 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 15h2v2h-2z"
}));

/* eslint-disable max-len */
var Calendar = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 3v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 3v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 11h16"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 15h1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 15v3"
}));

/* eslint-disable max-len */
var Car = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0h24v24H0V0Z",
  fill: "none",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6.5",
  cy: "13.5",
  r: ".5",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "17.5",
  cy: "13.5",
  r: ".5",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.47,9.24l1.46.46,1.03-3.22c.28-.89,1.17-1.49,2.16-1.49h9.77c.99,0,1.87.6,2.16,1.49l1.03,3.22,1.46-.46.47,1.31-1.48.46.47,1.49c.02.06.03.13.02.2v4.9s0,.07,0,.11v.59c0,.39-.34.7-.75.7h-2.25l-.26-.7H6.25l-.26.7h-2.25c-.41,0-.75-.31-.75-.7v-5.6c0-.07,0-.13.02-.2l.47-1.49-1.48-.46.47-1.31ZM3,10h18M3,18h3M18,18h3",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}));

/* eslint-disable max-len */
var CarDoor = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7.4,5.8c1.32-1.76,3.4-2.8,5.6-2.8h5c1.66,0,3,1.34,3,3v13c0,1.1-.9,2-2,2H5c-1.1,0-2-.9-2-2v-5.67c0-1.08.35-2.13,1-3l3.4-4.53ZM3,12.04h18"
}), /*#__PURE__*/React.createElement("line", {
  vectorEffect: "non-scaling-stroke",
  x1: "15",
  y1: "16",
  x2: "17",
  y2: "16"
}));

/* eslint-disable max-len */
var Cash = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
}));

/* eslint-disable max-len */
var CashBanknote = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 12l.01 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 12l.01 0"
}));

/* eslint-disable max-len */
var CashBanknoteOff = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 12l.01 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 12l.01 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 3l18 18"
}));

/* eslint-disable max-len */
var ChartBar = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 20l14 0"
}));

/* eslint-disable max-len */
var Chat = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1"
}));

/* eslint-disable max-len */
var Check = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l5 5l10 -10"
}));

/* eslint-disable max-len */
var Checkbox = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 11l3 3l8 -8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"
}));

/* eslint-disable max-len */
var ChevronDown = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 9l6 6l6 -6"
}));

/* eslint-disable max-len */
var ChevronLeft = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 6l-6 6l6 6"
}));

/* eslint-disable max-len */
var ChevronRight = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 6l6 6l-6 6"
}));

/* eslint-disable max-len */
var ChevronUp = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 15l6 -6l6 6"
}));

/* eslint-disable max-len */
var CircleCheck = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 12l2 2l4 -4"
}));

/* eslint-disable max-len */
var CircleDot = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
}));

/* eslint-disable max-len */
var ClipboardCheck = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 14l2 2l4 -4"
}));

/* eslint-disable max-len */
var ClipboardText = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 12h6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 16h6"
}));

/* eslint-disable max-len */
var Clock = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 7v5l3 3"
}));

/* eslint-disable max-len */
var ClockCheck = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.942 13.021a9 9 0 1 0 -9.407 7.967"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 7v5l3 3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 19l2 2l4 -4"
}));

/* eslint-disable max-len */
var ClockQuestion = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.975 11.33a9 9 0 1 0 -5.717 9.06"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 7v5l2 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 22v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
}));

/* eslint-disable max-len */
var ClockSearch = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.993 11.646a9 9 0 1 0 -9.318 9.348"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 7v5l1 1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.2 20.2l1.8 1.8"
}));

/* eslint-disable max-len */
var ClockStar = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.982 11.436a9 9 0 1 0 -9.966 9.51"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 7v5l1 1"
}));

/* eslint-disable max-len */
var Copy = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
}));

/* eslint-disable max-len */
var CopyCheck = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 14l2 2l4 -4"
}));

/* eslint-disable max-len */
var CreditCard = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 10l18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 15l.01 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 15l2 0"
}));

/* eslint-disable max-len */
var CreditCardOff = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 3l18 18"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.128 .87"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18.87 18.872a3 3 0 0 1 -.87 .128h-12a3 3 0 0 1 -3 -3v-8c0 -1.352 .894 -2.495 2.124 -2.87"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 11l8 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 11l6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 15l.01 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 15l2 0"
}));

/* eslint-disable max-len */
var CurrencyDollar = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 3v3m0 12v3"
}));

/* eslint-disable max-len */
var CurrencyDollarOff = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4m-2.557 1.431a3 3 0 0 0 2.557 4.569h2m4.564 4.558a3 3 0 0 1 -2.564 1.442h-4a3 3 0 0 1 -2.7 -2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 3v3m0 12v3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 3l18 18"
}));

/* eslint-disable max-len */
var DeviceFloppy = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 4l0 4l-6 0l0 -4"
}));

/* eslint-disable max-len */
var DeviceMobileMessage = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 3h10v8h-3l-4 2v-2h-3z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 18v.01"
}));

/* eslint-disable max-len */
var DirectionSign = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3.32 12.774l7.906 7.905c.427 .428 1.12 .428 1.548 0l7.905 -7.905a1.095 1.095 0 0 0 0 -1.548l-7.905 -7.905a1.095 1.095 0 0 0 -1.548 0l-7.905 7.905a1.095 1.095 0 0 0 0 1.548z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 12h7.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 8.5l3.5 3.5l-3.5 3.5"
}));

/* eslint-disable max-len */
var DotsCircleHorizontal = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 12l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 12l0 .01"
}));

/* eslint-disable max-len */
var DotsHorizontal = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}));

/* eslint-disable max-len */
var DotsVertical = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}));

/* eslint-disable max-len */
var Download = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 11l5 5l5 -5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 4l0 12"
}));

/* eslint-disable max-len */
var Edit = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 5l3 3"
}));

/* eslint-disable max-len */
var ExclamationCircle = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 9v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 16v.01"
}));

/* eslint-disable max-len */
var ExternalLink = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 13l9 -9"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 4h5v5"
}));

/* eslint-disable max-len */
var FileAnalytics = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 3v4a1 1 0 0 0 1 1h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 17l0 -5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 17l0 -1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 17l0 -3"
}));

/* eslint-disable max-len */
var FileDollar = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 3v4a1 1 0 0 0 1 1h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 17v1m0 -8v1"
}));

/* eslint-disable max-len */
var FileInvoice = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 3v4a1 1 0 0 0 1 1h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 7l1 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 13l6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 17l2 0"
}));

/* eslint-disable max-len */
var FileText = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 3v4a1 1 0 0 0 1 1h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 9l1 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 13l6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 17l6 0"
}));

/* eslint-disable max-len */
var FileTime = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 3v4a1 1 0 0 0 1 1h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12.496v1.504l1 1"
}));

/* eslint-disable max-len */
var Filter = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z"
}));

/* eslint-disable max-len */
var HamburgerMenu = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 6l16 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 12l16 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 18l16 0"
}));

/* eslint-disable max-len */
var Help = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 17l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
}));

/* eslint-disable max-len */
var HelpSquareRounded = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 16v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
}));

/* eslint-disable max-len */
var History = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 8l0 4l2 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"
}));

/* eslint-disable max-len */
var Home = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l-2 0l9 -9l9 9l-2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"
}));

/* eslint-disable max-len */
var Hotel = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0h24v24H0V0Z",
  fill: "none",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,7h.01",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,7h.01",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,7h.01",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,11h.01",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,11h.01",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,11h.01",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,4.8v14.4c0,.99-.78,1.8-1.75,1.8H6.75c-.97,0-1.75-.81-1.75-1.8V4.8c0-.99.78-1.8,1.75-1.8h10.5c.97,0,1.75.81,1.75,1.8ZM15,16l-.35-.24c-1.46-1.01-3.84-1.01-5.3,0l-.35.24M10,20v-4.5M14,15.5v4.5",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth,
  vectorEffect: "non-scaling-stroke"
}));

/* eslint-disable max-len */
var HotelService = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8.5 10a1.5 1.5 0 0 1 -1.5 -1.5a5.5 5.5 0 0 1 11 0v10.5a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2c0 -1.38 .71 -2.444 1.88 -3.175l4.424 -2.765c1.055 -.66 1.696 -1.316 1.696 -2.56a2.5 2.5 0 1 0 -5 0a1.5 1.5 0 0 1 -1.5 1.5z"
}));

/* eslint-disable max-len */
var Hourglass = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6.5 7h11"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6.5 17h11"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
}));

/* eslint-disable max-len */
var Id = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 8l2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 12l2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 16l10 0"
}));

/* eslint-disable max-len */
var InfoCircle = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 9h.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 12h1v4h1"
}));

/* eslint-disable max-len */
var InputSearch = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20 11v-2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.2 20.2l1.8 1.8"
}));

/* eslint-disable max-len */
var KeyframeHorizontal = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 12h2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 12h2"
}));

/* eslint-disable max-len */
var KeyframeVertical = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 2v2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 20v2"
}));

/* eslint-disable max-len */
var LayoutGrid = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}));

/* eslint-disable max-len */
var Library = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 7h5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 10h6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 13h3"
}));

/* eslint-disable max-len */
var LineDotted = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 12v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 12v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 12v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20 12v.01"
}));

/* eslint-disable max-len */
var LinkChain = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 15l6 -6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"
}));

/* eslint-disable max-len */
var List = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 6l11 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 12l11 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 18l11 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 6l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l0 .01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 18l0 .01"
}));

/* eslint-disable max-len */
var ListDetails = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 5h8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 9h5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 15h8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 19h5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
}));

/* eslint-disable max-len */
var ListLong = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 3h16"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 9h16"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 15h16"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 21h16"
}));

/* eslint-disable max-len */
var ListNumbers = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 6h9"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 12h9"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 18h8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 10v-6l-2 2"
}));

/* eslint-disable max-len */
var ListRows = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 14m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
}));

/* eslint-disable max-len */
var Lock = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 11v-4a4 4 0 1 1 8 0v4"
}));

/* eslint-disable max-len */
var Luggage = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 10h12"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 16h12"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 20v1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 20v1"
}));

/* eslint-disable max-len */
var Mail = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 7l9 6l9 -6"
}));

/* eslint-disable max-len */
var MapPin = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
}));

/* eslint-disable max-len */
var Map = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v7.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 4v13"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 7v5.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 18v.01"
}));

/* eslint-disable max-len */
var Message = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 9h8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 13h6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z"
}));

/* eslint-disable max-len */
var MessageCircle = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1"
}));

/* eslint-disable max-len */
var Messages = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
}));

/* eslint-disable max-len */
var Minus = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l14 0"
}));

/* eslint-disable max-len */
var Notes = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 7l6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 11l6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 15l4 0"
}));

/* eslint-disable max-len */
var Pencil = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13.5 6.5l4 4"
}));

/* eslint-disable max-len */
var Percentage10 = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3c1.92 0 3.7 .601 5.16 1.626l-5.16 7.374z",
  fill: "currentColor",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
}));

/* eslint-disable max-len */
var Percentage20 = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3a9 9 0 0 1 8.497 6.025l-8.497 2.975z",
  fill: "currentColor",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
}));

/* eslint-disable max-len */
var Percentage25 = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 12a9 9 0 0 0 -9 -9m0 0v9h9",
  fill: "currentColor",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
}));

/* eslint-disable max-len */
var Phone = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
}));

/* eslint-disable max-len */
var PiggyBank = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 11v.01"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5.173 8.378a3 3 0 1 1 4.656 -1.377"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 4v3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.336 .95 -.907 1.8 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3h0z"
}));

/* eslint-disable max-len */
var PlaneArrival = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15.157 11.81l4.83 1.295a2 2 0 1 1 -1.036 3.863l-14.489 -3.882l-1.345 -6.572l2.898 .776l1.414 2.45l2.898 .776l-.12 -7.279l2.898 .777l2.052 7.797z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 21h18"
}));

/* eslint-disable max-len */
var PlaneDeparture = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14.639 10.258l4.83 -1.294a2 2 0 1 1 1.035 3.863l-14.489 3.883l-4.45 -5.02l2.897 -.776l2.45 1.414l2.897 -.776l-3.743 -6.244l2.898 -.777l5.675 5.727z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 21h18"
}));

/* eslint-disable max-len */
var PlaneInflight = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 11.085h5a2 2 0 1 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3l4 7z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 21h18"
}));

/* eslint-disable max-len */
var PlaneSeat = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14,21l-1.41-4.39M9,21h8M9,10h6M5.34,3.42c-.29.38-.33.81-.34,1.02l1.1,10.11c.09.8.85,1.44,1.7,1.44h3.09c.29,0,2.16,0,2.35,0,.15,0,.95,0,.95,0,.47,0,.69,0,.95,0,.62,0,.64,0,.71,0,0,0,.02,0,.04,0,.07,0,.86-.01,1.11,0,.51.02,1.07-.28,1-1-.07-.69-.17-1.45-.7-1.78-.34-.21-1.16-.22-2.8-.22,0,0,0,0,0,0-.91,0-2.32,0-4.49,0h-1c-.33-2-.67-4-1-6,.18-.31.84-1.52.4-2.82-.1-.3-.3-.87-.87-1.18-.67-.37-1.67-.25-2.19.42Z"
}));

/* eslint-disable max-len */
var PlaneTicket = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0h24v24H0V0Z",
  fill: "none",
  strokeWidth: "0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5,5h14c1.1,0,2,.9,2,2v3c-1.1,0-2,.9-2,2s.9,2,2,2v3c0,1.1-.9,2-2,2H5c-1.1,0-2-.9-2-2v-3c1.1,0,2-.9,2-2s-.9-2-2-2v-3c0-1.1.9-2,2-2",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.48,15l-1.48-2.75.83-.24,1.12.95,2.13-.61-2.14-3.98,1.25-.36,3.57,3.58,2.17-.62c.46-.13.93.16,1.05.65.11.5-.16,1-.61,1.14l-7.88,2.26Z",
  strokeWidth: "0",
  fill: "currentColor"
}));

/* eslint-disable max-len */
var PlaneTilt = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14.5 6.5l3 -2.9a2.05 2.05 0 0 1 2.9 2.9l-2.9 3l2.5 7.5l-2.5 2.55l-3.5 -6.55l-3 3v3l-2 2l-1.5 -4.5l-4.5 -1.5l2 -2h3l3 -3l-6.5 -3.5l2.5 -2.5l7.5 2.5z"
}));

/* eslint-disable max-len */
var Plane = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z"
}));

/* eslint-disable max-len */
var Plus = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 5l0 14"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 12l14 0"
}));

/* eslint-disable max-len */
var Printer = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z"
}));

/* eslint-disable max-len */
var Quote = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
}));

/* eslint-disable max-len */
var Receipt = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5"
}));

/* eslint-disable max-len */
var Reload = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20 4v5h-5"
}));

/* eslint-disable max-len */
var Report = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 14v4h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 11v-4a2 2 0 0 0 -2 -2h-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 11h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 15h3"
}));

/* eslint-disable max-len */
var ReportAnalytics = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 17v-5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 17v-1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 17v-3"
}));

/* eslint-disable max-len */
var ReportSearch = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 12v-5a2 2 0 0 0 -2 -2h-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 11h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 15h3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18.5 19.5l2.5 2.5"
}));

/* eslint-disable max-len */
var Road = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 19l4 -14"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 5l4 14"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 8v-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 13v-2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 18v-2"
}));

/* eslint-disable max-len */
var RouteAlt = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2"
}));

/* eslint-disable max-len */
var Search = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M21 21l-6 -6"
}));

/* eslint-disable max-len */
var Settings = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
}));

/* eslint-disable max-len */
var Shield = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
}));

/* eslint-disable max-len */
var ShieldCheck = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12,3c2.34,2.07,5.38,3.14,8.5,3,1.87,6.36-1.77,13.03-8.13,14.9-.12.04-.25.07-.37.1C5.58,19.34,1.73,12.79,3.4,6.37c.03-.12.07-.25.1-.37,3.12.14,6.16-.93,8.5-3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9.08,12.83l2,2,4-4"
}));

/* eslint-disable max-len */
var ShieldOff = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17.67 17.667a12 12 0 0 1 -5.67 3.333a12 12 0 0 1 -8.5 -15c.794 .036 1.583 -.006 2.357 -.124m3.128 -.926a11.997 11.997 0 0 0 3.015 -1.95a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.116 9.376"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 3l18 18"
}));

/* eslint-disable max-len */
var Snowflake = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 4l2 1l2 -1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 2v6.5l3 1.72"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17.928 6.268l.134 2.232l1.866 1.232"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.66 7l-5.629 3.25l.01 3.458"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M19.928 14.268l-1.866 1.232l-.134 2.232"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20.66 17l-5.629 -3.25l-2.99 1.738"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 20l-2 -1l-2 1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 22v-6.5l-3 -1.72"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6.072 17.732l-.134 -2.232l-1.866 -1.232"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3.34 17l5.629 -3.25l-.01 -3.458"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4.072 9.732l1.866 -1.232l.134 -2.232"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3.34 7l5.629 3.25l2.99 -1.738"
}));

/* eslint-disable max-len */
var SortAscending = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 6l7 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 12l7 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 18l9 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 9l3 -3l3 3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 6l0 12"
}));

/* eslint-disable max-len */
var SortDescending = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 6l9 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 12l7 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 18l7 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 15l3 3l3 -3"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 6l0 12"
}));

/* eslint-disable max-len */
var Square = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
}));

/* eslint-disable max-len */
var Star = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
}));

/* eslint-disable max-len */
var Stopwatch = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14.5 10.5l-2.5 2.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M17 8l1 -1"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 3h-4"
}));

/* eslint-disable max-len */
var SwitchHorizontal = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 3l4 4l-4 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 7l10 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 13l-4 4l4 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 17l9 0"
}));

/* eslint-disable max-len */
var Tag = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"
}));

/* eslint-disable max-len */
var Ticket = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 5l0 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 11l0 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 17l0 2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"
}));

/* eslint-disable max-len */
var TicketOff = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 5v2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M15 17v2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 5h10a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3m-2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 1 0 0 -4v-3a2 2 0 0 1 2 -2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 3l18 18"
}));

/* eslint-disable max-len */
var TimelineEventText = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 20h-6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 20h6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 6h6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 9h3"
}));

/* eslint-disable max-len */
var Tool = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
}));

/* eslint-disable max-len */
var Train = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M21 13c0 -3.87 -3.37 -7 -10 -7h-8"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 15h16a2 2 0 0 0 2 -2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 6v5h17.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 10l0 4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 11l0 -5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M13 11l0 -4.5"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 19l18 0"
}));

/* eslint-disable max-len */
var Trash = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 7l16 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M10 11l0 6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14 11l0 6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
}));

/* eslint-disable max-len */
var UserCircle = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"
}));

/* eslint-disable max-len */
var User = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
}));

/* eslint-disable max-len */
var Users = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 3.13a4 4 0 0 1 0 7.75"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M21 21v-2a4 4 0 0 0 -3 -3.85"
}));

/* eslint-disable max-len */
var Vip = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 5h18"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3 19h18"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M4 9l2 6h1l2 -6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 9v6"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 15v-6h2a2 2 0 1 1 0 4h-2"
}));

/* eslint-disable max-len */
var Wifi = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M12 18l.01 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M9.172 15.172a4 4 0 0 1 5.656 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6.343 12.343a8 8 0 0 1 11.314 0"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
}));

/* eslint-disable max-len */
var Writing = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M16 7h4"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
}));

/* eslint-disable max-len */
var X = props => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  strokeWidth: props.strokeWidth,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M18 6l-12 12"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M6 6l12 12"
}));

const lineIcons = {
  AdjustmentsHorizontal: AdjustmentsHorizontal,
  Alarm: Alarm,
  AlarmAverage: AlarmAverage,
  AlertTriangle: AlertTriangle,
  ArmchairLounge: ArmchairLounge,
  ArrowGuide: ArrowGuide,
  ArrowLeft: ArrowLeft,
  ArrowNarrowDown: ArrowNarrowDown,
  ArrowNarrowLeft: ArrowNarrowLeft,
  ArrowNarrowRight: ArrowNarrowRight,
  ArrowNarrowUp: ArrowNarrowUp,
  ArrowRampRight: ArrowRampRight,
  ArrowRight: ArrowRight,
  ArrowUpLeft: ArrowUpLeft,
  ArrowUpRight: ArrowUpRight,
  ArrowUp: ArrowUp,
  AutomaticGearbox: AutomaticGearbox,
  Award: Award,
  Backpack: Backpack,
  Bed: Bed,
  Books: Books,
  BrandSlack: BrandSlack,
  BrandTeams: BrandTeams,
  Briefcase: Briefcase,
  BuildingCommunity: BuildingCommunity,
  BuildingFortress: BuildingFortress,
  BuildingSkyscraper: BuildingSkyscraper,
  Calculator: Calculator,
  CalendarClock: CalendarClock,
  CalendarDollar: CalendarDollar,
  CalendarEvent: CalendarEvent,
  Calendar: Calendar,
  Car: Car,
  CarDoor: CarDoor,
  Cash: Cash,
  CashBanknote: CashBanknote,
  CashBanknoteOff: CashBanknoteOff,
  ChartBar: ChartBar,
  Chat: Chat,
  Check: Check,
  Checkbox: Checkbox,
  ChevronDown: ChevronDown,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  ChevronUp: ChevronUp,
  CircleCheck: CircleCheck,
  CircleDot: CircleDot,
  ClipboardCheck: ClipboardCheck,
  ClipboardText: ClipboardText,
  Clock: Clock,
  ClockCheck: ClockCheck,
  ClockQuestion: ClockQuestion,
  ClockSearch: ClockSearch,
  ClockStar: ClockStar,
  Copy: Copy,
  CopyCheck: CopyCheck,
  CreditCard: CreditCard,
  CreditCardOff: CreditCardOff,
  CurrencyDollar: CurrencyDollar,
  CurrencyDollarOff: CurrencyDollarOff,
  DeviceFloppy: DeviceFloppy,
  DeviceMobileMessage: DeviceMobileMessage,
  DirectionSign: DirectionSign,
  DotsCircleHorizontal: DotsCircleHorizontal,
  DotsHorizontal: DotsHorizontal,
  DotsVertical: DotsVertical,
  Download: Download,
  Edit: Edit,
  ExclamationCircle: ExclamationCircle,
  ExternalLink: ExternalLink,
  FileAnalytics: FileAnalytics,
  FileDollar: FileDollar,
  FileInvoice: FileInvoice,
  FileText: FileText,
  FileTime: FileTime,
  Filter: Filter,
  HamburgerMenu: HamburgerMenu,
  Help: Help,
  HelpSquareRounded: HelpSquareRounded,
  History: History,
  Home: Home,
  Hotel: Hotel,
  HotelService: HotelService,
  Hourglass: Hourglass,
  Id: Id,
  InfoCircle: InfoCircle,
  InputSearch: InputSearch,
  KeyframeHorizontal: KeyframeHorizontal,
  KeyframeVertical: KeyframeVertical,
  LayoutGrid: LayoutGrid,
  Library: Library,
  LineDotted: LineDotted,
  LinkChain: LinkChain,
  List: List,
  ListDetails: ListDetails,
  ListLong: ListLong,
  ListNumbers: ListNumbers,
  ListRows: ListRows,
  Lock: Lock,
  Luggage: Luggage,
  Mail: Mail,
  MapPin: MapPin,
  Map: Map,
  Message: Message,
  MessageCircle: MessageCircle,
  Messages: Messages,
  Minus: Minus,
  Notes: Notes,
  Pencil: Pencil,
  Percentage10: Percentage10,
  Percentage20: Percentage20,
  Percentage25: Percentage25,
  Phone: Phone,
  PiggyBank: PiggyBank,
  PlaneArrival: PlaneArrival,
  PlaneDeparture: PlaneDeparture,
  PlaneInflight: PlaneInflight,
  PlaneSeat: PlaneSeat,
  PlaneTicket: PlaneTicket,
  PlaneTilt: PlaneTilt,
  Plane: Plane,
  Plus: Plus,
  Printer: Printer,
  Quote: Quote,
  Receipt: Receipt,
  Reload: Reload,
  Report: Report,
  ReportAnalytics: ReportAnalytics,
  ReportSearch: ReportSearch,
  Road: Road,
  RouteAlt: RouteAlt,
  Search: Search,
  Settings: Settings,
  Shield: Shield,
  ShieldCheck: ShieldCheck,
  ShieldOff: ShieldOff,
  Snowflake: Snowflake,
  SortAscending: SortAscending,
  SortDescending: SortDescending,
  Square: Square,
  Star: Star,
  Stopwatch: Stopwatch,
  SwitchHorizontal: SwitchHorizontal,
  Tag: Tag,
  Ticket: Ticket,
  TicketOff: TicketOff,
  TimelineEventText: TimelineEventText,
  Tool: Tool,
  Train: Train,
  Trash: Trash,
  UserCircle: UserCircle,
  User: User,
  Users: Users,
  Vip: Vip,
  Wifi: Wifi,
  Writing: Writing,
  X: X
};
function getLineIcon(iconName, strokeWidth) {
  const IconComponent = lineIcons[iconName];
  if (IconComponent === undefined) {
    console.error(`${iconName} is not a supported icon.`);
    return null;
  }
  return /*#__PURE__*/React.createElement(IconComponent, {
    strokeWidth: strokeWidth
  });
}
const getAllIconNames = Object.keys(lineIcons);

const sizeDefs = {
  xxlarge: '48px',
  xlarge: '40px',
  large: '32px',
  medium: '24px',
  small: '16px'
};
const validSizeDefs = Object.keys(sizeDefs);
const getSizeVal = size => {
  if (typeof size === 'number') {
    return `${size}px`;
  }
  if (typeof size === 'string' && validSizeDefs.includes(size)) {
    return sizeDefs[size];
  }
  return size;
};
const IconLineStyled = styled(Box)`
  width: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}};
  height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size;
}};
  font-size: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size;
}};
  color: ${_ref4 => {
  let {
    $color
  } = _ref4;
  return $color;
}};
`;
const IconLine = _ref5 => {
  let {
    icon = '',
    size = 24,
    color = 'inherit',
    strokeWidth,
    ...rest
  } = _ref5;
  let strokeVal = 2;
  if (typeof size === 'string' && (size === 'small' || size === '16px')) {
    strokeVal = 1.5;
  }
  if (typeof size === 'number' && size <= 23) {
    strokeVal = 1.5;
  }
  return /*#__PURE__*/React.createElement(IconLineStyled, _extends({
    size: getSizeVal(size),
    $color: color
  }, rest), getLineIcon(icon, strokeWidth || strokeVal));
};
IconLine.propTypes = {
  icon: PropTypes$1.string,
  /** Size definitions when not using a number or em value: `xxlarge`, `xlarge`, `large`, `medium`, `small` */
  size: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  /** Can accept a color string or kind: `textBody`, `primary`, `secondary`, `info`, `dark`, `link`, `success`, etc. */
  color: PropTypes$1.string,
  /** Default `strokeWidth` is `2`. It is internally set to `1.5` if `size` = `small` or < `23`. Do not change the strokeWidth unless you have been specifically instructed to do so! */
  strokeWidth: PropTypes$1.number
};

export { IconAdd, IconAngleDown, IconAngleLeft, IconAngleRight, IconAngledFlatSeat, IconApple, IconApprove, IconArrowUpLong, IconBell, IconBilling, IconBolt, IconBriefcase, IconBuilding, IconCalendar, IconCalendarLine, IconCamera, IconCar, IconCarDoor, IconCarLine, IconCaretDown, IconCaretUp, IconChainLink, IconChat, IconChatRound, IconChatSquare, IconCheck, IconCheckCircle, IconCheckCircleLine, IconCheckCurved, IconCheckDouble, IconCheckLine, IconChevron, IconCircleX, IconCity, IconClear, IconClock, IconClone, IconClose, IconCog, IconCoronavirus, IconCreditCard, IconCreditCards, IconDownload, IconDragHandle, IconDragNDrop, IconDuplicate, IconEarth, IconEco, IconEdit, IconEditDocument, IconEllipsisHorizCircle, IconEllipsisHorizontal, IconEmail, IconEmailLine, IconEmptyExpTrip, IconEmptyExpense, IconEmptyReceipt, IconExpired, IconEye, IconFile, IconFilter, IconFreeAlcoholicDrinks, IconGearShift, IconGoogle, IconGridView, IconHalfCircle, IconHalfmoon, IconHistory, IconHotel, IconHotelBed, IconHotelLine, IconInfo, IconInfoLine, IconJet, IconKeyboard, IconLieFlatPod, IconLieFlatSeat, IconLieFlatSuite, IconLine, IconLineCar, IconLineHotel, IconListView, IconLiveTV, IconLocation, IconLock, IconLuggage, IconLuggageLine, IconMSTeams, IconMagnifyingGlass, IconMap, IconMarketingBubbles, IconMeal, IconMeeting, IconMerge, IconMiddleSeatFree, IconMinimize, IconMoney, IconMoneySlash, IconNext, IconOpenNew, IconOutlook, IconOutlookOnline, IconPersonalVideo, IconPhone, IconPhoneHandle, IconPlace, IconPlane, IconPlaneAlt, IconPlaneDeparture, IconPlaneLand, IconPlaneLine, IconPlaneTakeOff, IconPlaneTicket, IconPlug, IconPower, IconPrevious, IconPriceTag, IconPrint, IconPrintLine, IconQuoteRight, IconReclinerSeat, IconRefresh, IconRemove, IconResendEmail, IconSearch, IconSearchLine, IconSendArrow, IconSlackApp, IconSmile, IconSnack, IconSort, IconSpeedometer, IconStarSolid, IconStreamingVideo, IconSuitcase, IconSuitcaseLine, IconSuitcases, IconSvgStyled, IconTextSMS, IconThumbsUp, IconTicket, IconTicketLine, IconTotalSpend$1 as IconTotalSpend, IconTrain, IconTrainLine, IconTransfer, IconTrashCan, IconTotalSpend as IconTriangle, IconTrips, IconUSAFlag, IconUSB, IconUser, IconUserCheck, IconUserCircle, IconUserCog, IconViewModify, IconWallet, IconWalletLine, IconWarning, IconWarningCircle, IconWarningCircleSolid, IconWarningTriangle, IconWiFi, IconWiFiFast, IconYahoo, getAllIconNames };
//# sourceMappingURL=index.esm.js.map
